//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as AnalyzesClient from './api-client/AnalyzesClient';

export * as AnalyzesQuery from './api-client/AnalyzesQuery';



export * as ConfigurableMonitoringFormsClient from './api-client/ConfigurableMonitoringFormsClient';

export * as ConfigurableMonitoringFormsQuery from './api-client/ConfigurableMonitoringFormsQuery';



export * as DeviceDataSummaryClient from './api-client/DeviceDataSummaryClient';

export * as DeviceDataSummaryQuery from './api-client/DeviceDataSummaryQuery';



export * as ExportLogClient from './api-client/ExportLogClient';

export * as ExportLogQuery from './api-client/ExportLogQuery';



export * as FaqClient from './api-client/FaqClient';

export * as FaqQuery from './api-client/FaqQuery';



export * as FilesClient from './api-client/FilesClient';

export * as FilesQuery from './api-client/FilesQuery';



export * as FormsClient from './api-client/FormsClient';

export * as FormsQuery from './api-client/FormsQuery';



export * as IssueClient from './api-client/IssueClient';

export * as IssueQuery from './api-client/IssueQuery';



export * as MonitoringFormsClient from './api-client/MonitoringFormsClient';

export * as MonitoringFormsQuery from './api-client/MonitoringFormsQuery';



export * as NotificationClient from './api-client/NotificationClient';

export * as NotificationQuery from './api-client/NotificationQuery';



export * as ParticipantsClient from './api-client/ParticipantsClient';

export * as ParticipantsQuery from './api-client/ParticipantsQuery';



export * as PatientClient from './api-client/PatientClient';

export * as PatientQuery from './api-client/PatientQuery';



export * as PdfClient from './api-client/PdfClient';

export * as PdfQuery from './api-client/PdfQuery';



export * as ProfileClient from './api-client/ProfileClient';

export * as ProfileQuery from './api-client/ProfileQuery';



export * as QuestionSchemeClient from './api-client/QuestionSchemeClient';

export * as QuestionSchemeQuery from './api-client/QuestionSchemeQuery';



export * as SchedulerClient from './api-client/SchedulerClient';

export * as SchedulerQuery from './api-client/SchedulerQuery';



export * as StudyClient from './api-client/StudyClient';

export * as StudyQuery from './api-client/StudyQuery';



export * as StudyNotesClient from './api-client/StudyNotesClient';

export * as StudyNotesQuery from './api-client/StudyNotesQuery';



export * as StudyProgressStatisticClient from './api-client/StudyProgressStatisticClient';

export * as StudyProgressStatisticQuery from './api-client/StudyProgressStatisticQuery';



export * as StudyRoutesClient from './api-client/StudyRoutesClient';

export * as StudyRoutesQuery from './api-client/StudyRoutesQuery';



export * as SurveyClient from './api-client/SurveyClient';

export * as SurveyQuery from './api-client/SurveyQuery';



export * as TestClient from './api-client/TestClient';

export * as TestQuery from './api-client/TestQuery';



export * as UserRolesClient from './api-client/UserRolesClient';

export * as UserRolesQuery from './api-client/UserRolesQuery';



export * as UsersClient from './api-client/UsersClient';

export * as UsersQuery from './api-client/UsersQuery';



export * as VersionClient from './api-client/VersionClient';

export * as VersionQuery from './api-client/VersionQuery';



//-----Types.File-----
export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class AnalysisPresetDto implements IAnalysisPresetDto {
    /** Id of the preset */
    id!: number;
    /** Name of the preset */
    name!: string;
    /** Description of the preset */
    description!: string;
    /** Preset database filename */
    databaseFilename!: string;
    /** Scheme of the analysis preset */
    scheme!: AnalysisPresetScheme[];
    /** Count of the analysis that can be imported
null = unlimited */
    analysisQuantityLimit?: number | null;

    constructor(data?: IAnalysisPresetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.scheme = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.databaseFilename = _data["databaseFilename"];
            if (Array.isArray(_data["scheme"])) {
                this.scheme = [] as any;
                for (let item of _data["scheme"])
                    this.scheme!.push(AnalysisPresetScheme.fromJS(item));
            }
            this.analysisQuantityLimit = _data["analysisQuantityLimit"];
        }
    }

    static fromJS(data: any): AnalysisPresetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPresetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["databaseFilename"] = this.databaseFilename;
        if (Array.isArray(this.scheme)) {
            data["scheme"] = [];
            for (let item of this.scheme)
                data["scheme"].push(item.toJSON());
        }
        data["analysisQuantityLimit"] = this.analysisQuantityLimit;
        return data;
    }
}

export interface IAnalysisPresetDto {
    /** Id of the preset */
    id: number;
    /** Name of the preset */
    name: string;
    /** Description of the preset */
    description: string;
    /** Preset database filename */
    databaseFilename: string;
    /** Scheme of the analysis preset */
    scheme: AnalysisPresetScheme[];
    /** Count of the analysis that can be imported
null = unlimited */
    analysisQuantityLimit?: number | null;
}

export class AnalysisPresetScheme implements IAnalysisPresetScheme {
    tableName!: string;
    keyColumnsWithValue!: { [key: string]: string; };
    dataColumns!: string[];

    constructor(data?: IAnalysisPresetScheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.keyColumnsWithValue = {};
            this.dataColumns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"];
            if (_data["keyColumnsWithValue"]) {
                this.keyColumnsWithValue = {} as any;
                for (let key in _data["keyColumnsWithValue"]) {
                    if (_data["keyColumnsWithValue"].hasOwnProperty(key))
                        (<any>this.keyColumnsWithValue)![key] = _data["keyColumnsWithValue"][key];
                }
            }
            if (Array.isArray(_data["dataColumns"])) {
                this.dataColumns = [] as any;
                for (let item of _data["dataColumns"])
                    this.dataColumns!.push(item);
            }
        }
    }

    static fromJS(data: any): AnalysisPresetScheme {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPresetScheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        if (this.keyColumnsWithValue) {
            data["keyColumnsWithValue"] = {};
            for (let key in this.keyColumnsWithValue) {
                if (this.keyColumnsWithValue.hasOwnProperty(key))
                    (<any>data["keyColumnsWithValue"])[key] = (<any>this.keyColumnsWithValue)[key];
            }
        }
        if (Array.isArray(this.dataColumns)) {
            data["dataColumns"] = [];
            for (let item of this.dataColumns)
                data["dataColumns"].push(item);
        }
        return data;
    }
}

export interface IAnalysisPresetScheme {
    tableName: string;
    keyColumnsWithValue: { [key: string]: string; };
    dataColumns: string[];
}

export class AnalysisPresetCreationDto implements IAnalysisPresetCreationDto {
    /** Id of the study */
    studyId!: number;
    /** Name of the preset */
    name!: string;
    /** Description of the preset */
    description?: string | null;
    /** Preset database filename */
    databaseFilename!: string;
    /** Scheme of the analysis preset */
    scheme!: AnalysisPresetScheme[];
    /** Count of the analysis that can be imported
null = unlimited */
    analysisQuantityLimit?: number | null;

    constructor(data?: IAnalysisPresetCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.scheme = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.databaseFilename = _data["databaseFilename"];
            if (Array.isArray(_data["scheme"])) {
                this.scheme = [] as any;
                for (let item of _data["scheme"])
                    this.scheme!.push(AnalysisPresetScheme.fromJS(item));
            }
            this.analysisQuantityLimit = _data["analysisQuantityLimit"];
        }
    }

    static fromJS(data: any): AnalysisPresetCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPresetCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["databaseFilename"] = this.databaseFilename;
        if (Array.isArray(this.scheme)) {
            data["scheme"] = [];
            for (let item of this.scheme)
                data["scheme"].push(item.toJSON());
        }
        data["analysisQuantityLimit"] = this.analysisQuantityLimit;
        return data;
    }
}

export interface IAnalysisPresetCreationDto {
    /** Id of the study */
    studyId: number;
    /** Name of the preset */
    name: string;
    /** Description of the preset */
    description?: string | null;
    /** Preset database filename */
    databaseFilename: string;
    /** Scheme of the analysis preset */
    scheme: AnalysisPresetScheme[];
    /** Count of the analysis that can be imported
null = unlimited */
    analysisQuantityLimit?: number | null;
}

export class AnalysisPresetUpdateDto implements IAnalysisPresetUpdateDto {
    /** Name of the preset */
    name!: string;
    /** Description of the preset */
    description!: string | null;
    /** Preset database filename */
    databaseFilename!: string;
    /** Scheme of the analysis preset */
    scheme?: AnalysisPresetScheme[] | null;
    /** Count of the analysis that can be imported
null = unlimited */
    analysisQuantityLimit!: number | null;

    constructor(data?: IAnalysisPresetUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.databaseFilename = _data["databaseFilename"];
            if (Array.isArray(_data["scheme"])) {
                this.scheme = [] as any;
                for (let item of _data["scheme"])
                    this.scheme!.push(AnalysisPresetScheme.fromJS(item));
            }
            this.analysisQuantityLimit = _data["analysisQuantityLimit"];
        }
    }

    static fromJS(data: any): AnalysisPresetUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPresetUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["databaseFilename"] = this.databaseFilename;
        if (Array.isArray(this.scheme)) {
            data["scheme"] = [];
            for (let item of this.scheme)
                data["scheme"].push(item.toJSON());
        }
        data["analysisQuantityLimit"] = this.analysisQuantityLimit;
        return data;
    }
}

export interface IAnalysisPresetUpdateDto {
    /** Name of the preset */
    name: string;
    /** Description of the preset */
    description: string | null;
    /** Preset database filename */
    databaseFilename: string;
    /** Scheme of the analysis preset */
    scheme?: AnalysisPresetScheme[] | null;
    /** Count of the analysis that can be imported
null = unlimited */
    analysisQuantityLimit: number | null;
}

export class AnalysisDto implements IAnalysisDto {
    /** Id of the analysis */
    id!: number;
    /** Name of analysis */
    presetId!: number;
    /** Date of creation */
    createdAt!: Date;
    /** Full name of the uploaded user */
    createdBy!: string;
    /** Analysis content */
    data!: { [key: string]: any; };

    constructor(data?: IAnalysisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.presetId = _data["presetId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.createdBy = _data["createdBy"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): AnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["presetId"] = this.presetId;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["createdBy"] = this.createdBy;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IAnalysisDto {
    /** Id of the analysis */
    id: number;
    /** Name of analysis */
    presetId: number;
    /** Date of creation */
    createdAt: Date;
    /** Full name of the uploaded user */
    createdBy: string;
    /** Analysis content */
    data: { [key: string]: any; };
}

export class AnalysisCreationDto implements IAnalysisCreationDto {
    /** Id of the preset */
    presetId!: number;
    /** Analysis content */
    data!: { [key: string]: any; };

    constructor(data?: IAnalysisCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presetId = _data["presetId"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): AnalysisCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presetId"] = this.presetId;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IAnalysisCreationDto {
    /** Id of the preset */
    presetId: number;
    /** Analysis content */
    data: { [key: string]: any; };
}

export class MonitoringFormConfigDto implements IMonitoringFormConfigDto {
    /** Id of the form config */
    id!: number;
    /** Title of the form config */
    title!: string;
    /** Date when form was created and saved in the DB. */
    createdAt!: Date;
    /** Date when form was modified or filled. */
    updatedAt!: Date | null;
    /** Schema of form layout (markup) */
    layout!: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;

    constructor(data?: IMonitoringFormConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layout = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
            if (Array.isArray(_data["scoreSections"])) {
                this.scoreSections = [] as any;
                for (let item of _data["scoreSections"])
                    this.scoreSections!.push(BaseScoreSection.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(BaseVariableSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonitoringFormConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        if (Array.isArray(this.scoreSections)) {
            data["scoreSections"] = [];
            for (let item of this.scoreSections)
                data["scoreSections"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonitoringFormConfigDto {
    /** Id of the form config */
    id: number;
    /** Title of the form config */
    title: string;
    /** Date when form was created and saved in the DB. */
    createdAt: Date;
    /** Date when form was modified or filled. */
    updatedAt: Date | null;
    /** Schema of form layout (markup) */
    layout: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;
}

export class BaseScoreSection implements IBaseScoreSection {
    name!: string;
    units!: string | null;
    decimal!: number | null;
    expression!: string;
    isGeneralScore!: boolean | null;

    constructor(data?: IBaseScoreSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.units = _data["units"];
            this.decimal = _data["decimal"];
            this.expression = _data["expression"];
            this.isGeneralScore = _data["isGeneralScore"];
        }
    }

    static fromJS(data: any): BaseScoreSection {
        data = typeof data === 'object' ? data : {};
        let result = new BaseScoreSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["units"] = this.units;
        data["decimal"] = this.decimal;
        data["expression"] = this.expression;
        data["isGeneralScore"] = this.isGeneralScore;
        return data;
    }
}

export interface IBaseScoreSection {
    name: string;
    units: string | null;
    decimal: number | null;
    expression: string;
    isGeneralScore: boolean | null;
}

export class BaseVariableSection implements IBaseVariableSection {
    name!: string;
    expression!: string;

    constructor(data?: IBaseVariableSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expression = _data["expression"];
        }
    }

    static fromJS(data: any): BaseVariableSection {
        data = typeof data === 'object' ? data : {};
        let result = new BaseVariableSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expression"] = this.expression;
        return data;
    }
}

export interface IBaseVariableSection {
    name: string;
    expression: string;
}

export class MonitoringFormConfigCreationDto implements IMonitoringFormConfigCreationDto {
    /** Title of the form config */
    title!: string;
    /** Schema of form layout (markup) */
    layout!: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;

    constructor(data?: IMonitoringFormConfigCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layout = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
            if (Array.isArray(_data["scoreSections"])) {
                this.scoreSections = [] as any;
                for (let item of _data["scoreSections"])
                    this.scoreSections!.push(BaseScoreSection.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(BaseVariableSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonitoringFormConfigCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormConfigCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        if (Array.isArray(this.scoreSections)) {
            data["scoreSections"] = [];
            for (let item of this.scoreSections)
                data["scoreSections"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonitoringFormConfigCreationDto {
    /** Title of the form config */
    title: string;
    /** Schema of form layout (markup) */
    layout: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;
}

export class MonitoringFormConfigPatchingDto implements IMonitoringFormConfigPatchingDto {
    /** Title of the form config */
    title?: string | null;
    /** Schema of form layout (markup) */
    layout?: { [key: string]: any; } | null;
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    variables?: BaseVariableSection[] | null;

    constructor(data?: IMonitoringFormConfigPatchingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
            if (Array.isArray(_data["scoreSections"])) {
                this.scoreSections = [] as any;
                for (let item of _data["scoreSections"])
                    this.scoreSections!.push(BaseScoreSection.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(BaseVariableSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonitoringFormConfigPatchingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormConfigPatchingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        if (Array.isArray(this.scoreSections)) {
            data["scoreSections"] = [];
            for (let item of this.scoreSections)
                data["scoreSections"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonitoringFormConfigPatchingDto {
    /** Title of the form config */
    title?: string | null;
    /** Schema of form layout (markup) */
    layout?: { [key: string]: any; } | null;
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    variables?: BaseVariableSection[] | null;
}

export class MonitoringFormResultDto implements IMonitoringFormResultDto {
    /** The version number of form result */
    version!: ResultVersionNumber;
    /** Id of the form result which result version belongs to */
    formResultId!: number;
    /** Id of the form config which result */
    formConfigId!: number;
    /** Value of form result for the version */
    value!: { [key: string]: any; } | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; } | null;
    scoreResults!: ScoreResult[] | null;
    /** The reasons why field was changed. */
    fieldEditReasons!: { [key: string]: FieldEditReasonWithStaff; } | null;
    /** Filling progress */
    fillingProgress!: FillingProgress | null;
    /** Who create Value of this version */
    createdBy!: DoctorDto;
    /** When the version was created */
    createdAt!: Date;
    /** Who update Value of this version the last time */
    updatedBy!: DoctorDto;
    /** When the version was updated */
    updatedAt!: Date;

    constructor(data?: IMonitoringFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new ResultVersionNumber();
            this.createdBy = new DoctorDto();
            this.updatedBy = new DoctorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? ResultVersionNumber.fromJS(_data["version"]) : new ResultVersionNumber();
            this.formResultId = _data["formResultId"];
            this.formConfigId = _data["formConfigId"];
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            if (Array.isArray(_data["scoreResults"])) {
                this.scoreResults = [] as any;
                for (let item of _data["scoreResults"])
                    this.scoreResults!.push(ScoreResult.fromJS(item));
            }
            if (_data["fieldEditReasons"]) {
                this.fieldEditReasons = {} as any;
                for (let key in _data["fieldEditReasons"]) {
                    if (_data["fieldEditReasons"].hasOwnProperty(key))
                        (<any>this.fieldEditReasons)![key] = _data["fieldEditReasons"][key] ? FieldEditReasonWithStaff.fromJS(_data["fieldEditReasons"][key]) : new FieldEditReasonWithStaff();
                }
            }
            this.fillingProgress = _data["fillingProgress"] ? FillingProgress.fromJS(_data["fillingProgress"]) : <any>null;
            this.createdBy = _data["createdBy"] ? DoctorDto.fromJS(_data["createdBy"]) : new DoctorDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedBy = _data["updatedBy"] ? DoctorDto.fromJS(_data["updatedBy"]) : new DoctorDto();
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): MonitoringFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>null;
        data["formResultId"] = this.formResultId;
        data["formConfigId"] = this.formConfigId;
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        if (Array.isArray(this.scoreResults)) {
            data["scoreResults"] = [];
            for (let item of this.scoreResults)
                data["scoreResults"].push(item.toJSON());
        }
        if (this.fieldEditReasons) {
            data["fieldEditReasons"] = {};
            for (let key in this.fieldEditReasons) {
                if (this.fieldEditReasons.hasOwnProperty(key))
                    (<any>data["fieldEditReasons"])[key] = this.fieldEditReasons[key] ? this.fieldEditReasons[key].toJSON() : <any>null;
            }
        }
        data["fillingProgress"] = this.fillingProgress ? this.fillingProgress.toJSON() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        return data;
    }
}

export interface IMonitoringFormResultDto {
    /** The version number of form result */
    version: ResultVersionNumber;
    /** Id of the form result which result version belongs to */
    formResultId: number;
    /** Id of the form config which result */
    formConfigId: number;
    /** Value of form result for the version */
    value: { [key: string]: any; } | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; } | null;
    scoreResults: ScoreResult[] | null;
    /** The reasons why field was changed. */
    fieldEditReasons: { [key: string]: FieldEditReasonWithStaff; } | null;
    /** Filling progress */
    fillingProgress: FillingProgress | null;
    /** Who create Value of this version */
    createdBy: DoctorDto;
    /** When the version was created */
    createdAt: Date;
    /** Who update Value of this version the last time */
    updatedBy: DoctorDto;
    /** When the version was updated */
    updatedAt: Date;
}

export class ResultVersionNumber implements IResultVersionNumber {
    majorVersion!: number;
    minorVersion!: number;

    constructor(data?: IResultVersionNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
        }
    }

    static fromJS(data: any): ResultVersionNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ResultVersionNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        return data;
    }
}

export interface IResultVersionNumber {
    majorVersion: number;
    minorVersion: number;
}

/** 0 = NotApplicable 1 = MissedValue 2 = Unknown 3 = NoReason */
export enum FieldSkipReason {
    NotApplicable = 0,
    MissedValue = 1,
    Unknown = 2,
    NoReason = 3,
}

export class ScoreResult implements IScoreResult {
    name!: string;
    value!: number | null;

    constructor(data?: IScoreResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ScoreResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IScoreResult {
    name: string;
    value: number | null;
}

export class FieldEditReasonWithStaff implements IFieldEditReasonWithStaff {
    editedAt!: Date;
    editedById!: string;
    editReason!: FieldEditReasonEnum;
    editReasonText!: string | null;

    constructor(data?: IFieldEditReasonWithStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editedAt = _data["editedAt"] ? new Date(_data["editedAt"].toString()) : <any>null;
            this.editedById = _data["editedById"];
            this.editReason = _data["editReason"];
            this.editReasonText = _data["editReasonText"];
        }
    }

    static fromJS(data: any): FieldEditReasonWithStaff {
        data = typeof data === 'object' ? data : {};
        let result = new FieldEditReasonWithStaff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editedAt"] = this.editedAt && this.editedAt.toISOString();
        data["editedById"] = this.editedById;
        data["editReason"] = this.editReason;
        data["editReasonText"] = this.editReasonText;
        return data;
    }
}

export interface IFieldEditReasonWithStaff {
    editedAt: Date;
    editedById: string;
    editReason: FieldEditReasonEnum;
    editReasonText: string | null;
}

/** 1 = WrongEntry 2 = Update */
export enum FieldEditReasonEnum {
    WrongEntry = 1,
    Update = 2,
}

export class FillingProgress implements IFillingProgress {
    filled!: number;
    total!: number;

    constructor(data?: IFillingProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filled = _data["filled"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): FillingProgress {
        data = typeof data === 'object' ? data : {};
        let result = new FillingProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filled"] = this.filled;
        data["total"] = this.total;
        return data;
    }
}

export interface IFillingProgress {
    filled: number;
    total: number;
}

export class DoctorDto implements IDoctorDto {
    /** Doctor id. */
    id!: string;
    /** Doctor's full name. */
    fullName!: string;
    /** Doctor's email. */
    email!: string | null;

    constructor(data?: IDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): DoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IDoctorDto {
    /** Doctor id. */
    id: string;
    /** Doctor's full name. */
    fullName: string;
    /** Doctor's email. */
    email: string | null;
}

export class ShortMonitoringFormResultDto implements IShortMonitoringFormResultDto {
    /** The version number of form result */
    version!: ResultVersionNumber;
    /** Id of the form result which result version belongs to */
    formResultId!: number;
    /** Id of the form config which result */
    formConfigId!: number;
    /** Id of the form config which result */
    formConfigTitle!: string;
    /** Who create this version */
    createdBy!: DoctorDto;
    /** When the version was created */
    createdAt!: Date;
    /** Who update this version the last time */
    updatedBy!: DoctorDto;
    /** When the version was updated */
    updatedAt!: Date;

    constructor(data?: IShortMonitoringFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new ResultVersionNumber();
            this.createdBy = new DoctorDto();
            this.updatedBy = new DoctorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? ResultVersionNumber.fromJS(_data["version"]) : new ResultVersionNumber();
            this.formResultId = _data["formResultId"];
            this.formConfigId = _data["formConfigId"];
            this.formConfigTitle = _data["formConfigTitle"];
            this.createdBy = _data["createdBy"] ? DoctorDto.fromJS(_data["createdBy"]) : new DoctorDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedBy = _data["updatedBy"] ? DoctorDto.fromJS(_data["updatedBy"]) : new DoctorDto();
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ShortMonitoringFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShortMonitoringFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>null;
        data["formResultId"] = this.formResultId;
        data["formConfigId"] = this.formConfigId;
        data["formConfigTitle"] = this.formConfigTitle;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        return data;
    }
}

export interface IShortMonitoringFormResultDto {
    /** The version number of form result */
    version: ResultVersionNumber;
    /** Id of the form result which result version belongs to */
    formResultId: number;
    /** Id of the form config which result */
    formConfigId: number;
    /** Id of the form config which result */
    formConfigTitle: string;
    /** Who create this version */
    createdBy: DoctorDto;
    /** When the version was created */
    createdAt: Date;
    /** Who update this version the last time */
    updatedBy: DoctorDto;
    /** When the version was updated */
    updatedAt: Date;
}

export class MonitoringFormProcessingDto implements IMonitoringFormProcessingDto {
    /** Value of form result for the version */
    value!: { [key: string]: any; };
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; } | null;
    scoreResults!: ScoreResult[] | null;
    /** Version type that you want to create. It can be major  e.g. v.1.0 or minor v.0.1
VersionType.Major by default */
    versionType!: VersionType | null;
    /** File Ids to commit */
    fileIdsToCommit!: string[];

    constructor(data?: IMonitoringFormProcessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = {};
            this.fileIdsToCommit = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            if (Array.isArray(_data["scoreResults"])) {
                this.scoreResults = [] as any;
                for (let item of _data["scoreResults"])
                    this.scoreResults!.push(ScoreResult.fromJS(item));
            }
            this.versionType = _data["versionType"];
            if (Array.isArray(_data["fileIdsToCommit"])) {
                this.fileIdsToCommit = [] as any;
                for (let item of _data["fileIdsToCommit"])
                    this.fileIdsToCommit!.push(item);
            }
        }
    }

    static fromJS(data: any): MonitoringFormProcessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormProcessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        if (Array.isArray(this.scoreResults)) {
            data["scoreResults"] = [];
            for (let item of this.scoreResults)
                data["scoreResults"].push(item.toJSON());
        }
        data["versionType"] = this.versionType;
        if (Array.isArray(this.fileIdsToCommit)) {
            data["fileIdsToCommit"] = [];
            for (let item of this.fileIdsToCommit)
                data["fileIdsToCommit"].push(item);
        }
        return data;
    }
}

export interface IMonitoringFormProcessingDto {
    /** Value of form result for the version */
    value: { [key: string]: any; };
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; } | null;
    scoreResults: ScoreResult[] | null;
    /** Version type that you want to create. It can be major  e.g. v.1.0 or minor v.0.1
VersionType.Major by default */
    versionType: VersionType | null;
    /** File Ids to commit */
    fileIdsToCommit: string[];
}

/** 0 = Minor 1 = Major */
export enum VersionType {
    Minor = 0,
    Major = 1,
}

export class SummaryDto implements ISummaryDto {
    /** Patient id */
    patientId!: string;
    /** The array od summary data */
    data!: AggregatedValue[];
    /** Device bindings for patient */
    deviceBindings!: DeviceBindingDto[];

    constructor(data?: ISummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.deviceBindings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AggregatedValue.fromJS(item));
            }
            if (Array.isArray(_data["deviceBindings"])) {
                this.deviceBindings = [] as any;
                for (let item of _data["deviceBindings"])
                    this.deviceBindings!.push(DeviceBindingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.deviceBindings)) {
            data["deviceBindings"] = [];
            for (let item of this.deviceBindings)
                data["deviceBindings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISummaryDto {
    /** Patient id */
    patientId: string;
    /** The array od summary data */
    data: AggregatedValue[];
    /** Device bindings for patient */
    deviceBindings: DeviceBindingDto[];
}

export class AggregatedValue implements IAggregatedValue {
    from!: Date;
    until!: Date;
    value!: number | null;
    qualityMetric!: QualityMetric;

    constructor(data?: IAggregatedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? parseDateOnly(_data["from"].toString()) : <any>null;
            this.until = _data["until"] ? parseDateOnly(_data["until"].toString()) : <any>null;
            this.value = _data["value"];
            this.qualityMetric = _data["qualityMetric"];
        }
    }

    static fromJS(data: any): AggregatedValue {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from && formatDate(this.from);
        data["until"] = this.until && formatDate(this.until);
        data["value"] = this.value;
        data["qualityMetric"] = this.qualityMetric;
        return data;
    }
}

export interface IAggregatedValue {
    from: Date;
    until: Date;
    value: number | null;
    qualityMetric: QualityMetric;
}

/** 0 = Empty 1 = Awful 2 = Bad 3 = Normal 4 = Good 5 = Awesome 999 = NotCalculated */
export enum QualityMetric {
    Empty = 0,
    Awful = 1,
    Bad = 2,
    Normal = 3,
    Good = 4,
    Awesome = 5,
    NotCalculated = 999,
}

export class DeviceBindingDto implements IDeviceBindingDto {
    /** Device serial number */
    deviceSerialNumber!: string;
    /** Assigned at */
    assignedAt!: Date;
    /** Unassigned at */
    unassignedAt!: Date | null;

    constructor(data?: IDeviceBindingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.assignedAt = _data["assignedAt"] ? new Date(_data["assignedAt"].toString()) : <any>null;
            this.unassignedAt = _data["unassignedAt"] ? new Date(_data["unassignedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DeviceBindingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBindingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["assignedAt"] = this.assignedAt && this.assignedAt.toISOString();
        data["unassignedAt"] = this.unassignedAt && this.unassignedAt.toISOString();
        return data;
    }
}

export interface IDeviceBindingDto {
    /** Device serial number */
    deviceSerialNumber: string;
    /** Assigned at */
    assignedAt: Date;
    /** Unassigned at */
    unassignedAt: Date | null;
}

/** 0 = Daily 1 = Monthly */
export enum AggregationPeriodEnum {
    Daily = 0,
    Monthly = 1,
}

/** 0 = Compliance */
export enum SummaryCalculatorEnum {
    Compliance = 0,
}

/** 0 = Draft 1 = Submitted 2 = Approved 3 = ApproveRecalled */
export enum FormLifecycleState {
    Draft = 0,
    Submitted = 1,
    Approved = 2,
    ApproveRecalled = 3,
}

export class StatisticTypesDto implements IStatisticTypesDto {
    /** Types of surveys that can be exported */
    surveyTypes!: string[];
    /** Types of forms that can be exported */
    formTypes!: string[];

    constructor(data?: IStatisticTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyTypes = [];
            this.formTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyTypes"])) {
                this.surveyTypes = [] as any;
                for (let item of _data["surveyTypes"])
                    this.surveyTypes!.push(item);
            }
            if (Array.isArray(_data["formTypes"])) {
                this.formTypes = [] as any;
                for (let item of _data["formTypes"])
                    this.formTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): StatisticTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyTypes)) {
            data["surveyTypes"] = [];
            for (let item of this.surveyTypes)
                data["surveyTypes"].push(item);
        }
        if (Array.isArray(this.formTypes)) {
            data["formTypes"] = [];
            for (let item of this.formTypes)
                data["formTypes"].push(item);
        }
        return data;
    }
}

export interface IStatisticTypesDto {
    /** Types of surveys that can be exported */
    surveyTypes: string[];
    /** Types of forms that can be exported */
    formTypes: string[];
}

export class FaqDto implements IFaqDto {
    /** Id of the FAQ */
    id!: number;
    /** Schema of FAQ layout */
    layout!: { [key: string]: any; } | null;

    constructor(data?: IFaqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
        }
    }

    static fromJS(data: any): FaqDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        return data;
    }
}

export interface IFaqDto {
    /** Id of the FAQ */
    id: number;
    /** Schema of FAQ layout */
    layout: { [key: string]: any; } | null;
}

export class FormDto implements IFormDto {
    /** Id of the form */
    id!: number;
    /** Id of the related Study. */
    studyId!: number;
    /** Date when form was created and saved in the DB. */
    createdAt!: Date;
    /** Date when form was modified or filled. */
    updatedAt!: Date;
    /** Schema of form layout (markup) */
    layoutSchema!: { [key: string]: any; };
    /** Form legend */
    legend!: string[] | null;
    /** Type of form */
    type!: string;
    /** Indicates that form can be created several times. */
    isMultiInstance!: boolean;
    /** Flag allows fill the form for "Not started" patients.
Only used with IsMultiInstance set to true */
    allowedForNotStartedPatients!: boolean;
    /** Flag indicating that the form is creating a patient */
    isPatientCreationForm!: boolean;
    /** Can the form be skipped? */
    canBeSkipped!: boolean;
    /** Collection of the section groups. Section group is a group of sections that are displayed together on the form overview. It has a title and a list of sections that belong to the group. */
    scoreSectionConfig!: ScoreSectionConfig | null;

    constructor(data?: IFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layoutSchema = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            if (_data["layoutSchema"]) {
                this.layoutSchema = {} as any;
                for (let key in _data["layoutSchema"]) {
                    if (_data["layoutSchema"].hasOwnProperty(key))
                        (<any>this.layoutSchema)![key] = _data["layoutSchema"][key];
                }
            }
            if (Array.isArray(_data["legend"])) {
                this.legend = [] as any;
                for (let item of _data["legend"])
                    this.legend!.push(item);
            }
            this.type = _data["type"];
            this.isMultiInstance = _data["isMultiInstance"];
            this.allowedForNotStartedPatients = _data["allowedForNotStartedPatients"];
            this.isPatientCreationForm = _data["isPatientCreationForm"];
            this.canBeSkipped = _data["canBeSkipped"];
            this.scoreSectionConfig = _data["scoreSectionConfig"] ? ScoreSectionConfig.fromJS(_data["scoreSectionConfig"]) : <any>null;
        }
    }

    static fromJS(data: any): FormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        if (this.layoutSchema) {
            data["layoutSchema"] = {};
            for (let key in this.layoutSchema) {
                if (this.layoutSchema.hasOwnProperty(key))
                    (<any>data["layoutSchema"])[key] = (<any>this.layoutSchema)[key];
            }
        }
        if (Array.isArray(this.legend)) {
            data["legend"] = [];
            for (let item of this.legend)
                data["legend"].push(item);
        }
        data["type"] = this.type;
        data["isMultiInstance"] = this.isMultiInstance;
        data["allowedForNotStartedPatients"] = this.allowedForNotStartedPatients;
        data["isPatientCreationForm"] = this.isPatientCreationForm;
        data["canBeSkipped"] = this.canBeSkipped;
        data["scoreSectionConfig"] = this.scoreSectionConfig ? this.scoreSectionConfig.toJSON() : <any>null;
        return data;
    }
}

export interface IFormDto {
    /** Id of the form */
    id: number;
    /** Id of the related Study. */
    studyId: number;
    /** Date when form was created and saved in the DB. */
    createdAt: Date;
    /** Date when form was modified or filled. */
    updatedAt: Date;
    /** Schema of form layout (markup) */
    layoutSchema: { [key: string]: any; };
    /** Form legend */
    legend: string[] | null;
    /** Type of form */
    type: string;
    /** Indicates that form can be created several times. */
    isMultiInstance: boolean;
    /** Flag allows fill the form for "Not started" patients.
Only used with IsMultiInstance set to true */
    allowedForNotStartedPatients: boolean;
    /** Flag indicating that the form is creating a patient */
    isPatientCreationForm: boolean;
    /** Can the form be skipped? */
    canBeSkipped: boolean;
    /** Collection of the section groups. Section group is a group of sections that are displayed together on the form overview. It has a title and a list of sections that belong to the group. */
    scoreSectionConfig: ScoreSectionConfig | null;
}

export class ScoreSectionConfig implements IScoreSectionConfig {
    layout!: ScoreSectionLayout;
    scoreSectionGroups!: SectionGroup[] | null;

    constructor(data?: IScoreSectionConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layout = _data["layout"];
            if (Array.isArray(_data["scoreSectionGroups"])) {
                this.scoreSectionGroups = [] as any;
                for (let item of _data["scoreSectionGroups"])
                    this.scoreSectionGroups!.push(SectionGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScoreSectionConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreSectionConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout;
        if (Array.isArray(this.scoreSectionGroups)) {
            data["scoreSectionGroups"] = [];
            for (let item of this.scoreSectionGroups)
                data["scoreSectionGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScoreSectionConfig {
    layout: ScoreSectionLayout;
    scoreSectionGroups: SectionGroup[] | null;
}

/** 0 = Horizontal 1 = Vertical */
export enum ScoreSectionLayout {
    Horizontal = 0,
    Vertical = 1,
}

export class SectionGroup implements ISectionGroup {
    title!: string | null;
    tooltip!: string | null;
    sections!: ScoreGroupEnum[];

    constructor(data?: ISectionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.tooltip = _data["tooltip"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(item);
            }
        }
    }

    static fromJS(data: any): SectionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SectionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["tooltip"] = this.tooltip;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item);
        }
        return data;
    }
}

export interface ISectionGroup {
    title: string | null;
    tooltip: string | null;
    sections: ScoreGroupEnum[];
}

/** 1 = Symptoms 2 = Activity 3 = Impact 4 = HealthState 5 = EqVas 6 = PsqiQ1 7 = PsqiQ2 8 = PsqiQ3 9 = PsqiQ4 10 = PsqiQ5a 11 = PsqiQ5bj 12 = PsqiQ6 13 = PsqiQ7 14 = PsqiQ8 15 = PsqiQ9 16 = SleepQuality 17 = SleepLatency 18 = SleepDuration 19 = SleepEfficiency 20 = SleepDisturbances 21 = UseOfMedication 22 = Dysfunction 101 = HealthState1 102 = HealthState2 103 = HealthState3 104 = HealthState4 105 = HealthState5 150 = FbTherapiequalität 151 = FbMasken 152 = TechIssues 160 = SRI_RC 161 = SRI_PF 162 = SRI_ASaS 163 = SRI_SR 164 = SRI_ANX 165 = SRI_PWB 166 = SRI_SF 170 = FB2_5 171 = FB2_6 172 = FB2_6_1 173 = FB2_7 174 = FB2_7_1 175 = FB2_9_20 176 = FB2_18 177 = FB2_14_19_1 178 = FB2_14_19_2 179 = FB2_6_2 180 = FB2_7_2 999 = TotalScore 1000 = MeanScore 1001 = MedianScore 1002 = StandardDeviationScore 1003 = InterquatileScore 1010 = JuliaAcMeanScore 1011 = JuliaAcMedianScore 1012 = JuliaAcStandardDeviationScore 1013 = JuliaAcInterquatileScore 1020 = JuliaMaskMeanScore 1021 = JuliaMaskMedianScore 1022 = JuliaMaskStandardDeviationScore 1023 = JuliaMaskInterquatileScore */
export enum ScoreGroupEnum {
    Symptoms = 1,
    Activity = 2,
    Impact = 3,
    HealthState = 4,
    EqVas = 5,
    PsqiQ1 = 6,
    PsqiQ2 = 7,
    PsqiQ3 = 8,
    PsqiQ4 = 9,
    PsqiQ5a = 10,
    PsqiQ5bj = 11,
    PsqiQ6 = 12,
    PsqiQ7 = 13,
    PsqiQ8 = 14,
    PsqiQ9 = 15,
    SleepQuality = 16,
    SleepLatency = 17,
    SleepDuration = 18,
    SleepEfficiency = 19,
    SleepDisturbances = 20,
    UseOfMedication = 21,
    Dysfunction = 22,
    HealthState1 = 101,
    HealthState2 = 102,
    HealthState3 = 103,
    HealthState4 = 104,
    HealthState5 = 105,
    FbTherapiequalität = 150,
    FbMasken = 151,
    TechIssues = 152,
    SRI_RC = 160,
    SRI_PF = 161,
    SRI_ASaS = 162,
    SRI_SR = 163,
    SRI_ANX = 164,
    SRI_PWB = 165,
    SRI_SF = 166,
    FB2_5 = 170,
    FB2_6 = 171,
    FB2_6_1 = 172,
    FB2_7 = 173,
    FB2_7_1 = 174,
    FB2_9_20 = 175,
    FB2_18 = 176,
    FB2_14_19_1 = 177,
    FB2_14_19_2 = 178,
    FB2_6_2 = 179,
    FB2_7_2 = 180,
    TotalScore = 999,
    MeanScore = 1000,
    MedianScore = 1001,
    StandardDeviationScore = 1002,
    InterquatileScore = 1003,
    JuliaAcMeanScore = 1010,
    JuliaAcMedianScore = 1011,
    JuliaAcStandardDeviationScore = 1012,
    JuliaAcInterquatileScore = 1013,
    JuliaMaskMeanScore = 1020,
    JuliaMaskMedianScore = 1021,
    JuliaMaskStandardDeviationScore = 1022,
    JuliaMaskInterquatileScore = 1023,
}

export class FormHistoryDto implements IFormHistoryDto {
    /** Changes of all form versions (actions (e.g. submit, recall, etc...) are separated) */
    formChanges!: FormChangesDto[];

    constructor(data?: IFormHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formChanges = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formChanges"])) {
                this.formChanges = [] as any;
                for (let item of _data["formChanges"])
                    this.formChanges!.push(FormChangesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formChanges)) {
            data["formChanges"] = [];
            for (let item of this.formChanges)
                data["formChanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormHistoryDto {
    /** Changes of all form versions (actions (e.g. submit, recall, etc...) are separated) */
    formChanges: FormChangesDto[];
}

export class FormChangesDto implements IFormChangesDto {
    /** Id of form history element */
    id!: string;
    /** Major form version */
    versionNumber!: number;
    value!: { [key: string]: any; } | null;
    /** Minor form version */
    minorVersionNumber!: number;
    /** Who updated this version */
    updatedBy!: DoctorDto | null;
    /** Type of changes (e.g submit, approve, change fields, etc...) */
    formChangingActionType!: FormChangingActionType;
    /** When the value of this version was updated last time. */
    updatedAt!: Date;
    /** When this version was submitted for approval */
    submittedAt!: Date | null;
    /** Who submitted this version for approval */
    submittedBy!: DoctorDto | null;
    /** When submission of this version was revoked */
    submissionRevokedAt!: Date | null;
    /** Who revoked submission this version */
    submissionRevokedBy!: DoctorDto | null;
    /** When this version was approved */
    approvedAt!: Date | null;
    /** Who approved this version */
    approvedBy!: DoctorDto | null;
    /** When the approval was recalled */
    approvalIsRecalledAt!: Date | null;
    /** Who recalled the approval */
    approvalIsRecalledBy!: DoctorDto | null;
    /** Why the approval was recalled */
    approvalRecallReason!: string | null;
    /** The reasons why field was changed. */
    fieldEditReasons!: { [key: string]: FieldEditReasonWithStaff; };
    /** The reason of document editing. */
    editReason!: EditReasonEnum | null;
    /** Description of update reason. */
    updateReasonText!: string | null;
    /** Why the form is skipped */
    skipReason!: FormSkipReason | null;
    /** Detailed reason why the form is skipped */
    skipReasonDetails!: string | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };

    constructor(data?: IFormChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fieldEditReasons = {};
            this.fieldSkipReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            this.minorVersionNumber = _data["minorVersionNumber"];
            this.updatedBy = _data["updatedBy"] ? DoctorDto.fromJS(_data["updatedBy"]) : <any>null;
            this.formChangingActionType = _data["formChangingActionType"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>null;
            this.submittedBy = _data["submittedBy"] ? DoctorDto.fromJS(_data["submittedBy"]) : <any>null;
            this.submissionRevokedAt = _data["submissionRevokedAt"] ? new Date(_data["submissionRevokedAt"].toString()) : <any>null;
            this.submissionRevokedBy = _data["submissionRevokedBy"] ? DoctorDto.fromJS(_data["submissionRevokedBy"]) : <any>null;
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : <any>null;
            this.approvedBy = _data["approvedBy"] ? DoctorDto.fromJS(_data["approvedBy"]) : <any>null;
            this.approvalIsRecalledAt = _data["approvalIsRecalledAt"] ? new Date(_data["approvalIsRecalledAt"].toString()) : <any>null;
            this.approvalIsRecalledBy = _data["approvalIsRecalledBy"] ? DoctorDto.fromJS(_data["approvalIsRecalledBy"]) : <any>null;
            this.approvalRecallReason = _data["approvalRecallReason"];
            if (_data["fieldEditReasons"]) {
                this.fieldEditReasons = {} as any;
                for (let key in _data["fieldEditReasons"]) {
                    if (_data["fieldEditReasons"].hasOwnProperty(key))
                        (<any>this.fieldEditReasons)![key] = _data["fieldEditReasons"][key] ? FieldEditReasonWithStaff.fromJS(_data["fieldEditReasons"][key]) : new FieldEditReasonWithStaff();
                }
            }
            this.editReason = _data["editReason"];
            this.updateReasonText = _data["updateReasonText"];
            this.skipReason = _data["skipReason"];
            this.skipReasonDetails = _data["skipReasonDetails"];
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
        }
    }

    static fromJS(data: any): FormChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        data["minorVersionNumber"] = this.minorVersionNumber;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        data["formChangingActionType"] = this.formChangingActionType;
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        data["submittedAt"] = this.submittedAt && this.submittedAt.toISOString();
        data["submittedBy"] = this.submittedBy ? this.submittedBy.toJSON() : <any>null;
        data["submissionRevokedAt"] = this.submissionRevokedAt && this.submissionRevokedAt.toISOString();
        data["submissionRevokedBy"] = this.submissionRevokedBy ? this.submissionRevokedBy.toJSON() : <any>null;
        data["approvedAt"] = this.approvedAt && this.approvedAt.toISOString();
        data["approvedBy"] = this.approvedBy ? this.approvedBy.toJSON() : <any>null;
        data["approvalIsRecalledAt"] = this.approvalIsRecalledAt && this.approvalIsRecalledAt.toISOString();
        data["approvalIsRecalledBy"] = this.approvalIsRecalledBy ? this.approvalIsRecalledBy.toJSON() : <any>null;
        data["approvalRecallReason"] = this.approvalRecallReason;
        if (this.fieldEditReasons) {
            data["fieldEditReasons"] = {};
            for (let key in this.fieldEditReasons) {
                if (this.fieldEditReasons.hasOwnProperty(key))
                    (<any>data["fieldEditReasons"])[key] = this.fieldEditReasons[key] ? this.fieldEditReasons[key].toJSON() : <any>null;
            }
        }
        data["editReason"] = this.editReason;
        data["updateReasonText"] = this.updateReasonText;
        data["skipReason"] = this.skipReason;
        data["skipReasonDetails"] = this.skipReasonDetails;
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        return data;
    }
}

export interface IFormChangesDto {
    /** Id of form history element */
    id: string;
    /** Major form version */
    versionNumber: number;
    value: { [key: string]: any; } | null;
    /** Minor form version */
    minorVersionNumber: number;
    /** Who updated this version */
    updatedBy: DoctorDto | null;
    /** Type of changes (e.g submit, approve, change fields, etc...) */
    formChangingActionType: FormChangingActionType;
    /** When the value of this version was updated last time. */
    updatedAt: Date;
    /** When this version was submitted for approval */
    submittedAt: Date | null;
    /** Who submitted this version for approval */
    submittedBy: DoctorDto | null;
    /** When submission of this version was revoked */
    submissionRevokedAt: Date | null;
    /** Who revoked submission this version */
    submissionRevokedBy: DoctorDto | null;
    /** When this version was approved */
    approvedAt: Date | null;
    /** Who approved this version */
    approvedBy: DoctorDto | null;
    /** When the approval was recalled */
    approvalIsRecalledAt: Date | null;
    /** Who recalled the approval */
    approvalIsRecalledBy: DoctorDto | null;
    /** Why the approval was recalled */
    approvalRecallReason: string | null;
    /** The reasons why field was changed. */
    fieldEditReasons: { [key: string]: FieldEditReasonWithStaff; };
    /** The reason of document editing. */
    editReason: EditReasonEnum | null;
    /** Description of update reason. */
    updateReasonText: string | null;
    /** Why the form is skipped */
    skipReason: FormSkipReason | null;
    /** Detailed reason why the form is skipped */
    skipReasonDetails: string | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
}

/** 0 = Submit 1 = Approve 2 = Recall 3 = ChangeFields 4 = Skipped 5 = ApprovedAfterSkipping 6 = SubmissionRevoked */
export enum FormChangingActionType {
    Submit = 0,
    Approve = 1,
    Recall = 2,
    ChangeFields = 3,
    Skipped = 4,
    ApprovedAfterSkipping = 5,
    SubmissionRevoked = 6,
}

/** 1 = WrongEntry 2 = Adding 3 = Update */
export enum EditReasonEnum {
    WrongEntry = 1,
    Adding = 2,
    Update = 3,
}

/** 0 = Missed 1 = NotApplicable */
export enum FormSkipReason {
    Missed = 0,
    NotApplicable = 1,
}

export class CreateFormConfigDto implements ICreateFormConfigDto {
    /** Id of the related Study. */
    studyId!: number;
    /** Form type */
    type!: string;
    /** Form config */
    layoutSchema!: { [key: string]: any; };
    /** How form could be created only once or as many as possible by user. */
    isMultiInstance!: boolean;
    /** Flag allows fill the form for "Not started" patients.
Only used with IsMultiInstance set to true */
    allowedForNotStartedPatients!: boolean;
    /** Flag indicating that the form is creating a patient */
    isPatientCreationForm!: boolean;
    /** Can the form be skipped? */
    canBeSkipped!: boolean;

    constructor(data?: ICreateFormConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layoutSchema = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.type = _data["type"];
            if (_data["layoutSchema"]) {
                this.layoutSchema = {} as any;
                for (let key in _data["layoutSchema"]) {
                    if (_data["layoutSchema"].hasOwnProperty(key))
                        (<any>this.layoutSchema)![key] = _data["layoutSchema"][key];
                }
            }
            this.isMultiInstance = _data["isMultiInstance"];
            this.allowedForNotStartedPatients = _data["allowedForNotStartedPatients"];
            this.isPatientCreationForm = _data["isPatientCreationForm"];
            this.canBeSkipped = _data["canBeSkipped"];
        }
    }

    static fromJS(data: any): CreateFormConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["type"] = this.type;
        if (this.layoutSchema) {
            data["layoutSchema"] = {};
            for (let key in this.layoutSchema) {
                if (this.layoutSchema.hasOwnProperty(key))
                    (<any>data["layoutSchema"])[key] = (<any>this.layoutSchema)[key];
            }
        }
        data["isMultiInstance"] = this.isMultiInstance;
        data["allowedForNotStartedPatients"] = this.allowedForNotStartedPatients;
        data["isPatientCreationForm"] = this.isPatientCreationForm;
        data["canBeSkipped"] = this.canBeSkipped;
        return data;
    }
}

export interface ICreateFormConfigDto {
    /** Id of the related Study. */
    studyId: number;
    /** Form type */
    type: string;
    /** Form config */
    layoutSchema: { [key: string]: any; };
    /** How form could be created only once or as many as possible by user. */
    isMultiInstance: boolean;
    /** Flag allows fill the form for "Not started" patients.
Only used with IsMultiInstance set to true */
    allowedForNotStartedPatients: boolean;
    /** Flag indicating that the form is creating a patient */
    isPatientCreationForm: boolean;
    /** Can the form be skipped? */
    canBeSkipped: boolean;
}

export class PatchFormConfigDto implements IPatchFormConfigDto {
    /** Form type */
    type?: string;
    /** Form config */
    layoutSchema?: { [key: string]: any; };
    /** How form could be created only once or as many as possible by user. */
    isMultiInstance?: boolean;
    /** Flag allows fill the form for "Not started" patients.
Only used with IsMultiInstance set to true */
    allowedForNotStartedPatients?: boolean;
    /** Flag indicating that the form is creating a patient */
    isPatientCreationForm?: boolean;
    /** Can the form be skipped? */
    canBeSkipped?: boolean;

    constructor(data?: IPatchFormConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (_data["layoutSchema"]) {
                this.layoutSchema = {} as any;
                for (let key in _data["layoutSchema"]) {
                    if (_data["layoutSchema"].hasOwnProperty(key))
                        (<any>this.layoutSchema)![key] = _data["layoutSchema"][key];
                }
            }
            this.isMultiInstance = _data["isMultiInstance"];
            this.allowedForNotStartedPatients = _data["allowedForNotStartedPatients"];
            this.isPatientCreationForm = _data["isPatientCreationForm"];
            this.canBeSkipped = _data["canBeSkipped"];
        }
    }

    static fromJS(data: any): PatchFormConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchFormConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.layoutSchema) {
            data["layoutSchema"] = {};
            for (let key in this.layoutSchema) {
                if (this.layoutSchema.hasOwnProperty(key))
                    (<any>data["layoutSchema"])[key] = (<any>this.layoutSchema)[key];
            }
        }
        data["isMultiInstance"] = this.isMultiInstance;
        data["allowedForNotStartedPatients"] = this.allowedForNotStartedPatients;
        data["isPatientCreationForm"] = this.isPatientCreationForm;
        data["canBeSkipped"] = this.canBeSkipped;
        return data;
    }
}

export interface IPatchFormConfigDto {
    /** Form type */
    type?: string;
    /** Form config */
    layoutSchema?: { [key: string]: any; };
    /** How form could be created only once or as many as possible by user. */
    isMultiInstance?: boolean;
    /** Flag allows fill the form for "Not started" patients.
Only used with IsMultiInstance set to true */
    allowedForNotStartedPatients?: boolean;
    /** Flag indicating that the form is creating a patient */
    isPatientCreationForm?: boolean;
    /** Can the form be skipped? */
    canBeSkipped?: boolean;
}

export class FormResultDto implements IFormResultDto {
    /** The primary key of the form result */
    id!: number;
    /** The foreign key to the related form config. */
    formConfigId!: number;
    /** The foreign key to the related patient who the form's data is about. */
    patientId!: string;
    /** When form result was created */
    createdAt!: Date;
    /** The versions of this form result */
    versions!: FormResultVersionDto[];

    constructor(data?: IFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.versions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formConfigId = _data["formConfigId"];
            this.patientId = _data["patientId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(FormResultVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formConfigId"] = this.formConfigId;
        data["patientId"] = this.patientId;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormResultDto {
    /** The primary key of the form result */
    id: number;
    /** The foreign key to the related form config. */
    formConfigId: number;
    /** The foreign key to the related patient who the form's data is about. */
    patientId: string;
    /** When form result was created */
    createdAt: Date;
    /** The versions of this form result */
    versions: FormResultVersionDto[];
}

export class FormResultVersionDto implements IFormResultVersionDto {
    /** Id of form results */
    formResultId!: number;
    versionNumber!: number;
    minorVersionNumber!: number;
    /** Who updated the value of this version last time */
    doctor!: DoctorDto;
    /** When this version was created */
    createdAt!: Date;
    /** When the value of this version was updated last time. */
    updatedAt!: Date;
    /** Who updated this version */
    updatedBy!: DoctorDto | null;
    value!: { [key: string]: any; } | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };
    /** The reasons why field was changed. */
    fieldEditReasons!: { [key: string]: FieldEditReasonWithStaff; };
    /** Progress of filling the form */
    fillingProgress!: FillingProgress | null;
    /** The form is skipped */
    isSkipped!: boolean;
    /** Why the form is skipped */
    skipReason!: FormSkipReason | null;
    /** Detailed reason why the form is skipped */
    skipReasonDetails!: string | null;
    /** Score result */
    score!: FormScore | null;
    /** Status of score calculation */
    scoreStatus!: ScoreCalculationStatusEnum;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation!: boolean;
    /** The current state of the version's lifecycle */
    lifecycleState!: FormLifecycleState;
    /** When this version was submitted for approval */
    submittedAt!: Date | null;
    /** Who submitted this version for approval */
    submittedBy!: DoctorDto | null;
    /** When submission of this version was revoked */
    submissionRevokedAt!: Date | null;
    /** Who revoked submission this version */
    submissionRevokedBy!: DoctorDto | null;
    /** When this version was approved */
    approvedAt!: Date | null;
    /** Who approved this version */
    approvedBy!: DoctorDto | null;
    /** When the approval was recalled */
    approvalIsRecalledAt!: Date | null;
    /** Who recalled the approval */
    approvalIsRecalledBy!: DoctorDto | null;
    /** Why the approval was recalled */
    approvalRecallReason!: string | null;
    /** This version of the form can be edited without creating new version */
    isEditable!: boolean;
    /** The reason of document editing. */
    editReason!: EditReasonEnum | null;
    /** Description of update reason. */
    updateReasonText!: string | null;

    constructor(data?: IFormResultVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.doctor = new DoctorDto();
            this.fieldSkipReasons = {};
            this.fieldEditReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formResultId = _data["formResultId"];
            this.versionNumber = _data["versionNumber"];
            this.minorVersionNumber = _data["minorVersionNumber"];
            this.doctor = _data["doctor"] ? DoctorDto.fromJS(_data["doctor"]) : new DoctorDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.updatedBy = _data["updatedBy"] ? DoctorDto.fromJS(_data["updatedBy"]) : <any>null;
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            if (_data["fieldEditReasons"]) {
                this.fieldEditReasons = {} as any;
                for (let key in _data["fieldEditReasons"]) {
                    if (_data["fieldEditReasons"].hasOwnProperty(key))
                        (<any>this.fieldEditReasons)![key] = _data["fieldEditReasons"][key] ? FieldEditReasonWithStaff.fromJS(_data["fieldEditReasons"][key]) : new FieldEditReasonWithStaff();
                }
            }
            this.fillingProgress = _data["fillingProgress"] ? FillingProgress.fromJS(_data["fillingProgress"]) : <any>null;
            this.isSkipped = _data["isSkipped"];
            this.skipReason = _data["skipReason"];
            this.skipReasonDetails = _data["skipReasonDetails"];
            this.score = _data["score"] ? FormScore.fromJS(_data["score"]) : <any>null;
            this.scoreStatus = _data["scoreStatus"];
            this.canRetryScoreCalculation = _data["canRetryScoreCalculation"];
            this.lifecycleState = _data["lifecycleState"];
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>null;
            this.submittedBy = _data["submittedBy"] ? DoctorDto.fromJS(_data["submittedBy"]) : <any>null;
            this.submissionRevokedAt = _data["submissionRevokedAt"] ? new Date(_data["submissionRevokedAt"].toString()) : <any>null;
            this.submissionRevokedBy = _data["submissionRevokedBy"] ? DoctorDto.fromJS(_data["submissionRevokedBy"]) : <any>null;
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : <any>null;
            this.approvedBy = _data["approvedBy"] ? DoctorDto.fromJS(_data["approvedBy"]) : <any>null;
            this.approvalIsRecalledAt = _data["approvalIsRecalledAt"] ? new Date(_data["approvalIsRecalledAt"].toString()) : <any>null;
            this.approvalIsRecalledBy = _data["approvalIsRecalledBy"] ? DoctorDto.fromJS(_data["approvalIsRecalledBy"]) : <any>null;
            this.approvalRecallReason = _data["approvalRecallReason"];
            this.isEditable = _data["isEditable"];
            this.editReason = _data["editReason"];
            this.updateReasonText = _data["updateReasonText"];
        }
    }

    static fromJS(data: any): FormResultVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormResultVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formResultId"] = this.formResultId;
        data["versionNumber"] = this.versionNumber;
        data["minorVersionNumber"] = this.minorVersionNumber;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>null;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        if (this.fieldEditReasons) {
            data["fieldEditReasons"] = {};
            for (let key in this.fieldEditReasons) {
                if (this.fieldEditReasons.hasOwnProperty(key))
                    (<any>data["fieldEditReasons"])[key] = this.fieldEditReasons[key] ? this.fieldEditReasons[key].toJSON() : <any>null;
            }
        }
        data["fillingProgress"] = this.fillingProgress ? this.fillingProgress.toJSON() : <any>null;
        data["isSkipped"] = this.isSkipped;
        data["skipReason"] = this.skipReason;
        data["skipReasonDetails"] = this.skipReasonDetails;
        data["score"] = this.score ? this.score.toJSON() : <any>null;
        data["scoreStatus"] = this.scoreStatus;
        data["canRetryScoreCalculation"] = this.canRetryScoreCalculation;
        data["lifecycleState"] = this.lifecycleState;
        data["submittedAt"] = this.submittedAt && this.submittedAt.toISOString();
        data["submittedBy"] = this.submittedBy ? this.submittedBy.toJSON() : <any>null;
        data["submissionRevokedAt"] = this.submissionRevokedAt && this.submissionRevokedAt.toISOString();
        data["submissionRevokedBy"] = this.submissionRevokedBy ? this.submissionRevokedBy.toJSON() : <any>null;
        data["approvedAt"] = this.approvedAt && this.approvedAt.toISOString();
        data["approvedBy"] = this.approvedBy ? this.approvedBy.toJSON() : <any>null;
        data["approvalIsRecalledAt"] = this.approvalIsRecalledAt && this.approvalIsRecalledAt.toISOString();
        data["approvalIsRecalledBy"] = this.approvalIsRecalledBy ? this.approvalIsRecalledBy.toJSON() : <any>null;
        data["approvalRecallReason"] = this.approvalRecallReason;
        data["isEditable"] = this.isEditable;
        data["editReason"] = this.editReason;
        data["updateReasonText"] = this.updateReasonText;
        return data;
    }
}

export interface IFormResultVersionDto {
    /** Id of form results */
    formResultId: number;
    versionNumber: number;
    minorVersionNumber: number;
    /** Who updated the value of this version last time */
    doctor: DoctorDto;
    /** When this version was created */
    createdAt: Date;
    /** When the value of this version was updated last time. */
    updatedAt: Date;
    /** Who updated this version */
    updatedBy: DoctorDto | null;
    value: { [key: string]: any; } | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
    /** The reasons why field was changed. */
    fieldEditReasons: { [key: string]: FieldEditReasonWithStaff; };
    /** Progress of filling the form */
    fillingProgress: FillingProgress | null;
    /** The form is skipped */
    isSkipped: boolean;
    /** Why the form is skipped */
    skipReason: FormSkipReason | null;
    /** Detailed reason why the form is skipped */
    skipReasonDetails: string | null;
    /** Score result */
    score: FormScore | null;
    /** Status of score calculation */
    scoreStatus: ScoreCalculationStatusEnum;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation: boolean;
    /** The current state of the version's lifecycle */
    lifecycleState: FormLifecycleState;
    /** When this version was submitted for approval */
    submittedAt: Date | null;
    /** Who submitted this version for approval */
    submittedBy: DoctorDto | null;
    /** When submission of this version was revoked */
    submissionRevokedAt: Date | null;
    /** Who revoked submission this version */
    submissionRevokedBy: DoctorDto | null;
    /** When this version was approved */
    approvedAt: Date | null;
    /** Who approved this version */
    approvedBy: DoctorDto | null;
    /** When the approval was recalled */
    approvalIsRecalledAt: Date | null;
    /** Who recalled the approval */
    approvalIsRecalledBy: DoctorDto | null;
    /** Why the approval was recalled */
    approvalRecallReason: string | null;
    /** This version of the form can be edited without creating new version */
    isEditable: boolean;
    /** The reason of document editing. */
    editReason: EditReasonEnum | null;
    /** Description of update reason. */
    updateReasonText: string | null;
}

export class FormScore implements IFormScore {
    totalScore!: number | null;
    hasTotalScore!: boolean;
    decimal!: number | null;
    sectionScore!: ScoreSection[];

    constructor(data?: IFormScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sectionScore = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalScore = _data["totalScore"];
            this.hasTotalScore = _data["hasTotalScore"];
            this.decimal = _data["decimal"];
            if (Array.isArray(_data["sectionScore"])) {
                this.sectionScore = [] as any;
                for (let item of _data["sectionScore"])
                    this.sectionScore!.push(ScoreSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormScore {
        data = typeof data === 'object' ? data : {};
        let result = new FormScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalScore"] = this.totalScore;
        data["hasTotalScore"] = this.hasTotalScore;
        data["decimal"] = this.decimal;
        if (Array.isArray(this.sectionScore)) {
            data["sectionScore"] = [];
            for (let item of this.sectionScore)
                data["sectionScore"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormScore {
    totalScore: number | null;
    hasTotalScore: boolean;
    decimal: number | null;
    sectionScore: ScoreSection[];
}

export class ScoreSection implements IScoreSection {
    scoreGroup!: ScoreGroupEnum;
    maxScore!: number;
    rawScore!: number;
    missedScore!: number;
    score!: number | null;

    constructor(data?: IScoreSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreGroup = _data["scoreGroup"];
            this.maxScore = _data["maxScore"];
            this.rawScore = _data["rawScore"];
            this.missedScore = _data["missedScore"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): ScoreSection {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreGroup"] = this.scoreGroup;
        data["maxScore"] = this.maxScore;
        data["rawScore"] = this.rawScore;
        data["missedScore"] = this.missedScore;
        data["score"] = this.score;
        return data;
    }
}

export interface IScoreSection {
    scoreGroup: ScoreGroupEnum;
    maxScore: number;
    rawScore: number;
    missedScore: number;
    score: number | null;
}

/** 0 = NotCalculated 1 = InProcess 2 = Done 3 = Error */
export enum ScoreCalculationStatusEnum {
    NotCalculated = 0,
    InProcess = 1,
    Done = 2,
    Error = 3,
}

export class ProcessFormResultDto implements IProcessFormResultDto {
    /** Id of the related Study. */
    studyId!: number;
    /** Id of Patient, related to form result. */
    patientId?: string | null;
    /** Id of the form config. */
    formId!: number;
    /** Values dictionary. */
    values!: string;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };
    /** Related step in StudyRoutes. */
    stepName?: string | null;
    /** Tags that are attached to new patient */
    tags!: { [key: string]: string; } | null;
    /** Save the created form result version in submitted state */
    asSubmitted!: boolean;

    constructor(data?: IProcessFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fieldSkipReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.patientId = _data["patientId"];
            this.formId = _data["formId"];
            this.values = _data["values"];
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            this.stepName = _data["stepName"];
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key];
                }
            }
            this.asSubmitted = _data["asSubmitted"];
        }
    }

    static fromJS(data: any): ProcessFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["patientId"] = this.patientId;
        data["formId"] = this.formId;
        data["values"] = this.values;
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        data["stepName"] = this.stepName;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = (<any>this.tags)[key];
            }
        }
        data["asSubmitted"] = this.asSubmitted;
        return data;
    }
}

export interface IProcessFormResultDto {
    /** Id of the related Study. */
    studyId: number;
    /** Id of Patient, related to form result. */
    patientId?: string | null;
    /** Id of the form config. */
    formId: number;
    /** Values dictionary. */
    values: string;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
    /** Related step in StudyRoutes. */
    stepName?: string | null;
    /** Tags that are attached to new patient */
    tags: { [key: string]: string; } | null;
    /** Save the created form result version in submitted state */
    asSubmitted: boolean;
}

export class UpdateFormResultDto implements IUpdateFormResultDto {
    /** Id of the related Study. */
    studyId!: number;
    /** Id of Patient, related to form result. */
    patientId!: string;
    /** Id of the form result. */
    formResultId!: number;
    /** New Values dictionary. */
    values!: string;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };
    /** The reasons why field was changed. */
    fieldEditReasons!: { [key: string]: FieldEditReason; };

    constructor(data?: IUpdateFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fieldSkipReasons = {};
            this.fieldEditReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.patientId = _data["patientId"];
            this.formResultId = _data["formResultId"];
            this.values = _data["values"];
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            if (_data["fieldEditReasons"]) {
                this.fieldEditReasons = {} as any;
                for (let key in _data["fieldEditReasons"]) {
                    if (_data["fieldEditReasons"].hasOwnProperty(key))
                        (<any>this.fieldEditReasons)![key] = _data["fieldEditReasons"][key] ? FieldEditReason.fromJS(_data["fieldEditReasons"][key]) : new FieldEditReason();
                }
            }
        }
    }

    static fromJS(data: any): UpdateFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["patientId"] = this.patientId;
        data["formResultId"] = this.formResultId;
        data["values"] = this.values;
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        if (this.fieldEditReasons) {
            data["fieldEditReasons"] = {};
            for (let key in this.fieldEditReasons) {
                if (this.fieldEditReasons.hasOwnProperty(key))
                    (<any>data["fieldEditReasons"])[key] = this.fieldEditReasons[key] ? this.fieldEditReasons[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface IUpdateFormResultDto {
    /** Id of the related Study. */
    studyId: number;
    /** Id of Patient, related to form result. */
    patientId: string;
    /** Id of the form result. */
    formResultId: number;
    /** New Values dictionary. */
    values: string;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
    /** The reasons why field was changed. */
    fieldEditReasons: { [key: string]: FieldEditReason; };
}

export class FieldEditReason implements IFieldEditReason {
    /** Reason for editing the field */
    editReason!: FieldEditReasonEnum;
    /** Additional text due to editing */
    editReasonText!: string | null;

    constructor(data?: IFieldEditReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editReason = _data["editReason"];
            this.editReasonText = _data["editReasonText"];
        }
    }

    static fromJS(data: any): FieldEditReason {
        data = typeof data === 'object' ? data : {};
        let result = new FieldEditReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editReason"] = this.editReason;
        data["editReasonText"] = this.editReasonText;
        return data;
    }
}

export interface IFieldEditReason {
    /** Reason for editing the field */
    editReason: FieldEditReasonEnum;
    /** Additional text due to editing */
    editReasonText: string | null;
}

export class SkipFormResultDto implements ISkipFormResultDto {
    patientId!: string;
    formConfigId!: number;
    stepName!: string | null;
    skipReason!: FormSkipReason;
    skipReasonDetails!: string;

    constructor(data?: ISkipFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.formConfigId = _data["formConfigId"];
            this.stepName = _data["stepName"];
            this.skipReason = _data["skipReason"];
            this.skipReasonDetails = _data["skipReasonDetails"];
        }
    }

    static fromJS(data: any): SkipFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkipFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["formConfigId"] = this.formConfigId;
        data["stepName"] = this.stepName;
        data["skipReason"] = this.skipReason;
        data["skipReasonDetails"] = this.skipReasonDetails;
        return data;
    }
}

export interface ISkipFormResultDto {
    patientId: string;
    formConfigId: number;
    stepName: string | null;
    skipReason: FormSkipReason;
    skipReasonDetails: string;
}

export class SkipAllFormsOnStepDto implements ISkipAllFormsOnStepDto {
    patientId!: string;
    stepName!: string;
    skipReason!: FormSkipReason;
    skipReasonDetails!: string;

    constructor(data?: ISkipAllFormsOnStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.stepName = _data["stepName"];
            this.skipReason = _data["skipReason"];
            this.skipReasonDetails = _data["skipReasonDetails"];
        }
    }

    static fromJS(data: any): SkipAllFormsOnStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkipAllFormsOnStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["stepName"] = this.stepName;
        data["skipReason"] = this.skipReason;
        data["skipReasonDetails"] = this.skipReasonDetails;
        return data;
    }
}

export interface ISkipAllFormsOnStepDto {
    patientId: string;
    stepName: string;
    skipReason: FormSkipReason;
    skipReasonDetails: string;
}

export class MarkFormResultAsSkippedDto implements IMarkFormResultAsSkippedDto {
    skipReason!: FormSkipReason;
    skipReasonDetails!: string;

    constructor(data?: IMarkFormResultAsSkippedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skipReason = _data["skipReason"];
            this.skipReasonDetails = _data["skipReasonDetails"];
        }
    }

    static fromJS(data: any): MarkFormResultAsSkippedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkFormResultAsSkippedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipReason"] = this.skipReason;
        data["skipReasonDetails"] = this.skipReasonDetails;
        return data;
    }
}

export interface IMarkFormResultAsSkippedDto {
    skipReason: FormSkipReason;
    skipReasonDetails: string;
}

export class RecallFormResultApprovalDto implements IRecallFormResultApprovalDto {
    /** Why the approval was recalled */
    reason!: string;

    constructor(data?: IRecallFormResultApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RecallFormResultApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecallFormResultApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRecallFormResultApprovalDto {
    /** Why the approval was recalled */
    reason: string;
}

export class PagedResultOfFormResultDto implements IPagedResultOfFormResultDto {
    data!: FormResultDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfFormResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FormResultDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfFormResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfFormResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfFormResultDto {
    data: FormResultDto[];
    totalCount: number;
}

export class FormResultDatesDto implements IFormResultDatesDto {
    /** Mim possible date of filled results. */
    minAvailableDate!: Date | null;
    /** Max possible date of form filled results. */
    maxAvailableDate!: Date | null;
    /** All dates when forms have been filled. */
    dates!: Date[];

    constructor(data?: IFormResultDatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minAvailableDate = _data["minAvailableDate"] ? parseDateOnly(_data["minAvailableDate"].toString()) : <any>null;
            this.maxAvailableDate = _data["maxAvailableDate"] ? parseDateOnly(_data["maxAvailableDate"].toString()) : <any>null;
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(parseDateOnly(item));
            }
        }
    }

    static fromJS(data: any): FormResultDatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormResultDatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAvailableDate"] = this.minAvailableDate && formatDate(this.minAvailableDate);
        data["maxAvailableDate"] = this.maxAvailableDate && formatDate(this.maxAvailableDate);
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(formatDate(item));
        }
        return data;
    }
}

export interface IFormResultDatesDto {
    /** Mim possible date of filled results. */
    minAvailableDate: Date | null;
    /** Max possible date of form filled results. */
    maxAvailableDate: Date | null;
    /** All dates when forms have been filled. */
    dates: Date[];
}

export class FileDto implements IFileDto {
    fileId!: string;
    fileName!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IFileDto {
    fileId: string;
    fileName: string;
}

export class IssueDto implements IIssueDto {
    /** Id of the issue */
    id!: number;
    /** Id of the study */
    studyId!: number;
    /** Subject of the issue */
    subject!: string;
    /** Topic of the issue */
    topic!: string;
    /** Additional field to Topic of the issue */
    topicAdditional!: string | null;
    /** Description of the issue */
    description!: string;
    /** Additional field for navigation to described field */
    resultId!: number | null;
    /** Additional field for navigation to described field */
    fieldId!: string | null;
    /** Additional field with study step name for navigation to described field */
    stepName!: string | null;
    /** Additional field to describe the field (label, question or dataKey) */
    fieldDescription!: string | null;
    /** Unique Id of the linked patient in the study */
    linkedPatientUniqId!: string | null;
    /** Deadline for closing the issue */
    deadlineAt!: Date;
    /** Full name of the user who opened the issue */
    createdByUser!: string;
    /** Date when the issue has been opened */
    createdAt!: Date;
    /** Date when the issue has been edited */
    updatedAt!: Date;
    /** Full name of the user who update the issue */
    updatedByUser!: string;
    /** Issue state */
    state!: IssuesStateEnum;
    /** The last operation that were performed on the issue by a doctor */
    lastOperation!: IssueOperationDto | null;
    /** Attached files to issue entry. */
    files!: FileDto[];
    /** Flag that indicates the issue has expired */
    isExpired!: boolean;
    /** Flag that indicates the issue has new changes */
    isNew!: boolean;
    /** The flags indicate which fields are checked by the user. */
    checkedFields!: CheckedFieldsEnum;
    /** The date when the issue was checked */
    lastCheckedAt!: Date | null;
    /** Action that should be done to close the issue. */
    recommendedAction!: string;

    constructor(data?: IIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.subject = _data["subject"];
            this.topic = _data["topic"];
            this.topicAdditional = _data["topicAdditional"];
            this.description = _data["description"];
            this.resultId = _data["resultId"];
            this.fieldId = _data["fieldId"];
            this.stepName = _data["stepName"];
            this.fieldDescription = _data["fieldDescription"];
            this.linkedPatientUniqId = _data["linkedPatientUniqId"];
            this.deadlineAt = _data["deadlineAt"] ? parseDateOnly(_data["deadlineAt"].toString()) : <any>null;
            this.createdByUser = _data["createdByUser"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.updatedByUser = _data["updatedByUser"];
            this.state = _data["state"];
            this.lastOperation = _data["lastOperation"] ? IssueOperationDto.fromJS(_data["lastOperation"]) : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
            this.isExpired = _data["isExpired"];
            this.isNew = _data["isNew"];
            this.checkedFields = _data["checkedFields"];
            this.lastCheckedAt = _data["lastCheckedAt"] ? new Date(_data["lastCheckedAt"].toString()) : <any>null;
            this.recommendedAction = _data["recommendedAction"];
        }
    }

    static fromJS(data: any): IssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["subject"] = this.subject;
        data["topic"] = this.topic;
        data["topicAdditional"] = this.topicAdditional;
        data["description"] = this.description;
        data["resultId"] = this.resultId;
        data["fieldId"] = this.fieldId;
        data["stepName"] = this.stepName;
        data["fieldDescription"] = this.fieldDescription;
        data["linkedPatientUniqId"] = this.linkedPatientUniqId;
        data["deadlineAt"] = this.deadlineAt && formatDate(this.deadlineAt);
        data["createdByUser"] = this.createdByUser;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        data["updatedByUser"] = this.updatedByUser;
        data["state"] = this.state;
        data["lastOperation"] = this.lastOperation ? this.lastOperation.toJSON() : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["isExpired"] = this.isExpired;
        data["isNew"] = this.isNew;
        data["checkedFields"] = this.checkedFields;
        data["lastCheckedAt"] = this.lastCheckedAt && this.lastCheckedAt.toISOString();
        data["recommendedAction"] = this.recommendedAction;
        return data;
    }
}

export interface IIssueDto {
    /** Id of the issue */
    id: number;
    /** Id of the study */
    studyId: number;
    /** Subject of the issue */
    subject: string;
    /** Topic of the issue */
    topic: string;
    /** Additional field to Topic of the issue */
    topicAdditional: string | null;
    /** Description of the issue */
    description: string;
    /** Additional field for navigation to described field */
    resultId: number | null;
    /** Additional field for navigation to described field */
    fieldId: string | null;
    /** Additional field with study step name for navigation to described field */
    stepName: string | null;
    /** Additional field to describe the field (label, question or dataKey) */
    fieldDescription: string | null;
    /** Unique Id of the linked patient in the study */
    linkedPatientUniqId: string | null;
    /** Deadline for closing the issue */
    deadlineAt: Date;
    /** Full name of the user who opened the issue */
    createdByUser: string;
    /** Date when the issue has been opened */
    createdAt: Date;
    /** Date when the issue has been edited */
    updatedAt: Date;
    /** Full name of the user who update the issue */
    updatedByUser: string;
    /** Issue state */
    state: IssuesStateEnum;
    /** The last operation that were performed on the issue by a doctor */
    lastOperation: IssueOperationDto | null;
    /** Attached files to issue entry. */
    files: FileDto[];
    /** Flag that indicates the issue has expired */
    isExpired: boolean;
    /** Flag that indicates the issue has new changes */
    isNew: boolean;
    /** The flags indicate which fields are checked by the user. */
    checkedFields: CheckedFieldsEnum;
    /** The date when the issue was checked */
    lastCheckedAt: Date | null;
    /** Action that should be done to close the issue. */
    recommendedAction: string;
}

/** 0 = Opened 1 = Processed 2 = Closed */
export enum IssuesStateEnum {
    Opened = 0,
    Processed = 1,
    Closed = 2,
}

export class IssueOperationDto implements IIssueOperationDto {
    /** Id of the issue operation */
    id!: number;
    /** Id of the issue which contains this operation */
    issueId!: number;
    /** Full name of the user who performed the operation */
    createdByUser!: string;
    /** Date when the operation has been performed */
    createdAt!: Date;
    /** Description of the action that was taken */
    action!: string;
    /** Comment for the action */
    comment!: string | null;
    /** Operation state */
    state!: IssueOperationStateEnum | null;
    /** Date when the operation state has been changed */
    stateChangedAt!: Date | null;
    /** Full name of the user who resume the operation */
    stateChangedByUser!: string | null;

    constructor(data?: IIssueOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueId = _data["issueId"];
            this.createdByUser = _data["createdByUser"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.action = _data["action"];
            this.comment = _data["comment"];
            this.state = _data["state"];
            this.stateChangedAt = _data["stateChangedAt"] ? new Date(_data["stateChangedAt"].toString()) : <any>null;
            this.stateChangedByUser = _data["stateChangedByUser"];
        }
    }

    static fromJS(data: any): IssueOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueId"] = this.issueId;
        data["createdByUser"] = this.createdByUser;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["action"] = this.action;
        data["comment"] = this.comment;
        data["state"] = this.state;
        data["stateChangedAt"] = this.stateChangedAt && this.stateChangedAt.toISOString();
        data["stateChangedByUser"] = this.stateChangedByUser;
        return data;
    }
}

export interface IIssueOperationDto {
    /** Id of the issue operation */
    id: number;
    /** Id of the issue which contains this operation */
    issueId: number;
    /** Full name of the user who performed the operation */
    createdByUser: string;
    /** Date when the operation has been performed */
    createdAt: Date;
    /** Description of the action that was taken */
    action: string;
    /** Comment for the action */
    comment: string | null;
    /** Operation state */
    state: IssueOperationStateEnum | null;
    /** Date when the operation state has been changed */
    stateChangedAt: Date | null;
    /** Full name of the user who resume the operation */
    stateChangedByUser: string | null;
}

/** 0 = None 1 = Rejected 2 = Approved */
export enum IssueOperationStateEnum {
    None = 0,
    Rejected = 1,
    Approved = 2,
}

/** 0 = None 2 = Content 4 = State 8 = Comment 14 = All */
export enum CheckedFieldsEnum {
    None = 0,
    Content = 2,
    State = 4,
    Comment = 8,
    All = 14,
}

export class PagedResultOfIssueDto implements IPagedResultOfIssueDto {
    data!: IssueDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IssueDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfIssueDto {
    data: IssueDto[];
    totalCount: number;
}

/** 0 = Asc 1 = Desc */
export enum SortOrder {
    Asc = 0,
    Desc = 1,
}

export class PagedResultOfGroupedIssueDto implements IPagedResultOfGroupedIssueDto {
    data!: GroupedIssueDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfGroupedIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GroupedIssueDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfGroupedIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfGroupedIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfGroupedIssueDto {
    data: GroupedIssueDto[];
    totalCount: number;
}

export class GroupedIssueDto implements IGroupedIssueDto {
    /** Id of patient */
    patientId!: string | null;
    /** Unique id of patient in the current study
UniqueId is null for issues without linked patient */
    uniqueId!: string | null;
    /** Title of the group, where patient has included */
    group!: string | null;
    /** Current state of the patient study route */
    routeProgress!: RouteProgressDto | null;
    /** Issues count linked to patient */
    issuesCount!: number;
    /** Opened issues count linked to patient */
    openedCount!: number;
    /** Processed issues count linked to patient */
    processedCount!: number;
    /** Closed issues count linked to patient */
    closedCount!: number;

    constructor(data?: IGroupedIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.uniqueId = _data["uniqueId"];
            this.group = _data["group"];
            this.routeProgress = _data["routeProgress"] ? RouteProgressDto.fromJS(_data["routeProgress"]) : <any>null;
            this.issuesCount = _data["issuesCount"];
            this.openedCount = _data["openedCount"];
            this.processedCount = _data["processedCount"];
            this.closedCount = _data["closedCount"];
        }
    }

    static fromJS(data: any): GroupedIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["uniqueId"] = this.uniqueId;
        data["group"] = this.group;
        data["routeProgress"] = this.routeProgress ? this.routeProgress.toJSON() : <any>null;
        data["issuesCount"] = this.issuesCount;
        data["openedCount"] = this.openedCount;
        data["processedCount"] = this.processedCount;
        data["closedCount"] = this.closedCount;
        return data;
    }
}

export interface IGroupedIssueDto {
    /** Id of patient */
    patientId: string | null;
    /** Unique id of patient in the current study
UniqueId is null for issues without linked patient */
    uniqueId: string | null;
    /** Title of the group, where patient has included */
    group: string | null;
    /** Current state of the patient study route */
    routeProgress: RouteProgressDto | null;
    /** Issues count linked to patient */
    issuesCount: number;
    /** Opened issues count linked to patient */
    openedCount: number;
    /** Processed issues count linked to patient */
    processedCount: number;
    /** Closed issues count linked to patient */
    closedCount: number;
}

/** Describe the current state of the patient's study route */
export class RouteProgressDto implements IRouteProgressDto {
    /** Id of the related patient */
    patientId!: string;
    /** Id of the related study route */
    studyRouteId!: string;
    /** Steps of the route progress */
    steps!: RouteProgressStepDto[];
    /** The multi instance forms */
    multiInstanceForms!: RouteProgressMultiInstanceFormDto[];

    constructor(data?: IRouteProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.steps = [];
            this.multiInstanceForms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.studyRouteId = _data["studyRouteId"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(RouteProgressStepDto.fromJS(item));
            }
            if (Array.isArray(_data["multiInstanceForms"])) {
                this.multiInstanceForms = [] as any;
                for (let item of _data["multiInstanceForms"])
                    this.multiInstanceForms!.push(RouteProgressMultiInstanceFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RouteProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["studyRouteId"] = this.studyRouteId;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.multiInstanceForms)) {
            data["multiInstanceForms"] = [];
            for (let item of this.multiInstanceForms)
                data["multiInstanceForms"].push(item.toJSON());
        }
        return data;
    }
}

/** Describe the current state of the patient's study route */
export interface IRouteProgressDto {
    /** Id of the related patient */
    patientId: string;
    /** Id of the related study route */
    studyRouteId: string;
    /** Steps of the route progress */
    steps: RouteProgressStepDto[];
    /** The multi instance forms */
    multiInstanceForms: RouteProgressMultiInstanceFormDto[];
}

/** Step of a route progress */
export class RouteProgressStepDto implements IRouteProgressStepDto {
    /** Name of the step */
    name!: string;
    /** Short name of the step */
    shortName!: string | null;
    /** State of the step */
    state!: RouteProgressStateEnum;
    /** The date from which the forms can be filled */
    startFrom!: Date | null;
    /** The date from which the forms cannot be edited anymore. */
    editableUntil!: Date | null;
    /** The date when the step transits from state InProgressManually to Done or Missed */
    manuallyOpenedUntil!: Date | null;
    /** The forms that must be filled on this step */
    forms!: RouteProgressFormDto[];
    /** This flag indicates that this step is the final step in the patient's study */
    isFinalStep!: boolean | null;
    /** This flag indicates that all forms can be skipped */
    canSkipAllForms!: boolean | null;
    /** This flag indicates that all forms can be approved */
    canApproveAllSkippedForms!: boolean | null;

    constructor(data?: IRouteProgressStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.state = _data["state"];
            this.startFrom = _data["startFrom"] ? parseDateOnly(_data["startFrom"].toString()) : <any>null;
            this.editableUntil = _data["editableUntil"] ? parseDateOnly(_data["editableUntil"].toString()) : <any>null;
            this.manuallyOpenedUntil = _data["manuallyOpenedUntil"] ? parseDateOnly(_data["manuallyOpenedUntil"].toString()) : <any>null;
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(RouteProgressFormDto.fromJS(item));
            }
            this.isFinalStep = _data["isFinalStep"];
            this.canSkipAllForms = _data["canSkipAllForms"];
            this.canApproveAllSkippedForms = _data["canApproveAllSkippedForms"];
        }
    }

    static fromJS(data: any): RouteProgressStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteProgressStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["state"] = this.state;
        data["startFrom"] = this.startFrom && formatDate(this.startFrom);
        data["editableUntil"] = this.editableUntil && formatDate(this.editableUntil);
        data["manuallyOpenedUntil"] = this.manuallyOpenedUntil && formatDate(this.manuallyOpenedUntil);
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["isFinalStep"] = this.isFinalStep;
        data["canSkipAllForms"] = this.canSkipAllForms;
        data["canApproveAllSkippedForms"] = this.canApproveAllSkippedForms;
        return data;
    }
}

/** Step of a route progress */
export interface IRouteProgressStepDto {
    /** Name of the step */
    name: string;
    /** Short name of the step */
    shortName: string | null;
    /** State of the step */
    state: RouteProgressStateEnum;
    /** The date from which the forms can be filled */
    startFrom: Date | null;
    /** The date from which the forms cannot be edited anymore. */
    editableUntil: Date | null;
    /** The date when the step transits from state InProgressManually to Done or Missed */
    manuallyOpenedUntil: Date | null;
    /** The forms that must be filled on this step */
    forms: RouteProgressFormDto[];
    /** This flag indicates that this step is the final step in the patient's study */
    isFinalStep: boolean | null;
    /** This flag indicates that all forms can be skipped */
    canSkipAllForms: boolean | null;
    /** This flag indicates that all forms can be approved */
    canApproveAllSkippedForms: boolean | null;
}

/** 1 = None 2 = Init 3 = InProgress 4 = Done 5 = Missed 6 = InProgressManually 7 = Unexpected 8 = Approved */
export enum RouteProgressStateEnum {
    None = 1,
    Init = 2,
    InProgress = 3,
    Done = 4,
    Missed = 5,
    InProgressManually = 6,
    Unexpected = 7,
    Approved = 8,
}

/** The form that must be filled on some step */
export class RouteProgressFormDto implements IRouteProgressFormDto {
    /** Id of the form config */
    formConfigId!: number;
    /** Type of the form */
    formType!: string;
    /** Id of another form config that stores shared values (answers).
That answers must be transferred to this form too. */
    formConfigIdForInitialAnswers!: number | null;
    /** Id of the form result if the form is filled on this step */
    formResultId!: number | null;
    /** Progress of filling the form. It can be null when the form is not filled or
progress is failed to calculate */
    fillingProgress!: FillingProgress | null;
    /** The current state of the last version's lifecycle.
It can be null when the form is not filled yet */
    lifecycleState!: FormLifecycleState | null;
    /** This flag indicates that the form can be skipped */
    canBeSkipped!: boolean;
    /** The form is skipped.
It can be null when the form is not filled yet */
    isSkipped!: boolean | null;
    /** Total fields count calculated for not filled form.
It can be null when the progress is failed to calculate */
    initialTotalFieldsCount!: number | null;
    /** The last form result version can be edited without creating new version
null if the form hasn't been filled yet */
    lastVersionIsEditable!: boolean | null;
    /** The last form result version
null if the form hasn't been filled yet */
    lastVersionNumber!: number | null;
    lastMinorVersionNumber!: number | null;

    constructor(data?: IRouteProgressFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formConfigId = _data["formConfigId"];
            this.formType = _data["formType"];
            this.formConfigIdForInitialAnswers = _data["formConfigIdForInitialAnswers"];
            this.formResultId = _data["formResultId"];
            this.fillingProgress = _data["fillingProgress"] ? FillingProgress.fromJS(_data["fillingProgress"]) : <any>null;
            this.lifecycleState = _data["lifecycleState"];
            this.canBeSkipped = _data["canBeSkipped"];
            this.isSkipped = _data["isSkipped"];
            this.initialTotalFieldsCount = _data["initialTotalFieldsCount"];
            this.lastVersionIsEditable = _data["lastVersionIsEditable"];
            this.lastVersionNumber = _data["lastVersionNumber"];
            this.lastMinorVersionNumber = _data["lastMinorVersionNumber"];
        }
    }

    static fromJS(data: any): RouteProgressFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteProgressFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formConfigId"] = this.formConfigId;
        data["formType"] = this.formType;
        data["formConfigIdForInitialAnswers"] = this.formConfigIdForInitialAnswers;
        data["formResultId"] = this.formResultId;
        data["fillingProgress"] = this.fillingProgress ? this.fillingProgress.toJSON() : <any>null;
        data["lifecycleState"] = this.lifecycleState;
        data["canBeSkipped"] = this.canBeSkipped;
        data["isSkipped"] = this.isSkipped;
        data["initialTotalFieldsCount"] = this.initialTotalFieldsCount;
        data["lastVersionIsEditable"] = this.lastVersionIsEditable;
        data["lastVersionNumber"] = this.lastVersionNumber;
        data["lastMinorVersionNumber"] = this.lastMinorVersionNumber;
        return data;
    }
}

/** The form that must be filled on some step */
export interface IRouteProgressFormDto {
    /** Id of the form config */
    formConfigId: number;
    /** Type of the form */
    formType: string;
    /** Id of another form config that stores shared values (answers).
That answers must be transferred to this form too. */
    formConfigIdForInitialAnswers: number | null;
    /** Id of the form result if the form is filled on this step */
    formResultId: number | null;
    /** Progress of filling the form. It can be null when the form is not filled or
progress is failed to calculate */
    fillingProgress: FillingProgress | null;
    /** The current state of the last version's lifecycle.
It can be null when the form is not filled yet */
    lifecycleState: FormLifecycleState | null;
    /** This flag indicates that the form can be skipped */
    canBeSkipped: boolean;
    /** The form is skipped.
It can be null when the form is not filled yet */
    isSkipped: boolean | null;
    /** Total fields count calculated for not filled form.
It can be null when the progress is failed to calculate */
    initialTotalFieldsCount: number | null;
    /** The last form result version can be edited without creating new version
null if the form hasn't been filled yet */
    lastVersionIsEditable: boolean | null;
    /** The last form result version
null if the form hasn't been filled yet */
    lastVersionNumber: number | null;
    lastMinorVersionNumber: number | null;
}

/** The multi instance form */
export class RouteProgressMultiInstanceFormDto implements IRouteProgressMultiInstanceFormDto {
    /** Id of the form config. */
    formConfigId!: number;
    /** Form config type. */
    formType!: string;
    /** Ids of the related form results */
    formResultIds!: number[];
    /** Flag that indicates that it is allowed to fill the form. */
    isAvailableForFilling!: boolean;
    /** The aggregated life circle state of the multiple forms
It can be null when the form is not filled yet */
    aggregatedLifecycleState!: FormLifecycleState | null;

    constructor(data?: IRouteProgressMultiInstanceFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formResultIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formConfigId = _data["formConfigId"];
            this.formType = _data["formType"];
            if (Array.isArray(_data["formResultIds"])) {
                this.formResultIds = [] as any;
                for (let item of _data["formResultIds"])
                    this.formResultIds!.push(item);
            }
            this.isAvailableForFilling = _data["isAvailableForFilling"];
            this.aggregatedLifecycleState = _data["aggregatedLifecycleState"];
        }
    }

    static fromJS(data: any): RouteProgressMultiInstanceFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteProgressMultiInstanceFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formConfigId"] = this.formConfigId;
        data["formType"] = this.formType;
        if (Array.isArray(this.formResultIds)) {
            data["formResultIds"] = [];
            for (let item of this.formResultIds)
                data["formResultIds"].push(item);
        }
        data["isAvailableForFilling"] = this.isAvailableForFilling;
        data["aggregatedLifecycleState"] = this.aggregatedLifecycleState;
        return data;
    }
}

/** The multi instance form */
export interface IRouteProgressMultiInstanceFormDto {
    /** Id of the form config. */
    formConfigId: number;
    /** Form config type. */
    formType: string;
    /** Ids of the related form results */
    formResultIds: number[];
    /** Flag that indicates that it is allowed to fill the form. */
    isAvailableForFilling: boolean;
    /** The aggregated life circle state of the multiple forms
It can be null when the form is not filled yet */
    aggregatedLifecycleState: FormLifecycleState | null;
}

export class PerformIssueOperationDto implements IPerformIssueOperationDto {
    /** Description of the action that was taken */
    action!: string;
    /** Comment for the action */
    comment?: string | null;

    constructor(data?: IPerformIssueOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): PerformIssueOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformIssueOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IPerformIssueOperationDto {
    /** Description of the action that was taken */
    action: string;
    /** Comment for the action */
    comment?: string | null;
}

export class IssueHistoryDto implements IIssueHistoryDto {
    /** Id of the issue */
    issueId!: number;
    /** Action list */
    actions!: IssueHistoryActionDto[];

    constructor(data?: IIssueHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.actions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(IssueHistoryActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssueHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIssueHistoryDto {
    /** Id of the issue */
    issueId: number;
    /** Action list */
    actions: IssueHistoryActionDto[];
}

export class IssueHistoryActionDto implements IIssueHistoryActionDto {
    /** Time when the action was performed */
    takenAt!: Date;
    /** The user who performed the action */
    takenByUser!: string;
    /** Action description */
    description!: string | null;
    /** Action type */
    type!: IssueHistoryActionTypeEnum;

    constructor(data?: IIssueHistoryActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.takenAt = _data["takenAt"] ? new Date(_data["takenAt"].toString()) : <any>null;
            this.takenByUser = _data["takenByUser"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IssueHistoryActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueHistoryActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["takenAt"] = this.takenAt && this.takenAt.toISOString();
        data["takenByUser"] = this.takenByUser;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface IIssueHistoryActionDto {
    /** Time when the action was performed */
    takenAt: Date;
    /** The user who performed the action */
    takenByUser: string;
    /** Action description */
    description: string | null;
    /** Action type */
    type: IssueHistoryActionTypeEnum;
}

/** 1 = Opened 2 = Processed 3 = Rejected 4 = Closed */
export enum IssueHistoryActionTypeEnum {
    Opened = 1,
    Processed = 2,
    Rejected = 3,
    Closed = 4,
}

export class IssueCommentDto implements IIssueCommentDto {
    /** Id of the comment */
    id!: number;
    /** Date when the comment has been created */
    createdAt!: Date;
    /** Full name of the user who create the comment */
    createdByUser!: string;
    /** Id of the user who create the comment */
    createdByUserId!: string;
    /** Message of the comment */
    message!: string;
    /** The Id of the related issue */
    issueId!: number;
    /** The flag indicates that the comment can be deleted */
    canDelete!: boolean;

    constructor(data?: IIssueCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.createdByUser = _data["createdByUser"];
            this.createdByUserId = _data["createdByUserId"];
            this.message = _data["message"];
            this.issueId = _data["issueId"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): IssueCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["createdByUser"] = this.createdByUser;
        data["createdByUserId"] = this.createdByUserId;
        data["message"] = this.message;
        data["issueId"] = this.issueId;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IIssueCommentDto {
    /** Id of the comment */
    id: number;
    /** Date when the comment has been created */
    createdAt: Date;
    /** Full name of the user who create the comment */
    createdByUser: string;
    /** Id of the user who create the comment */
    createdByUserId: string;
    /** Message of the comment */
    message: string;
    /** The Id of the related issue */
    issueId: number;
    /** The flag indicates that the comment can be deleted */
    canDelete: boolean;
}

export class MonitoringFormDto implements IMonitoringFormDto {
    id!: string;
    studyId!: number;
    filledBy!: DoctorDto;
    createdAt!: Date;
    updatedAt!: Date;
    type!: string;
    value!: { [key: string]: any; };
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };

    constructor(data?: IMonitoringFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filledBy = new DoctorDto();
            this.value = {};
            this.fieldSkipReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.filledBy = _data["filledBy"] ? DoctorDto.fromJS(_data["filledBy"]) : new DoctorDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.type = _data["type"];
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
        }
    }

    static fromJS(data: any): MonitoringFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["filledBy"] = this.filledBy ? this.filledBy.toJSON() : <any>null;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        data["type"] = this.type;
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        return data;
    }
}

export interface IMonitoringFormDto {
    id: string;
    studyId: number;
    filledBy: DoctorDto;
    createdAt: Date;
    updatedAt: Date;
    type: string;
    value: { [key: string]: any; };
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
}

export class CreateMonitoringFormDto implements ICreateMonitoringFormDto {
    studyId!: number;
    type!: string;
    value!: { [key: string]: any; };
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };

    constructor(data?: ICreateMonitoringFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = {};
            this.fieldSkipReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.type = _data["type"];
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateMonitoringFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMonitoringFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["type"] = this.type;
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        return data;
    }
}

export interface ICreateMonitoringFormDto {
    studyId: number;
    type: string;
    value: { [key: string]: any; };
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
}

export class UpdateMonitoringFormDto implements IUpdateMonitoringFormDto {
    value!: { [key: string]: any; };
    fieldSkipReasons!: { [key: string]: FieldSkipReason; };

    constructor(data?: IUpdateMonitoringFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = {};
            this.fieldSkipReasons = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateMonitoringFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonitoringFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        return data;
    }
}

export interface IUpdateMonitoringFormDto {
    value: { [key: string]: any; };
    fieldSkipReasons: { [key: string]: FieldSkipReason; };
}

export class PagedResultOfNotificationDto implements IPagedResultOfNotificationDto {
    data!: NotificationDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfNotificationDto {
    data: NotificationDto[];
    totalCount: number;
}

export class NotificationDto implements INotificationDto {
    /** Answer Id. */
    id!: number;
    /** Id of the study, that current notification is related. */
    studyId!: number;
    /** Notification read status */
    isRead!: boolean;
    /** Notification type */
    type!: NotificationType;
    /** Notification data */
    data!: { [key: string]: string; } | null;
    /** Notification read date */
    readAt?: Date | null;
    /** Notification send date */
    sentAt?: Date | null;
    /** Notification creation date */
    createdAt!: Date;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.isRead = _data["isRead"];
            this.type = _data["type"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.readAt = _data["readAt"] ? new Date(_data["readAt"].toString()) : <any>null;
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["isRead"] = this.isRead;
        data["type"] = this.type;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["readAt"] = this.readAt && this.readAt.toISOString();
        data["sentAt"] = this.sentAt && this.sentAt.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        return data;
    }
}

export interface INotificationDto {
    /** Answer Id. */
    id: number;
    /** Id of the study, that current notification is related. */
    studyId: number;
    /** Notification read status */
    isRead: boolean;
    /** Notification type */
    type: NotificationType;
    /** Notification data */
    data: { [key: string]: string; } | null;
    /** Notification read date */
    readAt?: Date | null;
    /** Notification send date */
    sentAt?: Date | null;
    /** Notification creation date */
    createdAt: Date;
}

/** 1 = Other 2 = PrismaCloudCheck 3 = PrismaCheck 4 = NewSurveyAssigned 5 = SurveyIsExpired 6 = NewIssueComment 7 = IssueDeadline 8 = FormDeadline */
export enum NotificationType {
    Other = 1,
    PrismaCloudCheck = 2,
    PrismaCheck = 3,
    NewSurveyAssigned = 4,
    SurveyIsExpired = 5,
    NewIssueComment = 6,
    IssueDeadline = 7,
    FormDeadline = 8,
}

/** Notification batch that can be used to display to a user one notification instead of many ones of the same type */
export class NotificationBatchDto implements INotificationBatchDto {
    /** Type of the notifications */
    type!: NotificationType;
    /** Id of the user who notifications are */
    userId!: string;
    /** Ids of notifications that the batch is made from.
They can be used, as example, to mark the notifications as read
or to query details that are contained in them. */
    sourceNotificationIds!: number[];
    /** Payload of the batch that is aggregated from payloads of the source notifications */
    payload!: { [key: string]: string; };

    constructor(data?: INotificationBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceNotificationIds = [];
            this.payload = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["sourceNotificationIds"])) {
                this.sourceNotificationIds = [] as any;
                for (let item of _data["sourceNotificationIds"])
                    this.sourceNotificationIds!.push(item);
            }
            if (_data["payload"]) {
                this.payload = {} as any;
                for (let key in _data["payload"]) {
                    if (_data["payload"].hasOwnProperty(key))
                        (<any>this.payload)![key] = _data["payload"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationBatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationBatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userId"] = this.userId;
        if (Array.isArray(this.sourceNotificationIds)) {
            data["sourceNotificationIds"] = [];
            for (let item of this.sourceNotificationIds)
                data["sourceNotificationIds"].push(item);
        }
        if (this.payload) {
            data["payload"] = {};
            for (let key in this.payload) {
                if (this.payload.hasOwnProperty(key))
                    (<any>data["payload"])[key] = (<any>this.payload)[key];
            }
        }
        return data;
    }
}

/** Notification batch that can be used to display to a user one notification instead of many ones of the same type */
export interface INotificationBatchDto {
    /** Type of the notifications */
    type: NotificationType;
    /** Id of the user who notifications are */
    userId: string;
    /** Ids of notifications that the batch is made from.
They can be used, as example, to mark the notifications as read
or to query details that are contained in them. */
    sourceNotificationIds: number[];
    /** Payload of the batch that is aggregated from payloads of the source notifications */
    payload: { [key: string]: string; };
}

/** 1 = MobilePush */
export enum NotificationDeliveryType {
    MobilePush = 1,
}

/** Counts of notifications of a concrete type */
export class NotificationCountsByTypeDto implements INotificationCountsByTypeDto {
    type!: NotificationType;
    /** A count of read notifications of this type */
    read!: number;
    /** A count of unread notifications of this type */
    unread!: number;

    constructor(data?: INotificationCountsByTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.read = _data["read"];
            this.unread = _data["unread"];
        }
    }

    static fromJS(data: any): NotificationCountsByTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCountsByTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["read"] = this.read;
        data["unread"] = this.unread;
        return data;
    }
}

/** Counts of notifications of a concrete type */
export interface INotificationCountsByTypeDto {
    type: NotificationType;
    /** A count of read notifications of this type */
    read: number;
    /** A count of unread notifications of this type */
    unread: number;
}

export class UserPushTokenDto implements IUserPushTokenDto {
    /** Platform of push token binding. */
    platform!: MobilePlatform;
    /** FCM push notification token. */
    pushToken!: string;
    /** Language of push notification for the current binding. */
    language!: string;

    constructor(data?: IUserPushTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.pushToken = _data["pushToken"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UserPushTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPushTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["pushToken"] = this.pushToken;
        data["language"] = this.language;
        return data;
    }
}

export interface IUserPushTokenDto {
    /** Platform of push token binding. */
    platform: MobilePlatform;
    /** FCM push notification token. */
    pushToken: string;
    /** Language of push notification for the current binding. */
    language: string;
}

/** 0 = Unknown 1 = Android 2 = iOS */
export enum MobilePlatform {
    Unknown = 0,
    Android = 1,
    IOS = 2,
}

export class SendPushTokenDto implements ISendPushTokenDto {
    /** FCM token. */
    token!: string;
    /** User's phone platform. */
    platform!: MobilePlatform;
    /** Application language at the push token sending moment. All further */
    lastKnownLanguage!: string | null;

    constructor(data?: ISendPushTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.platform = _data["platform"];
            this.lastKnownLanguage = _data["lastKnownLanguage"];
        }
    }

    static fromJS(data: any): SendPushTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendPushTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["platform"] = this.platform;
        data["lastKnownLanguage"] = this.lastKnownLanguage;
        return data;
    }
}

export interface ISendPushTokenDto {
    /** FCM token. */
    token: string;
    /** User's phone platform. */
    platform: MobilePlatform;
    /** Application language at the push token sending moment. All further */
    lastKnownLanguage: string | null;
}

export class PagedResultOfParticipantDto implements IPagedResultOfParticipantDto {
    data!: ParticipantDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ParticipantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfParticipantDto {
    data: ParticipantDto[];
    totalCount: number;
}

export class ParticipantDto implements IParticipantDto {
    id!: string;
    fullName!: string;
    email!: string;
    tasks!: string[];
    tasksComment?: string | null;
    function!: string;
    functionComment?: string | null;
    onboardedOn!: Date;
    offboardedOn!: Date | null;
    studyId!: number;
    attachments!: FileDto[];

    constructor(data?: IParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tasks = [];
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.tasksComment = _data["tasksComment"];
            this.function = _data["function"];
            this.functionComment = _data["functionComment"];
            this.onboardedOn = _data["onboardedOn"] ? parseDateOnly(_data["onboardedOn"].toString()) : <any>null;
            this.offboardedOn = _data["offboardedOn"] ? parseDateOnly(_data["offboardedOn"].toString()) : <any>null;
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["tasksComment"] = this.tasksComment;
        data["function"] = this.function;
        data["functionComment"] = this.functionComment;
        data["onboardedOn"] = this.onboardedOn && formatDate(this.onboardedOn);
        data["offboardedOn"] = this.offboardedOn && formatDate(this.offboardedOn);
        data["studyId"] = this.studyId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipantDto {
    id: string;
    fullName: string;
    email: string;
    tasks: string[];
    tasksComment?: string | null;
    function: string;
    functionComment?: string | null;
    onboardedOn: Date;
    offboardedOn: Date | null;
    studyId: number;
    attachments: FileDto[];
}

export class CreateParticipantsRequestDto implements ICreateParticipantsRequestDto {
    fullName!: string;
    email!: string;
    tasks!: string[];
    tasksComment?: string | null;
    function!: string;
    functionComment?: string | null;
    onboardedOn!: Date;
    offboardedOn?: Date | null;
    studyId!: number;

    constructor(data?: ICreateParticipantsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.tasksComment = _data["tasksComment"];
            this.function = _data["function"];
            this.functionComment = _data["functionComment"];
            this.onboardedOn = _data["onboardedOn"] ? parseDateOnly(_data["onboardedOn"].toString()) : <any>null;
            this.offboardedOn = _data["offboardedOn"] ? parseDateOnly(_data["offboardedOn"].toString()) : <any>null;
            this.studyId = _data["studyId"];
        }
    }

    static fromJS(data: any): CreateParticipantsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParticipantsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["tasksComment"] = this.tasksComment;
        data["function"] = this.function;
        data["functionComment"] = this.functionComment;
        data["onboardedOn"] = this.onboardedOn && formatDate(this.onboardedOn);
        data["offboardedOn"] = this.offboardedOn && formatDate(this.offboardedOn);
        data["studyId"] = this.studyId;
        return data;
    }
}

export interface ICreateParticipantsRequestDto {
    fullName: string;
    email: string;
    tasks: string[];
    tasksComment?: string | null;
    function: string;
    functionComment?: string | null;
    onboardedOn: Date;
    offboardedOn?: Date | null;
    studyId: number;
}

export class UpdateParticipantRequestDto implements IUpdateParticipantRequestDto {
    fullName!: string;
    email!: string;
    tasks!: string[];
    tasksComment?: string | null;
    function!: string;
    functionComment?: string | null;
    onboardedOn!: Date;
    offboardedOn!: Date | null;
    attachmentIdsToDelete!: string[] | null;

    constructor(data?: IUpdateParticipantRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.tasksComment = _data["tasksComment"];
            this.function = _data["function"];
            this.functionComment = _data["functionComment"];
            this.onboardedOn = _data["onboardedOn"] ? parseDateOnly(_data["onboardedOn"].toString()) : <any>null;
            this.offboardedOn = _data["offboardedOn"] ? parseDateOnly(_data["offboardedOn"].toString()) : <any>null;
            if (Array.isArray(_data["attachmentIdsToDelete"])) {
                this.attachmentIdsToDelete = [] as any;
                for (let item of _data["attachmentIdsToDelete"])
                    this.attachmentIdsToDelete!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateParticipantRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["tasksComment"] = this.tasksComment;
        data["function"] = this.function;
        data["functionComment"] = this.functionComment;
        data["onboardedOn"] = this.onboardedOn && formatDate(this.onboardedOn);
        data["offboardedOn"] = this.offboardedOn && formatDate(this.offboardedOn);
        if (Array.isArray(this.attachmentIdsToDelete)) {
            data["attachmentIdsToDelete"] = [];
            for (let item of this.attachmentIdsToDelete)
                data["attachmentIdsToDelete"].push(item);
        }
        return data;
    }
}

export interface IUpdateParticipantRequestDto {
    fullName: string;
    email: string;
    tasks: string[];
    tasksComment?: string | null;
    function: string;
    functionComment?: string | null;
    onboardedOn: Date;
    offboardedOn: Date | null;
    attachmentIdsToDelete: string[] | null;
}

export class PatientListDto implements IPatientListDto {
    /** Id of user. */
    id!: string;
    /** Patient's group */
    group!: number;
    /** Study start date for patient. */
    studyStartedAt!: Date | null;
    /** Actual Study finish date for patient. */
    studyFinishedAt!: Date | null;
    /** Planning Study finish date. */
    studyFinishDate!: Date | null;
    /** Flag indicating that the study is finished */
    isStudyFinished!: boolean;
    /** Date and time when the patient was archived (server UTC time). */
    archivedAt!: Date | null;
    /** Stuff who archived the patient */
    archivedBy!: DoctorDto | null;
    /** Flag indicating that the study is started */
    isStudyStarted!: boolean;
    /** Flag indicating that the patient can be archived */
    canArchive!: boolean;
    /** Flag indicating that the patient can finish the study */
    canFinishStudy!: boolean;
    /** Reason why study was finished.
Null - study was planning finished */
    studyFinishedDescription!: string | null;
    /** Date of contract signed */
    contractSignedAt!: Date | null;
    /** Date When Patient was created. */
    createdAt!: Date;
    /** Date and time when patient has visited app last time.
NULL - if patient has never logged in. */
    lastVisitDateTime!: Date | null;
    /** Id of study, where patient has included. */
    studyId!: number;
    /** Unique id of patient in the current study . */
    uniqueId!: string;
    /** Assigned patient's device serial number. */
    deviceSerialNumber!: string | null;
    /** Number of minutes device usage by patient. */
    compliance!: IndicatorModel | null;
    /** Number of liters per hour during device usage. */
    leakage!: IndicatorModel | null;
    /** Number of apnia events per hour during device usage. */
    ahi!: IndicatorModel | null;
    /** Day of first available data from device that came into PrismaCLoud system. */
    firstTherapyDay!: Date | null;
    /** Day of last available data from device that came into PrismaCLoud system. */
    lastTherapyDay!: Date | null;
    /** Flag that indicates is access code (for mobile app) has been generated or not. */
    codeGenerated!: boolean;
    /** List of patient's survey indicators fro dashboard. */
    surveyIndicators!: SurveyIndicatorModel[];
    /** Last note field values to display in "Last note" column */
    lastNoteFields!: { [key: string]: any; } | null;
    /** Patient's category result */
    category!: CategorizationResultModel | null;
    /** Patient assigned filters */
    filters!: PatientFilterStatus;
    /** Additional data that is attached to patients
to filter them and restrict access of doctor to patient
according to tag filters of the doctor */
    tags!: TagFiltersDto | null;
    /** Current state of the study route */
    studyRouteProgress!: RouteProgressDto;
    /** Last date and time when changes has been performed for this patient (or  related entities).
Time provided from server by UTC */
    changedAt!: Date;
    /** User's Id who made a changes */
    changedBy!: string;
    /** Set of events that triggered last changes (update) */
    changeEvent!: PatientChangesEvent;
    /** This flag indicates that all issues for this patient are closed */
    allIssuesAreClosed!: boolean;
    /** This flag indicates that patient is ready for review or release */
    monitoringReviewStatus!: MonitoringReviewStatusEnum;

    constructor(data?: IPatientListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyIndicators = [];
            this.filters = new PatientFilterStatus();
            this.studyRouteProgress = new RouteProgressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"];
            this.studyStartedAt = _data["studyStartedAt"] ? parseDateOnly(_data["studyStartedAt"].toString()) : <any>null;
            this.studyFinishedAt = _data["studyFinishedAt"] ? new Date(_data["studyFinishedAt"].toString()) : <any>null;
            this.studyFinishDate = _data["studyFinishDate"] ? parseDateOnly(_data["studyFinishDate"].toString()) : <any>null;
            this.isStudyFinished = _data["isStudyFinished"];
            this.archivedAt = _data["archivedAt"] ? new Date(_data["archivedAt"].toString()) : <any>null;
            this.archivedBy = _data["archivedBy"] ? DoctorDto.fromJS(_data["archivedBy"]) : <any>null;
            this.isStudyStarted = _data["isStudyStarted"];
            this.canArchive = _data["canArchive"];
            this.canFinishStudy = _data["canFinishStudy"];
            this.studyFinishedDescription = _data["studyFinishedDescription"];
            this.contractSignedAt = _data["contractSignedAt"] ? parseDateOnly(_data["contractSignedAt"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.lastVisitDateTime = _data["lastVisitDateTime"] ? new Date(_data["lastVisitDateTime"].toString()) : <any>null;
            this.studyId = _data["studyId"];
            this.uniqueId = _data["uniqueId"];
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.compliance = _data["compliance"] ? IndicatorModel.fromJS(_data["compliance"]) : <any>null;
            this.leakage = _data["leakage"] ? IndicatorModel.fromJS(_data["leakage"]) : <any>null;
            this.ahi = _data["ahi"] ? IndicatorModel.fromJS(_data["ahi"]) : <any>null;
            this.firstTherapyDay = _data["firstTherapyDay"] ? parseDateOnly(_data["firstTherapyDay"].toString()) : <any>null;
            this.lastTherapyDay = _data["lastTherapyDay"] ? parseDateOnly(_data["lastTherapyDay"].toString()) : <any>null;
            this.codeGenerated = _data["codeGenerated"];
            if (Array.isArray(_data["surveyIndicators"])) {
                this.surveyIndicators = [] as any;
                for (let item of _data["surveyIndicators"])
                    this.surveyIndicators!.push(SurveyIndicatorModel.fromJS(item));
            }
            if (_data["lastNoteFields"]) {
                this.lastNoteFields = {} as any;
                for (let key in _data["lastNoteFields"]) {
                    if (_data["lastNoteFields"].hasOwnProperty(key))
                        (<any>this.lastNoteFields)![key] = _data["lastNoteFields"][key];
                }
            }
            this.category = _data["category"] ? CategorizationResultModel.fromJS(_data["category"]) : <any>null;
            this.filters = _data["filters"] ? PatientFilterStatus.fromJS(_data["filters"]) : new PatientFilterStatus();
            this.tags = _data["tags"] ? TagFiltersDto.fromJS(_data["tags"]) : <any>null;
            this.studyRouteProgress = _data["studyRouteProgress"] ? RouteProgressDto.fromJS(_data["studyRouteProgress"]) : new RouteProgressDto();
            this.changedAt = _data["changedAt"] ? new Date(_data["changedAt"].toString()) : <any>null;
            this.changedBy = _data["changedBy"];
            this.changeEvent = _data["changeEvent"];
            this.allIssuesAreClosed = _data["allIssuesAreClosed"];
            this.monitoringReviewStatus = _data["monitoringReviewStatus"];
        }
    }

    static fromJS(data: any): PatientListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group;
        data["studyStartedAt"] = this.studyStartedAt && formatDate(this.studyStartedAt);
        data["studyFinishedAt"] = this.studyFinishedAt && this.studyFinishedAt.toISOString();
        data["studyFinishDate"] = this.studyFinishDate && formatDate(this.studyFinishDate);
        data["isStudyFinished"] = this.isStudyFinished;
        data["archivedAt"] = this.archivedAt && this.archivedAt.toISOString();
        data["archivedBy"] = this.archivedBy ? this.archivedBy.toJSON() : <any>null;
        data["isStudyStarted"] = this.isStudyStarted;
        data["canArchive"] = this.canArchive;
        data["canFinishStudy"] = this.canFinishStudy;
        data["studyFinishedDescription"] = this.studyFinishedDescription;
        data["contractSignedAt"] = this.contractSignedAt && formatDate(this.contractSignedAt);
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["lastVisitDateTime"] = this.lastVisitDateTime && this.lastVisitDateTime.toISOString();
        data["studyId"] = this.studyId;
        data["uniqueId"] = this.uniqueId;
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["compliance"] = this.compliance ? this.compliance.toJSON() : <any>null;
        data["leakage"] = this.leakage ? this.leakage.toJSON() : <any>null;
        data["ahi"] = this.ahi ? this.ahi.toJSON() : <any>null;
        data["firstTherapyDay"] = this.firstTherapyDay && formatDate(this.firstTherapyDay);
        data["lastTherapyDay"] = this.lastTherapyDay && formatDate(this.lastTherapyDay);
        data["codeGenerated"] = this.codeGenerated;
        if (Array.isArray(this.surveyIndicators)) {
            data["surveyIndicators"] = [];
            for (let item of this.surveyIndicators)
                data["surveyIndicators"].push(item.toJSON());
        }
        if (this.lastNoteFields) {
            data["lastNoteFields"] = {};
            for (let key in this.lastNoteFields) {
                if (this.lastNoteFields.hasOwnProperty(key))
                    (<any>data["lastNoteFields"])[key] = (<any>this.lastNoteFields)[key];
            }
        }
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>null;
        data["tags"] = this.tags ? this.tags.toJSON() : <any>null;
        data["studyRouteProgress"] = this.studyRouteProgress ? this.studyRouteProgress.toJSON() : <any>null;
        data["changedAt"] = this.changedAt && this.changedAt.toISOString();
        data["changedBy"] = this.changedBy;
        data["changeEvent"] = this.changeEvent;
        data["allIssuesAreClosed"] = this.allIssuesAreClosed;
        data["monitoringReviewStatus"] = this.monitoringReviewStatus;
        return data;
    }
}

export interface IPatientListDto {
    /** Id of user. */
    id: string;
    /** Patient's group */
    group: number;
    /** Study start date for patient. */
    studyStartedAt: Date | null;
    /** Actual Study finish date for patient. */
    studyFinishedAt: Date | null;
    /** Planning Study finish date. */
    studyFinishDate: Date | null;
    /** Flag indicating that the study is finished */
    isStudyFinished: boolean;
    /** Date and time when the patient was archived (server UTC time). */
    archivedAt: Date | null;
    /** Stuff who archived the patient */
    archivedBy: DoctorDto | null;
    /** Flag indicating that the study is started */
    isStudyStarted: boolean;
    /** Flag indicating that the patient can be archived */
    canArchive: boolean;
    /** Flag indicating that the patient can finish the study */
    canFinishStudy: boolean;
    /** Reason why study was finished.
Null - study was planning finished */
    studyFinishedDescription: string | null;
    /** Date of contract signed */
    contractSignedAt: Date | null;
    /** Date When Patient was created. */
    createdAt: Date;
    /** Date and time when patient has visited app last time.
NULL - if patient has never logged in. */
    lastVisitDateTime: Date | null;
    /** Id of study, where patient has included. */
    studyId: number;
    /** Unique id of patient in the current study . */
    uniqueId: string;
    /** Assigned patient's device serial number. */
    deviceSerialNumber: string | null;
    /** Number of minutes device usage by patient. */
    compliance: IndicatorModel | null;
    /** Number of liters per hour during device usage. */
    leakage: IndicatorModel | null;
    /** Number of apnia events per hour during device usage. */
    ahi: IndicatorModel | null;
    /** Day of first available data from device that came into PrismaCLoud system. */
    firstTherapyDay: Date | null;
    /** Day of last available data from device that came into PrismaCLoud system. */
    lastTherapyDay: Date | null;
    /** Flag that indicates is access code (for mobile app) has been generated or not. */
    codeGenerated: boolean;
    /** List of patient's survey indicators fro dashboard. */
    surveyIndicators: SurveyIndicatorModel[];
    /** Last note field values to display in "Last note" column */
    lastNoteFields: { [key: string]: any; } | null;
    /** Patient's category result */
    category: CategorizationResultModel | null;
    /** Patient assigned filters */
    filters: PatientFilterStatus;
    /** Additional data that is attached to patients
to filter them and restrict access of doctor to patient
according to tag filters of the doctor */
    tags: TagFiltersDto | null;
    /** Current state of the study route */
    studyRouteProgress: RouteProgressDto;
    /** Last date and time when changes has been performed for this patient (or  related entities).
Time provided from server by UTC */
    changedAt: Date;
    /** User's Id who made a changes */
    changedBy: string;
    /** Set of events that triggered last changes (update) */
    changeEvent: PatientChangesEvent;
    /** This flag indicates that all issues for this patient are closed */
    allIssuesAreClosed: boolean;
    /** This flag indicates that patient is ready for review or release */
    monitoringReviewStatus: MonitoringReviewStatusEnum;
}

export class IndicatorModel implements IIndicatorModel {
    /** Numeric value of indicator. */
    value!: number;
    /** Calculated score value. */
    qualityMetric!: QualityMetric;
    /** Date range number of aggregation */
    numberOfAggregatedDays!: number;
    /** Indicates that there were not data for given last N-days of aggregation.
Let's imagine we are talking about therapy data (usage or leakage).
And aggregation period is 3 days.
            
We have got data but for week ago. It means that device didn't send data to us about week.
In this case it will be TRUE. */
    therapyIsNotReceivedForAggregatedPeriod!: boolean;
    /** Indicates that device sent data to us for aggregated period, but with 0-usage. */
    deviceIsNotUsedForAggregatedPeriod!: boolean;
    /** Indicates that Tele-monitoring data from the device will be hidden */
    telemonitoringIsDisabled!: boolean;
    /** List of single-days metrics by aggregated period. */
    therapyDayValues!: TherapyDashboardModel[];

    constructor(data?: IIndicatorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.therapyDayValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.qualityMetric = _data["qualityMetric"];
            this.numberOfAggregatedDays = _data["numberOfAggregatedDays"];
            this.therapyIsNotReceivedForAggregatedPeriod = _data["therapyIsNotReceivedForAggregatedPeriod"];
            this.deviceIsNotUsedForAggregatedPeriod = _data["deviceIsNotUsedForAggregatedPeriod"];
            this.telemonitoringIsDisabled = _data["telemonitoringIsDisabled"];
            if (Array.isArray(_data["therapyDayValues"])) {
                this.therapyDayValues = [] as any;
                for (let item of _data["therapyDayValues"])
                    this.therapyDayValues!.push(TherapyDashboardModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndicatorModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["qualityMetric"] = this.qualityMetric;
        data["numberOfAggregatedDays"] = this.numberOfAggregatedDays;
        data["therapyIsNotReceivedForAggregatedPeriod"] = this.therapyIsNotReceivedForAggregatedPeriod;
        data["deviceIsNotUsedForAggregatedPeriod"] = this.deviceIsNotUsedForAggregatedPeriod;
        data["telemonitoringIsDisabled"] = this.telemonitoringIsDisabled;
        if (Array.isArray(this.therapyDayValues)) {
            data["therapyDayValues"] = [];
            for (let item of this.therapyDayValues)
                data["therapyDayValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIndicatorModel {
    /** Numeric value of indicator. */
    value: number;
    /** Calculated score value. */
    qualityMetric: QualityMetric;
    /** Date range number of aggregation */
    numberOfAggregatedDays: number;
    /** Indicates that there were not data for given last N-days of aggregation.
Let's imagine we are talking about therapy data (usage or leakage).
And aggregation period is 3 days.
            
We have got data but for week ago. It means that device didn't send data to us about week.
In this case it will be TRUE. */
    therapyIsNotReceivedForAggregatedPeriod: boolean;
    /** Indicates that device sent data to us for aggregated period, but with 0-usage. */
    deviceIsNotUsedForAggregatedPeriod: boolean;
    /** Indicates that Tele-monitoring data from the device will be hidden */
    telemonitoringIsDisabled: boolean;
    /** List of single-days metrics by aggregated period. */
    therapyDayValues: TherapyDashboardModel[];
}

export class TherapyDashboardModel implements ITherapyDashboardModel {
    /** QualityIndicator value. */
    quality!: QualityMetric | null;
    /** Therapy date for which leakage values are displayed. */
    therapyDate!: Date;
    /** Anonymous object for Indicator characteristic */
    values!: { [key: string]: any; };

    constructor(data?: ITherapyDashboardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quality = _data["quality"];
            this.therapyDate = _data["therapyDate"] ? parseDateOnly(_data["therapyDate"].toString()) : <any>null;
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): TherapyDashboardModel {
        data = typeof data === 'object' ? data : {};
        let result = new TherapyDashboardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quality"] = this.quality;
        data["therapyDate"] = this.therapyDate && formatDate(this.therapyDate);
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }
}

export interface ITherapyDashboardModel {
    /** QualityIndicator value. */
    quality: QualityMetric | null;
    /** Therapy date for which leakage values are displayed. */
    therapyDate: Date;
    /** Anonymous object for Indicator characteristic */
    values: { [key: string]: any; };
}

export class SurveyIndicatorModel implements ISurveyIndicatorModel {
    /** Indicates that user has already filled last survey or not. */
    isSurveyFilled!: boolean;
    /** Type of survey. */
    surveyType!: SurveyType;
    /** Type of survey (in human readable format). */
    surveyTypeText!: string;
    /** Numeric value of indicator. */
    value!: number | null;
    /** Quality corresponding to the score value. */
    qualityMetric!: QualityMetric;
    /** Status of score calculation */
    scoreStatus!: ScoreCalculationStatusEnum;
    /** Indicates that survey close to be expired. */
    isSurveyCloseToExpired!: boolean;
    /** Indicates that patient missed survey filling. */
    hasSurveyAlreadyExpired!: boolean;
    /** Number of days that survey must be filled.
If it is negative - it means that survey has already expired.
If it is 0 - it means that today last day before expiration.
If it is positive - it describes number of days BEFORE expiring. */
    daysBeforeExpiring!: number;
    /** Number of days during which survey must be shown with "expired" state. */
    expiredStateDisplayDurationInDays!: number;
    /** Date when survey was answered. */
    fillingDate!: Date | null;
    /** Date when survey must be answered. */
    untilDate!: Date;
    /** Percentage of survey filling. */
    percentage!: number | null;
    /** Answer id */
    answerId!: number | null;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation!: boolean;

    constructor(data?: ISurveyIndicatorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSurveyFilled = _data["isSurveyFilled"];
            this.surveyType = _data["surveyType"];
            this.surveyTypeText = _data["surveyTypeText"];
            this.value = _data["value"];
            this.qualityMetric = _data["qualityMetric"];
            this.scoreStatus = _data["scoreStatus"];
            this.isSurveyCloseToExpired = _data["isSurveyCloseToExpired"];
            this.hasSurveyAlreadyExpired = _data["hasSurveyAlreadyExpired"];
            this.daysBeforeExpiring = _data["daysBeforeExpiring"];
            this.expiredStateDisplayDurationInDays = _data["expiredStateDisplayDurationInDays"];
            this.fillingDate = _data["fillingDate"] ? new Date(_data["fillingDate"].toString()) : <any>null;
            this.untilDate = _data["untilDate"] ? parseDateOnly(_data["untilDate"].toString()) : <any>null;
            this.percentage = _data["percentage"];
            this.answerId = _data["answerId"];
            this.canRetryScoreCalculation = _data["canRetryScoreCalculation"];
        }
    }

    static fromJS(data: any): SurveyIndicatorModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyIndicatorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSurveyFilled"] = this.isSurveyFilled;
        data["surveyType"] = this.surveyType;
        data["surveyTypeText"] = this.surveyTypeText;
        data["value"] = this.value;
        data["qualityMetric"] = this.qualityMetric;
        data["scoreStatus"] = this.scoreStatus;
        data["isSurveyCloseToExpired"] = this.isSurveyCloseToExpired;
        data["hasSurveyAlreadyExpired"] = this.hasSurveyAlreadyExpired;
        data["daysBeforeExpiring"] = this.daysBeforeExpiring;
        data["expiredStateDisplayDurationInDays"] = this.expiredStateDisplayDurationInDays;
        data["fillingDate"] = this.fillingDate && this.fillingDate.toISOString();
        data["untilDate"] = this.untilDate && formatDate(this.untilDate);
        data["percentage"] = this.percentage;
        data["answerId"] = this.answerId;
        data["canRetryScoreCalculation"] = this.canRetryScoreCalculation;
        return data;
    }
}

export interface ISurveyIndicatorModel {
    /** Indicates that user has already filled last survey or not. */
    isSurveyFilled: boolean;
    /** Type of survey. */
    surveyType: SurveyType;
    /** Type of survey (in human readable format). */
    surveyTypeText: string;
    /** Numeric value of indicator. */
    value: number | null;
    /** Quality corresponding to the score value. */
    qualityMetric: QualityMetric;
    /** Status of score calculation */
    scoreStatus: ScoreCalculationStatusEnum;
    /** Indicates that survey close to be expired. */
    isSurveyCloseToExpired: boolean;
    /** Indicates that patient missed survey filling. */
    hasSurveyAlreadyExpired: boolean;
    /** Number of days that survey must be filled.
If it is negative - it means that survey has already expired.
If it is 0 - it means that today last day before expiration.
If it is positive - it describes number of days BEFORE expiring. */
    daysBeforeExpiring: number;
    /** Number of days during which survey must be shown with "expired" state. */
    expiredStateDisplayDurationInDays: number;
    /** Date when survey was answered. */
    fillingDate: Date | null;
    /** Date when survey must be answered. */
    untilDate: Date;
    /** Percentage of survey filling. */
    percentage: number | null;
    /** Answer id */
    answerId: number | null;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation: boolean;
}

/** 0 = MonthlySurvey 1 = TherapySurvey 2 = ActivityCheckSurvey 3 = DailySurvey 4 = PrismaCheckSurvey 5 = TherapyHelp 6 = Custom */
export enum SurveyType {
    MonthlySurvey = 0,
    TherapySurvey = 1,
    ActivityCheckSurvey = 2,
    DailySurvey = 3,
    PrismaCheckSurvey = 4,
    TherapyHelp = 5,
    Custom = 6,
}

export class CategorizationResultModel implements ICategorizationResultModel {
    /** Describes calculated result of patient category group
e.g. Empty, PendingTOCalculate, Ok, Warning, Bad */
    quality!: PatientCategoryEnum;
    /** Describes facts that have influence on Quality during calculation. */
    achievements!: CategoryAchievement;

    constructor(data?: ICategorizationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quality = _data["quality"];
            this.achievements = _data["achievements"];
        }
    }

    static fromJS(data: any): CategorizationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategorizationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quality"] = this.quality;
        data["achievements"] = this.achievements;
        return data;
    }
}

export interface ICategorizationResultModel {
    /** Describes calculated result of patient category group
e.g. Empty, PendingTOCalculate, Ok, Warning, Bad */
    quality: PatientCategoryEnum;
    /** Describes facts that have influence on Quality during calculation. */
    achievements: CategoryAchievement;
}

/** 0 = Default 50 = Pending 100 = NoData 200 = Good 300 = Warning 400 = Bad 999 = Stopped */
export enum PatientCategoryEnum {
    Default = 0,
    Pending = 50,
    NoData = 100,
    Good = 200,
    Warning = 300,
    Bad = 400,
    Stopped = 999,
}

/** 0 = Empty 1 = TooLowDeviceUsage 2 = TooLowMonthlySurveyScore 4 = TooHighLeakage 8 = BadTherapyCheckScore 16 = TherapyCheckTrigger 32 = LowDeviceUsage 64 = LowMonthlySurveyScore 128 = HighLeakage 256 = AhiIncreased 512 = NoTherapyDataForLastSevenDays 1024 = WarningTherapyCheckScore 2048 = WarningDyspnea 4096 = BadDyspnea -1 = NoData */
export enum CategoryAchievement {
    Empty = 0,
    TooLowDeviceUsage = 1,
    TooLowMonthlySurveyScore = 2,
    TooHighLeakage = 4,
    BadTherapyCheckScore = 8,
    TherapyCheckTrigger = 16,
    LowDeviceUsage = 32,
    LowMonthlySurveyScore = 64,
    HighLeakage = 128,
    AhiIncreased = 256,
    NoTherapyDataForLastSevenDays = 512,
    WarningTherapyCheckScore = 1024,
    WarningDyspnea = 2048,
    BadDyspnea = 4096,
    NoData = -1,
}

export class PatientFilterStatus implements IPatientFilterStatus {
    isClinic!: boolean;
    isControlled!: boolean;
    needsChecking!: boolean;
    hasNoApp!: boolean;

    constructor(data?: IPatientFilterStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isClinic = _data["isClinic"];
            this.isControlled = _data["isControlled"];
            this.needsChecking = _data["needsChecking"];
            this.hasNoApp = _data["hasNoApp"];
        }
    }

    static fromJS(data: any): PatientFilterStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFilterStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isClinic"] = this.isClinic;
        data["isControlled"] = this.isControlled;
        data["needsChecking"] = this.needsChecking;
        data["hasNoApp"] = this.hasNoApp;
        return data;
    }
}

export interface IPatientFilterStatus {
    isClinic: boolean;
    isControlled: boolean;
    needsChecking: boolean;
    hasNoApp: boolean;
}

export class TagFiltersDto implements ITagFiltersDto {

    [key: string]: string[] | any;

    constructor(data?: ITagFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): TagFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface ITagFiltersDto {

    [key: string]: string[] | any;
}

/** 0 = Creation 2 = GeneralInfo 4 = Forms 8 = Surveys 16 = Analyses 32 = Review 64 = ReviewRevoke */
export enum PatientChangesEvent {
    Creation = 0,
    GeneralInfo = 2,
    Forms = 4,
    Surveys = 8,
    Analyses = 16,
    Review = 32,
    ReviewRevoke = 64,
}

/** Monitoring review status of the patient 1 = NotReady 2 = ReadyForReview 3 = ReadyForRelease 4 = Released */
export enum MonitoringReviewStatusEnum {
    NotReady = 1,
    ReadyForReview = 2,
    ReadyForRelease = 3,
    Released = 4,
}

export class PagedResultOfPatientListDto implements IPagedResultOfPatientListDto {
    data!: PatientListDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfPatientListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PatientListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfPatientListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPatientListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfPatientListDto {
    data: PatientListDto[];
    totalCount: number;
}

/** 1 = NotStarted 2 = InProgress 3 = Finished 4 = Archived */
export enum PatientStudyStateEnum {
    NotStarted = 1,
    InProgress = 2,
    Finished = 3,
    Archived = 4,
}

export class PatientDto implements IPatientDto {
    /** Id of user. */
    id!: string;
    /** Date When Patient was created. */
    createdAt!: Date;
    /** Date when study must start for patient */
    studyStartedAt!: Date | null;
    /** Date and time when patient has visited app last time.
NULL - if patient has never logged in. */
    lastVisitDateTime!: Date | null;
    /** Date of contract signed */
    contractSignedAt!: Date | null;
    /** Id of study, where patient has included. */
    studyId!: string;
    /** Id of group, where patient has included. */
    groupId!: number;
    /** Unique id of patient in the current study . */
    patientId!: string;
    /** Additional data that is attached to patients
to filter them and restrict access of doctor to patient
according to tag filters of the doctor */
    tags!: TagFiltersDto | null;
    /** Flag indicating that the study is finished */
    isStudyFinished!: boolean;
    /** Date and time when the patient was archived (server UTC time). */
    archivedAt!: Date | null;
    /** Stuff who archived the patient */
    archivedBy!: DoctorDto | null;
    /** This flag indicates that all issues for this patient are closed */
    allIssuesAreClosed!: boolean;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.studyStartedAt = _data["studyStartedAt"] ? parseDateOnly(_data["studyStartedAt"].toString()) : <any>null;
            this.lastVisitDateTime = _data["lastVisitDateTime"] ? new Date(_data["lastVisitDateTime"].toString()) : <any>null;
            this.contractSignedAt = _data["contractSignedAt"] ? parseDateOnly(_data["contractSignedAt"].toString()) : <any>null;
            this.studyId = _data["studyId"];
            this.groupId = _data["groupId"];
            this.patientId = _data["patientId"];
            this.tags = _data["tags"] ? TagFiltersDto.fromJS(_data["tags"]) : <any>null;
            this.isStudyFinished = _data["isStudyFinished"];
            this.archivedAt = _data["archivedAt"] ? new Date(_data["archivedAt"].toString()) : <any>null;
            this.archivedBy = _data["archivedBy"] ? DoctorDto.fromJS(_data["archivedBy"]) : <any>null;
            this.allIssuesAreClosed = _data["allIssuesAreClosed"];
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["studyStartedAt"] = this.studyStartedAt && formatDate(this.studyStartedAt);
        data["lastVisitDateTime"] = this.lastVisitDateTime && this.lastVisitDateTime.toISOString();
        data["contractSignedAt"] = this.contractSignedAt && formatDate(this.contractSignedAt);
        data["studyId"] = this.studyId;
        data["groupId"] = this.groupId;
        data["patientId"] = this.patientId;
        data["tags"] = this.tags ? this.tags.toJSON() : <any>null;
        data["isStudyFinished"] = this.isStudyFinished;
        data["archivedAt"] = this.archivedAt && this.archivedAt.toISOString();
        data["archivedBy"] = this.archivedBy ? this.archivedBy.toJSON() : <any>null;
        data["allIssuesAreClosed"] = this.allIssuesAreClosed;
        return data;
    }
}

export interface IPatientDto {
    /** Id of user. */
    id: string;
    /** Date When Patient was created. */
    createdAt: Date;
    /** Date when study must start for patient */
    studyStartedAt: Date | null;
    /** Date and time when patient has visited app last time.
NULL - if patient has never logged in. */
    lastVisitDateTime: Date | null;
    /** Date of contract signed */
    contractSignedAt: Date | null;
    /** Id of study, where patient has included. */
    studyId: string;
    /** Id of group, where patient has included. */
    groupId: number;
    /** Unique id of patient in the current study . */
    patientId: string;
    /** Additional data that is attached to patients
to filter them and restrict access of doctor to patient
according to tag filters of the doctor */
    tags: TagFiltersDto | null;
    /** Flag indicating that the study is finished */
    isStudyFinished: boolean;
    /** Date and time when the patient was archived (server UTC time). */
    archivedAt: Date | null;
    /** Stuff who archived the patient */
    archivedBy: DoctorDto | null;
    /** This flag indicates that all issues for this patient are closed */
    allIssuesAreClosed: boolean;
}

export class UpdatePatientFilterDto implements IUpdatePatientFilterDto {
    /** Set value for "IsClinic" filter of teh patient */
    isClinic?: boolean;
    /** Set value for "IsControlled" filter of the patient */
    isControlled?: boolean;
    /** Set value for "NeedsCheck" filter of the patient */
    needsChecking?: boolean;
    /** Set value for "No app" filter of the patient */
    hasNoApp?: boolean;

    constructor(data?: IUpdatePatientFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isClinic = _data["isClinic"];
            this.isControlled = _data["isControlled"];
            this.needsChecking = _data["needsChecking"];
            this.hasNoApp = _data["hasNoApp"];
        }
    }

    static fromJS(data: any): UpdatePatientFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isClinic"] = this.isClinic;
        data["isControlled"] = this.isControlled;
        data["needsChecking"] = this.needsChecking;
        data["hasNoApp"] = this.hasNoApp;
        return data;
    }
}

export interface IUpdatePatientFilterDto {
    /** Set value for "IsClinic" filter of teh patient */
    isClinic?: boolean;
    /** Set value for "IsControlled" filter of the patient */
    isControlled?: boolean;
    /** Set value for "NeedsCheck" filter of the patient */
    needsChecking?: boolean;
    /** Set value for "No app" filter of the patient */
    hasNoApp?: boolean;
}

export class FinishPatientStudyDto implements IFinishPatientStudyDto {
    /** Reason why study was finished.
Null - study was planning finished */
    reason!: FinishStudyReason;
    /** Reason why study was finished.
Null - study was planning finished */
    finishStudyDescription?: string | null;

    constructor(data?: IFinishPatientStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.finishStudyDescription = _data["finishStudyDescription"];
        }
    }

    static fromJS(data: any): FinishPatientStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishPatientStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["finishStudyDescription"] = this.finishStudyDescription;
        return data;
    }
}

export interface IFinishPatientStudyDto {
    /** Reason why study was finished.
Null - study was planning finished */
    reason: FinishStudyReason;
    /** Reason why study was finished.
Null - study was planning finished */
    finishStudyDescription?: string | null;
}

/** 1 = Planned 2 = Unplanned */
export enum FinishStudyReason {
    Planned = 1,
    Unplanned = 2,
}

/** Represents object with amount of patient in "Not Started", "Progress" and "Finished" states by group. */
export class PatientGroupCountersDto implements IPatientGroupCountersDto {
    /** Group Id. */
    groupId!: number;
    /** There is at least one patient with a not approved final form */
    hasNotApprovedFinalForm!: boolean;
    /** Amount of overall patients in group. */
    allCount!: number;
    /** Amount of patients in group currently in "Progress" state. */
    inProgressCount!: number;
    /** Amount of patients in group currently in "Finished" state. */
    finishedCount!: number;
    /** Amount of patients in group currently in "Not Started" state. */
    notStartedCount!: number;
    /** Amount of patients in group currently in "Archived" state. */
    archivedCount!: number;

    constructor(data?: IPatientGroupCountersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.hasNotApprovedFinalForm = _data["hasNotApprovedFinalForm"];
            this.allCount = _data["allCount"];
            this.inProgressCount = _data["inProgressCount"];
            this.finishedCount = _data["finishedCount"];
            this.notStartedCount = _data["notStartedCount"];
            this.archivedCount = _data["archivedCount"];
        }
    }

    static fromJS(data: any): PatientGroupCountersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGroupCountersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["hasNotApprovedFinalForm"] = this.hasNotApprovedFinalForm;
        data["allCount"] = this.allCount;
        data["inProgressCount"] = this.inProgressCount;
        data["finishedCount"] = this.finishedCount;
        data["notStartedCount"] = this.notStartedCount;
        data["archivedCount"] = this.archivedCount;
        return data;
    }
}

/** Represents object with amount of patient in "Not Started", "Progress" and "Finished" states by group. */
export interface IPatientGroupCountersDto {
    /** Group Id. */
    groupId: number;
    /** There is at least one patient with a not approved final form */
    hasNotApprovedFinalForm: boolean;
    /** Amount of overall patients in group. */
    allCount: number;
    /** Amount of patients in group currently in "Progress" state. */
    inProgressCount: number;
    /** Amount of patients in group currently in "Finished" state. */
    finishedCount: number;
    /** Amount of patients in group currently in "Not Started" state. */
    notStartedCount: number;
    /** Amount of patients in group currently in "Archived" state. */
    archivedCount: number;
}

export class PatientChangesDetails implements IPatientChangesDetails {
    /** Date and time of changes. */
    modifyAt!: Date;
    /** Person who made a changes
             */
    modifyBy!: string;
    /** Event(s) that has been triggered for patient and related entities update. */
    modifyEvent!: PatientChangesEvent;
    /** Some related information.
e.g. Name of form, survey or analyze preset - to point on certain subject. */
    additionalInfo!: string | null;

    constructor(data?: IPatientChangesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modifyAt = _data["modifyAt"] ? new Date(_data["modifyAt"].toString()) : <any>null;
            this.modifyBy = _data["modifyBy"];
            this.modifyEvent = _data["modifyEvent"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): PatientChangesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientChangesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifyAt"] = this.modifyAt && this.modifyAt.toISOString();
        data["modifyBy"] = this.modifyBy;
        data["modifyEvent"] = this.modifyEvent;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }
}

export interface IPatientChangesDetails {
    /** Date and time of changes. */
    modifyAt: Date;
    /** Person who made a changes
             */
    modifyBy: string;
    /** Event(s) that has been triggered for patient and related entities update. */
    modifyEvent: PatientChangesEvent;
    /** Some related information.
e.g. Name of form, survey or analyze preset - to point on certain subject. */
    additionalInfo: string | null;
}

export class ValidatePdfResponseDto implements IValidatePdfResponseDto {
    contactInfo!: string | null;
    location!: string | null;
    name!: string | null;
    reason!: string | null;
    valid!: boolean;
    signingTime!: Date;
    signatureCreator!: string | null;
    trusted!: boolean;

    constructor(data?: IValidatePdfResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactInfo = _data["contactInfo"];
            this.location = _data["location"];
            this.name = _data["name"];
            this.reason = _data["reason"];
            this.valid = _data["valid"];
            this.signingTime = _data["signingTime"] ? new Date(_data["signingTime"].toString()) : <any>null;
            this.signatureCreator = _data["signatureCreator"];
            this.trusted = _data["trusted"];
        }
    }

    static fromJS(data: any): ValidatePdfResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePdfResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactInfo"] = this.contactInfo;
        data["location"] = this.location;
        data["name"] = this.name;
        data["reason"] = this.reason;
        data["valid"] = this.valid;
        data["signingTime"] = this.signingTime && this.signingTime.toISOString();
        data["signatureCreator"] = this.signatureCreator;
        data["trusted"] = this.trusted;
        return data;
    }
}

export interface IValidatePdfResponseDto {
    contactInfo: string | null;
    location: string | null;
    name: string | null;
    reason: string | null;
    valid: boolean;
    signingTime: Date;
    signatureCreator: string | null;
    trusted: boolean;
}

export class DoctorProfileDto implements IDoctorProfileDto {
    /** Doctor id. */
    id!: string;
    /** Doctor's full name. */
    fullName!: string;
    /** Doctor's email. */
    email!: string | null;
    /** Studies of doctor. */
    studies!: number[];

    constructor(data?: IDoctorProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(item);
            }
        }
    }

    static fromJS(data: any): DoctorProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item);
        }
        return data;
    }
}

export interface IDoctorProfileDto {
    /** Doctor id. */
    id: string;
    /** Doctor's full name. */
    fullName: string;
    /** Doctor's email. */
    email: string | null;
    /** Studies of doctor. */
    studies: number[];
}

export class SurveyQuestion implements ISurveyQuestion {
    id!: string;
    hashCode!: number;
    questionType!: QuestionType;
    isYesNoQuestion?: boolean | null;
    discriminator!: string;
    questionText!: string;
    isSkippedRender!: SkipOptions;
    canBeSkipped!: boolean;
    attentionText?: string | null;
    options!: SurveyOption[];
    firsOptionIsPositive?: boolean | null;

    constructor(data?: ISurveyQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hashCode = _data["hashCode"];
            this.questionType = _data["questionType"];
            this.isYesNoQuestion = _data["isYesNoQuestion"];
            this.discriminator = _data["discriminator"];
            this.questionText = _data["questionText"];
            this.isSkippedRender = _data["isSkippedRender"];
            this.canBeSkipped = _data["canBeSkipped"];
            this.attentionText = _data["attentionText"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SurveyOption.fromJS(item));
            }
            this.firsOptionIsPositive = _data["firsOptionIsPositive"];
        }
    }

    static fromJS(data: any): SurveyQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hashCode"] = this.hashCode;
        data["questionType"] = this.questionType;
        data["isYesNoQuestion"] = this.isYesNoQuestion;
        data["discriminator"] = this.discriminator;
        data["questionText"] = this.questionText;
        data["isSkippedRender"] = this.isSkippedRender;
        data["canBeSkipped"] = this.canBeSkipped;
        data["attentionText"] = this.attentionText;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["firsOptionIsPositive"] = this.firsOptionIsPositive;
        return data;
    }
}

export interface ISurveyQuestion {
    id: string;
    hashCode: number;
    questionType: QuestionType;
    isYesNoQuestion?: boolean | null;
    discriminator: string;
    questionText: string;
    isSkippedRender: SkipOptions;
    canBeSkipped: boolean;
    attentionText?: string | null;
    options: SurveyOption[];
    firsOptionIsPositive?: boolean | null;
}

/** 0 = SingleChose 1 = MultipleChose 2 = Rate 3 = Scale 4 = FreeInput 5 = ConditionalQuestion 6 = YesNo */
export enum QuestionType {
    SingleChose = 0,
    MultipleChose = 1,
    Rate = 2,
    Scale = 3,
    FreeInput = 4,
    ConditionalQuestion = 5,
    YesNo = 6,
}

/** 0 = NotSkip 1 = OnlyQuestion 2 = WithChildren 3 = SkippedAnswer */
export enum SkipOptions {
    NotSkip = 0,
    OnlyQuestion = 1,
    WithChildren = 2,
    SkippedAnswer = 3,
}

export class SurveyOption implements ISurveyOption {
    discriminator!: string;
    optionText!: string;
    optionValue!: string;
    answerValue?: string | null;
    defaultValue?: string | null;
    scoreValue!: number;
    questionScheme?: QuestionScheme | null;

    constructor(data?: ISurveyOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.optionText = _data["optionText"];
            this.optionValue = _data["optionValue"];
            this.answerValue = _data["answerValue"];
            this.defaultValue = _data["defaultValue"];
            this.scoreValue = _data["scoreValue"];
            this.questionScheme = _data["questionScheme"] ? QuestionScheme.fromJS(_data["questionScheme"]) : <any>null;
        }
    }

    static fromJS(data: any): SurveyOption {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["optionText"] = this.optionText;
        data["optionValue"] = this.optionValue;
        data["answerValue"] = this.answerValue;
        data["defaultValue"] = this.defaultValue;
        data["scoreValue"] = this.scoreValue;
        data["questionScheme"] = this.questionScheme ? this.questionScheme.toJSON() : <any>null;
        return data;
    }
}

export interface ISurveyOption {
    discriminator: string;
    optionText: string;
    optionValue: string;
    answerValue?: string | null;
    defaultValue?: string | null;
    scoreValue: number;
    questionScheme?: QuestionScheme | null;
}

export class QuestionScheme implements IQuestionScheme {
    version?: string | null;
    description?: string | null;
    legend?: string | null;
    questions!: SurveyQuestion[];

    constructor(data?: IQuestionScheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.description = _data["description"];
            this.legend = _data["legend"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionScheme {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionScheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["description"] = this.description;
        data["legend"] = this.legend;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionScheme {
    version?: string | null;
    description?: string | null;
    legend?: string | null;
    questions: SurveyQuestion[];
}

export class QuestionCreationDto implements IQuestionCreationDto {
    questionType!: QuestionType;
    questionText!: string | null;
    options!: SurveyOption[];
    isSkippedRender!: SkipOptions;
    canBeSkipped!: boolean;

    constructor(data?: IQuestionCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionType = _data["questionType"];
            this.questionText = _data["questionText"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SurveyOption.fromJS(item));
            }
            this.isSkippedRender = _data["isSkippedRender"];
            this.canBeSkipped = _data["canBeSkipped"];
        }
    }

    static fromJS(data: any): QuestionCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionType"] = this.questionType;
        data["questionText"] = this.questionText;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["isSkippedRender"] = this.isSkippedRender;
        data["canBeSkipped"] = this.canBeSkipped;
        return data;
    }
}

export interface IQuestionCreationDto {
    questionType: QuestionType;
    questionText: string | null;
    options: SurveyOption[];
    isSkippedRender: SkipOptions;
    canBeSkipped: boolean;
}

export class PagedResultOfAdminStudyDto implements IPagedResultOfAdminStudyDto {
    data!: AdminStudyDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfAdminStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminStudyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfAdminStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAdminStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfAdminStudyDto {
    data: AdminStudyDto[];
    totalCount: number;
}

export class DoctorStudyDto implements IDoctorStudyDto {
    /** Study id. */
    id!: number;
    /** Number of the Study. */
    studyNumber!: string;
    /** Short description of the study. */
    title!: string;
    /** Description and proposal of study. */
    description!: string;
    /** Primary objective of the study */
    primaryObjectiveText!: string | null;
    /** Date when study has been started. */
    startDate!: Date;
    /** Date when study must finish. */
    duration!: number;
    /** Date of study creation. */
    createdAt!: Date;
    /** Flag indicates that the study uses therapy data. */
    hasTherapy!: boolean;
    /** Flag indicates that the study could be under "Monitoring" (issue tracker). */
    hasMonitoring!: boolean;
    /** Configurable monitoring form config */
    monitoringFormConfigs!: MonitoringFormConfig[];
    /** Flag indicates that the study uses pdf signing */
    hasPdfSigning!: boolean;
    /** Flag indicates that the study uses DB import */
    hasDbImport!: boolean;
    /** Flag indicates that the study uses eCRF feature */
    hasEcrf!: boolean;
    /** Flag indicates that mobile surveys are configured in study */
    hasSurveys!: boolean;
    infoPageConfiguration!: StudyInfoPageConfigurationDto | null;
    /** Indicates that sync status is available or not. */
    isTokenActive!: boolean;
    /** Indicates that statistics is updating right now. */
    isSyncInProgress!: boolean;
    /** Date when data was synced last time successfully. */
    lastSuccessSyncDate!: Date | null;
    /** List of available groups in study. */
    groups!: GroupDto[];
    /** List of available surveys in study. */
    surveys!: SurveyDto[];
    /** Form type and id for patient creation */
    patientCreationFormBinding!: FormBinding | null;
    /** Form type and id for finishing patient's study
NULL if Non eCRF study - at least it will not make sense */
    patientFinishingFormId!: number | null;
    /** FAQ id for study */
    faqId!: number | null;
    /** Amount of days for therapy data indicators aggregation */
    therapyAggregationPeriod!: number;
    /** This flag indicates that the all patient are archived */
    allPatientsAreArchived!: boolean;
    /** This flag indicates that the all issues are closed */
    allIssuesAreClosed!: boolean;
    /** When the study closing is approved */
    closingApprovedAt!: Date | null;
    /** Stuff who approve study closure */
    closingApprovedBy!: DoctorDto | null;
    /** When the study closed */
    closedAt!: Date | null;
    /** Stuff who close the study */
    closedBy!: DoctorDto | null;
    /** Number of days for creating a patient in advance */
    patientStudyStartAdvanceDays!: number;
    /** Roles for study */
    roles!: StudyRoleDto[] | null;
    /** Tag filters for study */
    tagFilters!: TagFiltersDto | null;

    constructor(data?: IDoctorStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.monitoringFormConfigs = [];
            this.groups = [];
            this.surveys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyNumber = _data["studyNumber"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.primaryObjectiveText = _data["primaryObjectiveText"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.duration = _data["duration"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.hasTherapy = _data["hasTherapy"];
            this.hasMonitoring = _data["hasMonitoring"];
            if (Array.isArray(_data["monitoringFormConfigs"])) {
                this.monitoringFormConfigs = [] as any;
                for (let item of _data["monitoringFormConfigs"])
                    this.monitoringFormConfigs!.push(MonitoringFormConfig.fromJS(item));
            }
            this.hasPdfSigning = _data["hasPdfSigning"];
            this.hasDbImport = _data["hasDbImport"];
            this.hasEcrf = _data["hasEcrf"];
            this.hasSurveys = _data["hasSurveys"];
            this.infoPageConfiguration = _data["infoPageConfiguration"] ? StudyInfoPageConfigurationDto.fromJS(_data["infoPageConfiguration"]) : <any>null;
            this.isTokenActive = _data["isTokenActive"];
            this.isSyncInProgress = _data["isSyncInProgress"];
            this.lastSuccessSyncDate = _data["lastSuccessSyncDate"] ? new Date(_data["lastSuccessSyncDate"].toString()) : <any>null;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDto.fromJS(item));
            }
            if (Array.isArray(_data["surveys"])) {
                this.surveys = [] as any;
                for (let item of _data["surveys"])
                    this.surveys!.push(SurveyDto.fromJS(item));
            }
            this.patientCreationFormBinding = _data["patientCreationFormBinding"] ? FormBinding.fromJS(_data["patientCreationFormBinding"]) : <any>null;
            this.patientFinishingFormId = _data["patientFinishingFormId"];
            this.faqId = _data["faqId"];
            this.therapyAggregationPeriod = _data["therapyAggregationPeriod"];
            this.allPatientsAreArchived = _data["allPatientsAreArchived"];
            this.allIssuesAreClosed = _data["allIssuesAreClosed"];
            this.closingApprovedAt = _data["closingApprovedAt"] ? new Date(_data["closingApprovedAt"].toString()) : <any>null;
            this.closingApprovedBy = _data["closingApprovedBy"] ? DoctorDto.fromJS(_data["closingApprovedBy"]) : <any>null;
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : <any>null;
            this.closedBy = _data["closedBy"] ? DoctorDto.fromJS(_data["closedBy"]) : <any>null;
            this.patientStudyStartAdvanceDays = _data["patientStudyStartAdvanceDays"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(StudyRoleDto.fromJS(item));
            }
            this.tagFilters = _data["tagFilters"] ? TagFiltersDto.fromJS(_data["tagFilters"]) : <any>null;
        }
    }

    static fromJS(data: any): DoctorStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyNumber"] = this.studyNumber;
        data["title"] = this.title;
        data["description"] = this.description;
        data["primaryObjectiveText"] = this.primaryObjectiveText;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["duration"] = this.duration;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["hasTherapy"] = this.hasTherapy;
        data["hasMonitoring"] = this.hasMonitoring;
        if (Array.isArray(this.monitoringFormConfigs)) {
            data["monitoringFormConfigs"] = [];
            for (let item of this.monitoringFormConfigs)
                data["monitoringFormConfigs"].push(item.toJSON());
        }
        data["hasPdfSigning"] = this.hasPdfSigning;
        data["hasDbImport"] = this.hasDbImport;
        data["hasEcrf"] = this.hasEcrf;
        data["hasSurveys"] = this.hasSurveys;
        data["infoPageConfiguration"] = this.infoPageConfiguration ? this.infoPageConfiguration.toJSON() : <any>null;
        data["isTokenActive"] = this.isTokenActive;
        data["isSyncInProgress"] = this.isSyncInProgress;
        data["lastSuccessSyncDate"] = this.lastSuccessSyncDate && this.lastSuccessSyncDate.toISOString();
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.surveys)) {
            data["surveys"] = [];
            for (let item of this.surveys)
                data["surveys"].push(item.toJSON());
        }
        data["patientCreationFormBinding"] = this.patientCreationFormBinding ? this.patientCreationFormBinding.toJSON() : <any>null;
        data["patientFinishingFormId"] = this.patientFinishingFormId;
        data["faqId"] = this.faqId;
        data["therapyAggregationPeriod"] = this.therapyAggregationPeriod;
        data["allPatientsAreArchived"] = this.allPatientsAreArchived;
        data["allIssuesAreClosed"] = this.allIssuesAreClosed;
        data["closingApprovedAt"] = this.closingApprovedAt && this.closingApprovedAt.toISOString();
        data["closingApprovedBy"] = this.closingApprovedBy ? this.closingApprovedBy.toJSON() : <any>null;
        data["closedAt"] = this.closedAt && this.closedAt.toISOString();
        data["closedBy"] = this.closedBy ? this.closedBy.toJSON() : <any>null;
        data["patientStudyStartAdvanceDays"] = this.patientStudyStartAdvanceDays;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["tagFilters"] = this.tagFilters ? this.tagFilters.toJSON() : <any>null;
        return data;
    }
}

export interface IDoctorStudyDto {
    /** Study id. */
    id: number;
    /** Number of the Study. */
    studyNumber: string;
    /** Short description of the study. */
    title: string;
    /** Description and proposal of study. */
    description: string;
    /** Primary objective of the study */
    primaryObjectiveText: string | null;
    /** Date when study has been started. */
    startDate: Date;
    /** Date when study must finish. */
    duration: number;
    /** Date of study creation. */
    createdAt: Date;
    /** Flag indicates that the study uses therapy data. */
    hasTherapy: boolean;
    /** Flag indicates that the study could be under "Monitoring" (issue tracker). */
    hasMonitoring: boolean;
    /** Configurable monitoring form config */
    monitoringFormConfigs: MonitoringFormConfig[];
    /** Flag indicates that the study uses pdf signing */
    hasPdfSigning: boolean;
    /** Flag indicates that the study uses DB import */
    hasDbImport: boolean;
    /** Flag indicates that the study uses eCRF feature */
    hasEcrf: boolean;
    /** Flag indicates that mobile surveys are configured in study */
    hasSurveys: boolean;
    infoPageConfiguration: StudyInfoPageConfigurationDto | null;
    /** Indicates that sync status is available or not. */
    isTokenActive: boolean;
    /** Indicates that statistics is updating right now. */
    isSyncInProgress: boolean;
    /** Date when data was synced last time successfully. */
    lastSuccessSyncDate: Date | null;
    /** List of available groups in study. */
    groups: GroupDto[];
    /** List of available surveys in study. */
    surveys: SurveyDto[];
    /** Form type and id for patient creation */
    patientCreationFormBinding: FormBinding | null;
    /** Form type and id for finishing patient's study
NULL if Non eCRF study - at least it will not make sense */
    patientFinishingFormId: number | null;
    /** FAQ id for study */
    faqId: number | null;
    /** Amount of days for therapy data indicators aggregation */
    therapyAggregationPeriod: number;
    /** This flag indicates that the all patient are archived */
    allPatientsAreArchived: boolean;
    /** This flag indicates that the all issues are closed */
    allIssuesAreClosed: boolean;
    /** When the study closing is approved */
    closingApprovedAt: Date | null;
    /** Stuff who approve study closure */
    closingApprovedBy: DoctorDto | null;
    /** When the study closed */
    closedAt: Date | null;
    /** Stuff who close the study */
    closedBy: DoctorDto | null;
    /** Number of days for creating a patient in advance */
    patientStudyStartAdvanceDays: number;
    /** Roles for study */
    roles: StudyRoleDto[] | null;
    /** Tag filters for study */
    tagFilters: TagFiltersDto | null;
}

export class AdminStudyDto extends DoctorStudyDto implements IAdminStudyDto {
    /** Returns http address of sync-platform (pCLoud) */
    prismaUrl!: string | null;
    /** Describes amount of days for aggregation therapy params (like a Compliance, Leakage, AHI tc.) */
    therapyAggregationPeriod!: number;
    /** Describes is auth token stored or not. */
    isTokenSet!: boolean;
    /** Planned number of patients in the study. */
    plannedPatients!: number | null;

    constructor(data?: IAdminStudyDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prismaUrl = _data["prismaUrl"];
            this.therapyAggregationPeriod = _data["therapyAggregationPeriod"];
            this.isTokenSet = _data["isTokenSet"];
            this.plannedPatients = _data["plannedPatients"];
        }
    }

    static fromJS(data: any): AdminStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prismaUrl"] = this.prismaUrl;
        data["therapyAggregationPeriod"] = this.therapyAggregationPeriod;
        data["isTokenSet"] = this.isTokenSet;
        data["plannedPatients"] = this.plannedPatients;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminStudyDto extends IDoctorStudyDto {
    /** Returns http address of sync-platform (pCLoud) */
    prismaUrl: string | null;
    /** Describes amount of days for aggregation therapy params (like a Compliance, Leakage, AHI tc.) */
    therapyAggregationPeriod: number;
    /** Describes is auth token stored or not. */
    isTokenSet: boolean;
    /** Planned number of patients in the study. */
    plannedPatients: number | null;
}

export class MonitoringFormConfig implements IMonitoringFormConfig {
    configId!: number;
    title!: string;

    constructor(data?: IMonitoringFormConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configId = _data["configId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MonitoringFormConfig {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringFormConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configId"] = this.configId;
        data["title"] = this.title;
        return data;
    }
}

export interface IMonitoringFormConfig {
    configId: number;
    title: string;
}

export class StudyInfoPageConfigurationDto implements IStudyInfoPageConfigurationDto {
    /** [Column][SectionIndex] */
    sections!: StudyInfoPageSection[][];

    constructor(data?: IStudyInfoPageConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyInfoPageConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInfoPageConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item);
        }
        return data;
    }
}

export interface IStudyInfoPageConfigurationDto {
    /** [Column][SectionIndex] */
    sections: StudyInfoPageSection[][];
}

/** 0 = StudyPeriod 1 = Patients 2 = Records 3 = Attachments 4 = Notes 5 = Users 6 = RecruitmentProgress 7 = PrimaryObjective */
export enum StudyInfoPageSection {
    StudyPeriod = 0,
    Patients = 1,
    Records = 2,
    Attachments = 3,
    Notes = 4,
    Users = 5,
    RecruitmentProgress = 6,
    PrimaryObjective = 7,
}

export class GroupDto implements IGroupDto {
    /** Id of the group */
    id!: number;
    /** Navigation property between Study and Group. */
    studyId!: number;
    /** Title of the groups. Will be presented on the UI patient table. */
    title!: string;
    /** Set of the visible/disabled columns */
    tableColumns!: TableColumnsEnum;
    /** List of survey columns for a dashboard */
    surveyColumns!: string[];
    /** Priority of display ordering. */
    priority!: number;
    /** Describe the flow how forms should appear for group. */
    studyRouteId!: string | null;
    /** Describes which surveys this group contains */
    surveyRuleIds!: number[];
    /** Describes which sections should be in patient card
e.g. [ columnOne: [GeneralInfo, Records, Stage], columnTwo: [Surveys, AppInformation], columnThree: [Notes, Analyzes] ] */
    patientCardSections!: CardSectionsEnum[][];
    /** List of surveys for a patient card section */
    surveysToPatientCard!: string[];
    /** Study route for the group */
    studyRoute!: StudyRouteDto | null;
    formConfigIdForNotes!: number | null;
    noteDateDataKey!: string | null;
    mainNoteFieldDataKey!: string | null;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyColumns = [];
            this.surveyRuleIds = [];
            this.patientCardSections = [];
            this.surveysToPatientCard = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.title = _data["title"];
            this.tableColumns = _data["tableColumns"];
            if (Array.isArray(_data["surveyColumns"])) {
                this.surveyColumns = [] as any;
                for (let item of _data["surveyColumns"])
                    this.surveyColumns!.push(item);
            }
            this.priority = _data["priority"];
            this.studyRouteId = _data["studyRouteId"];
            if (Array.isArray(_data["surveyRuleIds"])) {
                this.surveyRuleIds = [] as any;
                for (let item of _data["surveyRuleIds"])
                    this.surveyRuleIds!.push(item);
            }
            if (Array.isArray(_data["patientCardSections"])) {
                this.patientCardSections = [] as any;
                for (let item of _data["patientCardSections"])
                    this.patientCardSections!.push(item);
            }
            if (Array.isArray(_data["surveysToPatientCard"])) {
                this.surveysToPatientCard = [] as any;
                for (let item of _data["surveysToPatientCard"])
                    this.surveysToPatientCard!.push(item);
            }
            this.studyRoute = _data["studyRoute"] ? StudyRouteDto.fromJS(_data["studyRoute"]) : <any>null;
            this.formConfigIdForNotes = _data["formConfigIdForNotes"];
            this.noteDateDataKey = _data["noteDateDataKey"];
            this.mainNoteFieldDataKey = _data["mainNoteFieldDataKey"];
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["title"] = this.title;
        data["tableColumns"] = this.tableColumns;
        if (Array.isArray(this.surveyColumns)) {
            data["surveyColumns"] = [];
            for (let item of this.surveyColumns)
                data["surveyColumns"].push(item);
        }
        data["priority"] = this.priority;
        data["studyRouteId"] = this.studyRouteId;
        if (Array.isArray(this.surveyRuleIds)) {
            data["surveyRuleIds"] = [];
            for (let item of this.surveyRuleIds)
                data["surveyRuleIds"].push(item);
        }
        if (Array.isArray(this.patientCardSections)) {
            data["patientCardSections"] = [];
            for (let item of this.patientCardSections)
                data["patientCardSections"].push(item);
        }
        if (Array.isArray(this.surveysToPatientCard)) {
            data["surveysToPatientCard"] = [];
            for (let item of this.surveysToPatientCard)
                data["surveysToPatientCard"].push(item);
        }
        data["studyRoute"] = this.studyRoute ? this.studyRoute.toJSON() : <any>null;
        data["formConfigIdForNotes"] = this.formConfigIdForNotes;
        data["noteDateDataKey"] = this.noteDateDataKey;
        data["mainNoteFieldDataKey"] = this.mainNoteFieldDataKey;
        return data;
    }
}

export interface IGroupDto {
    /** Id of the group */
    id: number;
    /** Navigation property between Study and Group. */
    studyId: number;
    /** Title of the groups. Will be presented on the UI patient table. */
    title: string;
    /** Set of the visible/disabled columns */
    tableColumns: TableColumnsEnum;
    /** List of survey columns for a dashboard */
    surveyColumns: string[];
    /** Priority of display ordering. */
    priority: number;
    /** Describe the flow how forms should appear for group. */
    studyRouteId: string | null;
    /** Describes which surveys this group contains */
    surveyRuleIds: number[];
    /** Describes which sections should be in patient card
e.g. [ columnOne: [GeneralInfo, Records, Stage], columnTwo: [Surveys, AppInformation], columnThree: [Notes, Analyzes] ] */
    patientCardSections: CardSectionsEnum[][];
    /** List of surveys for a patient card section */
    surveysToPatientCard: string[];
    /** Study route for the group */
    studyRoute: StudyRouteDto | null;
    formConfigIdForNotes: number | null;
    noteDateDataKey: string | null;
    mainNoteFieldDataKey: string | null;
}

/** 2 = Compliance 4 = Leakage 8 = Ahi 16 = Surveys 32 = Categorization 64 = Note 128 = Stage 256 = CreationDate 512 = FlexiblePlaceholder */
export enum TableColumnsEnum {
    Compliance = 2,
    Leakage = 4,
    Ahi = 8,
    Surveys = 16,
    Categorization = 32,
    Note = 64,
    Stage = 128,
    CreationDate = 256,
    FlexiblePlaceholder = 512,
}

/** 1 = GeneralInfo 2 = RecordsGroupedByType 3 = Stage 4 = StudyPeriod 5 = Surveys 7 = Notes 8 = Analyzes 9 = AppInformation 10 = RecordsGroupedByStep 11 = MonitoringReview */
export enum CardSectionsEnum {
    GeneralInfo = 1,
    RecordsGroupedByType = 2,
    Stage = 3,
    StudyPeriod = 4,
    Surveys = 5,
    Notes = 7,
    Analyzes = 8,
    AppInformation = 9,
    RecordsGroupedByStep = 10,
    MonitoringReview = 11,
}

/** Describes study route for the specific study. */
export class StudyRouteDto implements IStudyRouteDto {
    /** Id of the study route */
    id!: string;
    /** Schema with ordered check points */
    schema!: CheckPoint[];

    constructor(data?: IStudyRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.schema = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["schema"])) {
                this.schema = [] as any;
                for (let item of _data["schema"])
                    this.schema!.push(CheckPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.schema)) {
            data["schema"] = [];
            for (let item of this.schema)
                data["schema"].push(item.toJSON());
        }
        return data;
    }
}

/** Describes study route for the specific study. */
export interface IStudyRouteDto {
    /** Id of the study route */
    id: string;
    /** Schema with ordered check points */
    schema: CheckPoint[];
}

export class CheckPoint implements ICheckPoint {
    name!: string;
    shortName!: string | null;
    forms!: CheckPointForm[];
    limitation!: StepTimeLimitation;
    stateTransferObject!: FormActionObject | null;
    initState!: RouteProgressStateEnum;
    isFinalStep!: boolean | null;

    constructor(data?: ICheckPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
            this.limitation = new StepTimeLimitation();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(CheckPointForm.fromJS(item));
            }
            this.limitation = _data["limitation"] ? StepTimeLimitation.fromJS(_data["limitation"]) : new StepTimeLimitation();
            this.stateTransferObject = _data["stateTransferObject"] ? FormActionObject.fromJS(_data["stateTransferObject"]) : <any>null;
            this.initState = _data["initState"];
            this.isFinalStep = _data["isFinalStep"];
        }
    }

    static fromJS(data: any): CheckPoint {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["limitation"] = this.limitation ? this.limitation.toJSON() : <any>null;
        data["stateTransferObject"] = this.stateTransferObject ? this.stateTransferObject.toJSON() : <any>null;
        data["initState"] = this.initState;
        data["isFinalStep"] = this.isFinalStep;
        return data;
    }
}

export interface ICheckPoint {
    name: string;
    shortName: string | null;
    forms: CheckPointForm[];
    limitation: StepTimeLimitation;
    stateTransferObject: FormActionObject | null;
    initState: RouteProgressStateEnum;
    isFinalStep: boolean | null;
}

export class CheckPointForm implements ICheckPointForm {
    formConfigId!: number;
    formConfigIdForInitialAnswers!: number | null;

    constructor(data?: ICheckPointForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formConfigId = _data["formConfigId"];
            this.formConfigIdForInitialAnswers = _data["formConfigIdForInitialAnswers"];
        }
    }

    static fromJS(data: any): CheckPointForm {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPointForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formConfigId"] = this.formConfigId;
        data["formConfigIdForInitialAnswers"] = this.formConfigIdForInitialAnswers;
        return data;
    }
}

export interface ICheckPointForm {
    formConfigId: number;
    formConfigIdForInitialAnswers: number | null;
}

export class StepTimeLimitation implements IStepTimeLimitation {
    numberOfStartShiftPeriod!: number;
    startPeriodUnits!: string;
    numberOfEditingPeriod!: number;
    editingPeriodUnits!: string;
    startDateActionObject!: FormActionObject;
    startWhenStepWithNameDone!: string | null;

    constructor(data?: IStepTimeLimitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startDateActionObject = new FormActionObject();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfStartShiftPeriod = _data["numberOfStartShiftPeriod"];
            this.startPeriodUnits = _data["startPeriodUnits"];
            this.numberOfEditingPeriod = _data["numberOfEditingPeriod"];
            this.editingPeriodUnits = _data["editingPeriodUnits"];
            this.startDateActionObject = _data["startDateActionObject"] ? FormActionObject.fromJS(_data["startDateActionObject"]) : new FormActionObject();
            this.startWhenStepWithNameDone = _data["startWhenStepWithNameDone"];
        }
    }

    static fromJS(data: any): StepTimeLimitation {
        data = typeof data === 'object' ? data : {};
        let result = new StepTimeLimitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfStartShiftPeriod"] = this.numberOfStartShiftPeriod;
        data["startPeriodUnits"] = this.startPeriodUnits;
        data["numberOfEditingPeriod"] = this.numberOfEditingPeriod;
        data["editingPeriodUnits"] = this.editingPeriodUnits;
        data["startDateActionObject"] = this.startDateActionObject ? this.startDateActionObject.toJSON() : <any>null;
        data["startWhenStepWithNameDone"] = this.startWhenStepWithNameDone;
        return data;
    }
}

export interface IStepTimeLimitation {
    numberOfStartShiftPeriod: number;
    startPeriodUnits: string;
    numberOfEditingPeriod: number;
    editingPeriodUnits: string;
    startDateActionObject: FormActionObject;
    startWhenStepWithNameDone: string | null;
}

export class FormActionObject implements IFormActionObject {
    formConfigId!: number | null;
    dataKey!: string | null;
    value!: string | null;
    funcName!: string | null;

    constructor(data?: IFormActionObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formConfigId = _data["formConfigId"];
            this.dataKey = _data["dataKey"];
            this.value = _data["value"];
            this.funcName = _data["funcName"];
        }
    }

    static fromJS(data: any): FormActionObject {
        data = typeof data === 'object' ? data : {};
        let result = new FormActionObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formConfigId"] = this.formConfigId;
        data["dataKey"] = this.dataKey;
        data["value"] = this.value;
        data["funcName"] = this.funcName;
        return data;
    }
}

export interface IFormActionObject {
    formConfigId: number | null;
    dataKey: string | null;
    value: string | null;
    funcName: string | null;
}

export class SurveyDto implements ISurveyDto {
    /** Unique ID of survey. */
    id!: number;
    studyId!: number;
    /** Date when survey was created. */
    createdDate!: Date;
    /** Type of survey. */
    type!: SurveyType;
    /** Questionnaire-survey type to string. */
    typeString!: string;
    /** Survey icon type */
    icon!: SurveyIcon;
    /** Title of survey. */
    title!: string;
    /** Description of survey. */
    description?: string | null;
    /** Settings for mobile app only */
    appSettings!: AppSettings;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appSettings = new AppSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.type = _data["type"];
            this.typeString = _data["typeString"];
            this.icon = _data["icon"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.appSettings = _data["appSettings"] ? AppSettings.fromJS(_data["appSettings"]) : new AppSettings();
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["createdDate"] = this.createdDate && this.createdDate.toISOString();
        data["type"] = this.type;
        data["typeString"] = this.typeString;
        data["icon"] = this.icon;
        data["title"] = this.title;
        data["description"] = this.description;
        data["appSettings"] = this.appSettings ? this.appSettings.toJSON() : <any>null;
        return data;
    }
}

export interface ISurveyDto {
    /** Unique ID of survey. */
    id: number;
    studyId: number;
    /** Date when survey was created. */
    createdDate: Date;
    /** Type of survey. */
    type: SurveyType;
    /** Questionnaire-survey type to string. */
    typeString: string;
    /** Survey icon type */
    icon: SurveyIcon;
    /** Title of survey. */
    title: string;
    /** Description of survey. */
    description?: string | null;
    /** Settings for mobile app only */
    appSettings: AppSettings;
}

/** 0 = Default 1 = Heart 2 = Device 3 = Shoe 4 = Smile 5 = Diary 6 = Hand 7 = Pillow 8 = Lungs 9 = Prisma 10 = Sheep 11 = Clipboard */
export enum SurveyIcon {
    Default = 0,
    Heart = 1,
    Device = 2,
    Shoe = 3,
    Smile = 4,
    Diary = 5,
    Hand = 6,
    Pillow = 7,
    Lungs = 8,
    Prisma = 9,
    Sheep = 10,
    Clipboard = 11,
}

export class AppSettings implements IAppSettings {
    priority!: boolean;
    showInDiary!: boolean;
    showInSummary!: boolean;
    notificationEnabled!: boolean;

    constructor(data?: IAppSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            this.showInDiary = _data["showInDiary"];
            this.showInSummary = _data["showInSummary"];
            this.notificationEnabled = _data["notificationEnabled"];
        }
    }

    static fromJS(data: any): AppSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        data["showInDiary"] = this.showInDiary;
        data["showInSummary"] = this.showInSummary;
        data["notificationEnabled"] = this.notificationEnabled;
        return data;
    }
}

export interface IAppSettings {
    priority: boolean;
    showInDiary: boolean;
    showInSummary: boolean;
    notificationEnabled: boolean;
}

export class FormBinding implements IFormBinding {
    id!: number;
    type!: string;
    formTypeForInitialAnswers?: string | null;

    constructor(data?: IFormBinding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.formTypeForInitialAnswers = _data["formTypeForInitialAnswers"];
        }
    }

    static fromJS(data: any): FormBinding {
        data = typeof data === 'object' ? data : {};
        let result = new FormBinding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["formTypeForInitialAnswers"] = this.formTypeForInitialAnswers;
        return data;
    }
}

export interface IFormBinding {
    id: number;
    type: string;
    formTypeForInitialAnswers?: string | null;
}

export class StudyRoleDto implements IStudyRoleDto {
    id!: string;
    name!: string;
    claims!: StudyRoleClaimValue[];
    availableForms!: AvailableFormDto[];

    constructor(data?: IStudyRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claims = [];
            this.availableForms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(item);
            }
            if (Array.isArray(_data["availableForms"])) {
                this.availableForms = [] as any;
                for (let item of _data["availableForms"])
                    this.availableForms!.push(AvailableFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item);
        }
        if (Array.isArray(this.availableForms)) {
            data["availableForms"] = [];
            for (let item of this.availableForms)
                data["availableForms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyRoleDto {
    id: string;
    name: string;
    claims: StudyRoleClaimValue[];
    availableForms: AvailableFormDto[];
}

/** 0 = StudyConfigure 1 = PatientView 2 = PatientCreate 3 = IssueView 4 = IssueCreate 5 = IssueProcess 6 = IssueApprove 7 = IssueDiscuss 8 = AnalysisPresetView 9 = AnalysisPresetManage 10 = AnalysisView 11 = AnalysisManage 12 = ApproveForm 13 = ApproveClosureForm 14 = ApproveClosureStudy 15 = ExportForm 16 = ExportPopulation 17 = ExportPatientEcrfReport 18 = ParticipantsView 19 = ParticipantsEdit 20 = ParticipantsApprove 21 = UeFormCreate 22 = UeFormEdit 23 = PatientRelease 24 = PatientArchive 25 = CloseStudy 26 = MonitoringReportView 27 = MonitoringReportCreate 28 = ExportAuditLog 29 = StudyInfoPageView 30 = StudyUserListView 31 = PatientReviewApproval */
export enum StudyRoleClaimValue {
    StudyConfigure = 0,
    PatientView = 1,
    PatientCreate = 2,
    IssueView = 3,
    IssueCreate = 4,
    IssueProcess = 5,
    IssueApprove = 6,
    IssueDiscuss = 7,
    AnalysisPresetView = 8,
    AnalysisPresetManage = 9,
    AnalysisView = 10,
    AnalysisManage = 11,
    ApproveForm = 12,
    ApproveClosureForm = 13,
    ApproveClosureStudy = 14,
    ExportForm = 15,
    ExportPopulation = 16,
    ExportPatientEcrfReport = 17,
    ParticipantsView = 18,
    ParticipantsEdit = 19,
    ParticipantsApprove = 20,
    UeFormCreate = 21,
    UeFormEdit = 22,
    PatientRelease = 23,
    PatientArchive = 24,
    CloseStudy = 25,
    MonitoringReportView = 26,
    MonitoringReportCreate = 27,
    ExportAuditLog = 28,
    StudyInfoPageView = 29,
    StudyUserListView = 30,
    PatientReviewApproval = 31,
}

export class AvailableFormDto implements IAvailableFormDto {
    id!: number;
    type!: string;

    constructor(data?: IAvailableFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AvailableFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IAvailableFormDto {
    id: number;
    type: string;
}

export class DoctorStudyListDto implements IDoctorStudyListDto {
    counters!: DoctorStudyListCounter;
    studies!: PagedResultOfStudyDto;

    constructor(data?: IDoctorStudyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.counters = new DoctorStudyListCounter();
            this.studies = new PagedResultOfStudyDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counters = _data["counters"] ? DoctorStudyListCounter.fromJS(_data["counters"]) : new DoctorStudyListCounter();
            this.studies = _data["studies"] ? PagedResultOfStudyDto.fromJS(_data["studies"]) : new PagedResultOfStudyDto();
        }
    }

    static fromJS(data: any): DoctorStudyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorStudyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counters"] = this.counters ? this.counters.toJSON() : <any>null;
        data["studies"] = this.studies ? this.studies.toJSON() : <any>null;
        return data;
    }
}

export interface IDoctorStudyListDto {
    counters: DoctorStudyListCounter;
    studies: PagedResultOfStudyDto;
}

export class DoctorStudyListCounter implements IDoctorStudyListCounter {
    /** Amount of overall studies */
    all!: number;
    /** Amount of active studies */
    active!: number;
    /** Amount of closed studies */
    closed!: number;

    constructor(data?: IDoctorStudyListCounter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.all = _data["all"];
            this.active = _data["active"];
            this.closed = _data["closed"];
        }
    }

    static fromJS(data: any): DoctorStudyListCounter {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorStudyListCounter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["all"] = this.all;
        data["active"] = this.active;
        data["closed"] = this.closed;
        return data;
    }
}

export interface IDoctorStudyListCounter {
    /** Amount of overall studies */
    all: number;
    /** Amount of active studies */
    active: number;
    /** Amount of closed studies */
    closed: number;
}

export class PagedResultOfStudyDto implements IPagedResultOfStudyDto {
    data!: StudyDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfStudyDto {
    data: StudyDto[];
    totalCount: number;
}

export class StudyDto implements IStudyDto {
    /** Study id. */
    id!: number;
    /** Number of the Study. */
    studyNumber!: string;
    /** Short description of the study. */
    title!: string | null;
    /** Description and proposal of study. */
    description!: string | null;
    /** Date when study has been started. */
    startDate!: Date;
    /** Date when study must finish. */
    duration!: number;
    /** Date of study creation. */
    createdAt!: Date;
    /** List of available groups in study. */
    groups!: GroupTitleDto[];
    /** When the study closing is approved */
    closingApprovedAt!: Date | null;
    /** Stuff who approve study closure */
    closingApprovedBy!: DoctorDto | null;
    /** When the study closed */
    closedAt!: Date | null;
    /** Stuff who close the study */
    closedBy!: DoctorDto | null;

    constructor(data?: IStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyNumber = _data["studyNumber"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.duration = _data["duration"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupTitleDto.fromJS(item));
            }
            this.closingApprovedAt = _data["closingApprovedAt"] ? new Date(_data["closingApprovedAt"].toString()) : <any>null;
            this.closingApprovedBy = _data["closingApprovedBy"] ? DoctorDto.fromJS(_data["closingApprovedBy"]) : <any>null;
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : <any>null;
            this.closedBy = _data["closedBy"] ? DoctorDto.fromJS(_data["closedBy"]) : <any>null;
        }
    }

    static fromJS(data: any): StudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyNumber"] = this.studyNumber;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["duration"] = this.duration;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["closingApprovedAt"] = this.closingApprovedAt && this.closingApprovedAt.toISOString();
        data["closingApprovedBy"] = this.closingApprovedBy ? this.closingApprovedBy.toJSON() : <any>null;
        data["closedAt"] = this.closedAt && this.closedAt.toISOString();
        data["closedBy"] = this.closedBy ? this.closedBy.toJSON() : <any>null;
        return data;
    }
}

export interface IStudyDto {
    /** Study id. */
    id: number;
    /** Number of the Study. */
    studyNumber: string;
    /** Short description of the study. */
    title: string | null;
    /** Description and proposal of study. */
    description: string | null;
    /** Date when study has been started. */
    startDate: Date;
    /** Date when study must finish. */
    duration: number;
    /** Date of study creation. */
    createdAt: Date;
    /** List of available groups in study. */
    groups: GroupTitleDto[];
    /** When the study closing is approved */
    closingApprovedAt: Date | null;
    /** Stuff who approve study closure */
    closingApprovedBy: DoctorDto | null;
    /** When the study closed */
    closedAt: Date | null;
    /** Stuff who close the study */
    closedBy: DoctorDto | null;
}

export class GroupTitleDto implements IGroupTitleDto {
    /** Id of the group */
    id!: number;
    /** Title of the groups. Will be presented on the UI patient table. */
    title!: string;

    constructor(data?: IGroupTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): GroupTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IGroupTitleDto {
    /** Id of the group */
    id: number;
    /** Title of the groups. Will be presented on the UI patient table. */
    title: string;
}

export class StudyAttachmentDto implements IStudyAttachmentDto {
    /** The id of the attached file */
    fileId!: string;
    /** The name of the attached file */
    fileName!: string;
    /** File size. */
    fileSizeBytes!: number;

    constructor(data?: IStudyAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileSizeBytes = _data["fileSizeBytes"];
        }
    }

    static fromJS(data: any): StudyAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileSizeBytes"] = this.fileSizeBytes;
        return data;
    }
}

export interface IStudyAttachmentDto {
    /** The id of the attached file */
    fileId: string;
    /** The name of the attached file */
    fileName: string;
    /** File size. */
    fileSizeBytes: number;
}

export class PatientStudyDto implements IPatientStudyDto {
    /** Id of study. */
    id!: number;
    /** Title of study. */
    title!: string;
    /** Description and proposal of study. */
    description!: string;
    /** Date when study is getting started. */
    sinceDate!: Date | null;
    /** Date when study must finish. */
    tillDate!: Date | null;
    /** Flag indicating that the study is finished */
    isFinished!: boolean;
    /** Flag indicating that the study has therapy data */
    hasTherapyData!: boolean;
    /** Patient therapy daily statistics from PrismaCloud. */
    statistics!: PatientsStatisticDto[];
    /** List of questionnaires. */
    questionnaires!: QuestionnaireDto[];
    /** List of surveys which can be triggered by patient. */
    canBeTriggeredByPatientSurveys!: SurveyDto[];
    /** List of answers already filled in by patient. */
    surveyRecords?: SurveyRecordDto[] | null;

    constructor(data?: IPatientStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statistics = [];
            this.questionnaires = [];
            this.canBeTriggeredByPatientSurveys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.sinceDate = _data["sinceDate"] ? parseDateOnly(_data["sinceDate"].toString()) : <any>null;
            this.tillDate = _data["tillDate"] ? new Date(_data["tillDate"].toString()) : <any>null;
            this.isFinished = _data["isFinished"];
            this.hasTherapyData = _data["hasTherapyData"];
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(PatientsStatisticDto.fromJS(item));
            }
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(QuestionnaireDto.fromJS(item));
            }
            if (Array.isArray(_data["canBeTriggeredByPatientSurveys"])) {
                this.canBeTriggeredByPatientSurveys = [] as any;
                for (let item of _data["canBeTriggeredByPatientSurveys"])
                    this.canBeTriggeredByPatientSurveys!.push(SurveyDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyRecords"])) {
                this.surveyRecords = [] as any;
                for (let item of _data["surveyRecords"])
                    this.surveyRecords!.push(SurveyRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sinceDate"] = this.sinceDate && formatDate(this.sinceDate);
        data["tillDate"] = this.tillDate && this.tillDate.toISOString();
        data["isFinished"] = this.isFinished;
        data["hasTherapyData"] = this.hasTherapyData;
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item.toJSON());
        }
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item.toJSON());
        }
        if (Array.isArray(this.canBeTriggeredByPatientSurveys)) {
            data["canBeTriggeredByPatientSurveys"] = [];
            for (let item of this.canBeTriggeredByPatientSurveys)
                data["canBeTriggeredByPatientSurveys"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyRecords)) {
            data["surveyRecords"] = [];
            for (let item of this.surveyRecords)
                data["surveyRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientStudyDto {
    /** Id of study. */
    id: number;
    /** Title of study. */
    title: string;
    /** Description and proposal of study. */
    description: string;
    /** Date when study is getting started. */
    sinceDate: Date | null;
    /** Date when study must finish. */
    tillDate: Date | null;
    /** Flag indicating that the study is finished */
    isFinished: boolean;
    /** Flag indicating that the study has therapy data */
    hasTherapyData: boolean;
    /** Patient therapy daily statistics from PrismaCloud. */
    statistics: PatientsStatisticDto[];
    /** List of questionnaires. */
    questionnaires: QuestionnaireDto[];
    /** List of surveys which can be triggered by patient. */
    canBeTriggeredByPatientSurveys: SurveyDto[];
    /** List of answers already filled in by patient. */
    surveyRecords?: SurveyRecordDto[] | null;
}

export class PatientsStatisticDto implements IPatientsStatisticDto {
    /** Day of therapy */
    therapyDay!: Date;
    /** Number of minutes device usage per day. */
    compliance!: number | null;
    /** Number of liters per hour during device usage per day. */
    leakage!: number | null;
    /** Indicates that day is empty (with zero usage or empty at all) */
    isEmptyDay!: boolean;
    /** Indicates is it a current day or not. */
    isCurrentDay!: boolean | null;
    /** Indicates that user has achieved usage goal per day or not. */
    isComplianceGoalReached!: boolean;
    /** Indicates that leakage is upper than 25 l/min for day */
    isHighValueOfLeakage!: boolean;
    /** Indicates that data was not received in the system. */
    isNotReceived!: boolean | null;
    /** Indicates "DailyCheck" value. */
    dailyCheckValue!: number | null;

    constructor(data?: IPatientsStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.therapyDay = _data["therapyDay"] ? parseDateOnly(_data["therapyDay"].toString()) : <any>null;
            this.compliance = _data["compliance"];
            this.leakage = _data["leakage"];
            this.isEmptyDay = _data["isEmptyDay"];
            this.isCurrentDay = _data["isCurrentDay"];
            this.isComplianceGoalReached = _data["isComplianceGoalReached"];
            this.isHighValueOfLeakage = _data["isHighValueOfLeakage"];
            this.isNotReceived = _data["isNotReceived"];
            this.dailyCheckValue = _data["dailyCheckValue"];
        }
    }

    static fromJS(data: any): PatientsStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["therapyDay"] = this.therapyDay && formatDate(this.therapyDay);
        data["compliance"] = this.compliance;
        data["leakage"] = this.leakage;
        data["isEmptyDay"] = this.isEmptyDay;
        data["isCurrentDay"] = this.isCurrentDay;
        data["isComplianceGoalReached"] = this.isComplianceGoalReached;
        data["isHighValueOfLeakage"] = this.isHighValueOfLeakage;
        data["isNotReceived"] = this.isNotReceived;
        data["dailyCheckValue"] = this.dailyCheckValue;
        return data;
    }
}

export interface IPatientsStatisticDto {
    /** Day of therapy */
    therapyDay: Date;
    /** Number of minutes device usage per day. */
    compliance: number | null;
    /** Number of liters per hour during device usage per day. */
    leakage: number | null;
    /** Indicates that day is empty (with zero usage or empty at all) */
    isEmptyDay: boolean;
    /** Indicates is it a current day or not. */
    isCurrentDay: boolean | null;
    /** Indicates that user has achieved usage goal per day or not. */
    isComplianceGoalReached: boolean;
    /** Indicates that leakage is upper than 25 l/min for day */
    isHighValueOfLeakage: boolean;
    /** Indicates that data was not received in the system. */
    isNotReceived: boolean | null;
    /** Indicates "DailyCheck" value. */
    dailyCheckValue: number | null;
}

export class QuestionnaireDto implements IQuestionnaireDto {
    /** Unique identifier of patient's survey. */
    id!: number;
    /** Unique identifier of study's survey. */
    surveyId!: number;
    /** JSON-contract of questionnaire. */
    questionsScheme!: QuestionScheme;
    /** Questionnaire-survey type. */
    type!: SurveyType;
    /** Questionnaire-survey type to string. */
    typeString!: string;
    /** Close to expire date flag. */
    isCloseToExpired!: boolean;
    /** Server date with time */
    serverTime!: Date;
    /** Answer for related iteration. */
    answer!: AnswerDto | null;
    /** Shows if questionnaire was completely answered. */
    isCompleted!: boolean;
    /** Date since which questionnaire can be answered. */
    startDate!: Date;
    /** Date when questionnaire becomes expired if it isn't answered. */
    endDate!: Date;
    /** Id of doctor who triggered questionnaire or "scheduler" if it was planned questionnaire. */
    triggeredBy!: string;
    /** Flag indicates that the doctor can fill this survey */
    canBeFilledByDoctor!: boolean;
    /** Flag indicates that the patient triggered this survey */
    triggeredByPatient!: boolean;
    /** The survey was triggered by a doctor */
    triggeredByDoctor!: boolean;
    /** Description of survey. */
    surveyTitle!: string;
    /** Survey icon type */
    surveyIcon!: SurveyIcon;
    /** Settings for mobile app only */
    appSettings!: AppSettings;

    constructor(data?: IQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questionsScheme = new QuestionScheme();
            this.appSettings = new AppSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.questionsScheme = _data["questionsScheme"] ? QuestionScheme.fromJS(_data["questionsScheme"]) : new QuestionScheme();
            this.type = _data["type"];
            this.typeString = _data["typeString"];
            this.isCloseToExpired = _data["isCloseToExpired"];
            this.serverTime = _data["serverTime"] ? new Date(_data["serverTime"].toString()) : <any>null;
            this.answer = _data["answer"] ? AnswerDto.fromJS(_data["answer"]) : <any>null;
            this.isCompleted = _data["isCompleted"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.triggeredBy = _data["triggeredBy"];
            this.canBeFilledByDoctor = _data["canBeFilledByDoctor"];
            this.triggeredByPatient = _data["triggeredByPatient"];
            this.triggeredByDoctor = _data["triggeredByDoctor"];
            this.surveyTitle = _data["surveyTitle"];
            this.surveyIcon = _data["surveyIcon"];
            this.appSettings = _data["appSettings"] ? AppSettings.fromJS(_data["appSettings"]) : new AppSettings();
        }
    }

    static fromJS(data: any): QuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["questionsScheme"] = this.questionsScheme ? this.questionsScheme.toJSON() : <any>null;
        data["type"] = this.type;
        data["typeString"] = this.typeString;
        data["isCloseToExpired"] = this.isCloseToExpired;
        data["serverTime"] = this.serverTime && this.serverTime.toISOString();
        data["answer"] = this.answer ? this.answer.toJSON() : <any>null;
        data["isCompleted"] = this.isCompleted;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["triggeredBy"] = this.triggeredBy;
        data["canBeFilledByDoctor"] = this.canBeFilledByDoctor;
        data["triggeredByPatient"] = this.triggeredByPatient;
        data["triggeredByDoctor"] = this.triggeredByDoctor;
        data["surveyTitle"] = this.surveyTitle;
        data["surveyIcon"] = this.surveyIcon;
        data["appSettings"] = this.appSettings ? this.appSettings.toJSON() : <any>null;
        return data;
    }
}

export interface IQuestionnaireDto {
    /** Unique identifier of patient's survey. */
    id: number;
    /** Unique identifier of study's survey. */
    surveyId: number;
    /** JSON-contract of questionnaire. */
    questionsScheme: QuestionScheme;
    /** Questionnaire-survey type. */
    type: SurveyType;
    /** Questionnaire-survey type to string. */
    typeString: string;
    /** Close to expire date flag. */
    isCloseToExpired: boolean;
    /** Server date with time */
    serverTime: Date;
    /** Answer for related iteration. */
    answer: AnswerDto | null;
    /** Shows if questionnaire was completely answered. */
    isCompleted: boolean;
    /** Date since which questionnaire can be answered. */
    startDate: Date;
    /** Date when questionnaire becomes expired if it isn't answered. */
    endDate: Date;
    /** Id of doctor who triggered questionnaire or "scheduler" if it was planned questionnaire. */
    triggeredBy: string;
    /** Flag indicates that the doctor can fill this survey */
    canBeFilledByDoctor: boolean;
    /** Flag indicates that the patient triggered this survey */
    triggeredByPatient: boolean;
    /** The survey was triggered by a doctor */
    triggeredByDoctor: boolean;
    /** Description of survey. */
    surveyTitle: string;
    /** Survey icon type */
    surveyIcon: SurveyIcon;
    /** Settings for mobile app only */
    appSettings: AppSettings;
}

export class AnswerDto implements IAnswerDto {
    id!: number;
    surveyId!: number;
    questionnaireId!: number;
    answerObject!: QuestionScheme;
    isSubmitted!: boolean;
    creationDate!: Date;
    lastModifiedAt!: Date;
    duration!: string;
    finishPercentage!: number;
    iterationNumber!: number;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation!: boolean;

    constructor(data?: IAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answerObject = new QuestionScheme();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.questionnaireId = _data["questionnaireId"];
            this.answerObject = _data["answerObject"] ? QuestionScheme.fromJS(_data["answerObject"]) : new QuestionScheme();
            this.isSubmitted = _data["isSubmitted"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>null;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>null;
            this.duration = _data["duration"];
            this.finishPercentage = _data["finishPercentage"];
            this.iterationNumber = _data["iterationNumber"];
            this.canRetryScoreCalculation = _data["canRetryScoreCalculation"];
        }
    }

    static fromJS(data: any): AnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["questionnaireId"] = this.questionnaireId;
        data["answerObject"] = this.answerObject ? this.answerObject.toJSON() : <any>null;
        data["isSubmitted"] = this.isSubmitted;
        data["creationDate"] = this.creationDate && this.creationDate.toISOString();
        data["lastModifiedAt"] = this.lastModifiedAt && this.lastModifiedAt.toISOString();
        data["duration"] = this.duration;
        data["finishPercentage"] = this.finishPercentage;
        data["iterationNumber"] = this.iterationNumber;
        data["canRetryScoreCalculation"] = this.canRetryScoreCalculation;
        return data;
    }
}

export interface IAnswerDto {
    id: number;
    surveyId: number;
    questionnaireId: number;
    answerObject: QuestionScheme;
    isSubmitted: boolean;
    creationDate: Date;
    lastModifiedAt: Date;
    duration: string;
    finishPercentage: number;
    iterationNumber: number;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation: boolean;
}

export class SurveyRecordDto implements ISurveyRecordDto {
    /** Survey */
    survey!: SurveyDto;
    /** Count of answers for this survey type */
    answersCount!: number;

    constructor(data?: ISurveyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.survey = new SurveyDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.survey = _data["survey"] ? SurveyDto.fromJS(_data["survey"]) : new SurveyDto();
            this.answersCount = _data["answersCount"];
        }
    }

    static fromJS(data: any): SurveyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : <any>null;
        data["answersCount"] = this.answersCount;
        return data;
    }
}

export interface ISurveyRecordDto {
    /** Survey */
    survey: SurveyDto;
    /** Count of answers for this survey type */
    answersCount: number;
}

export class CreateStudyDto implements ICreateStudyDto {
    /** Number of the Study. */
    studyNumber!: string;
    /** Short name of the study. */
    title!: string;
    /** Description and proposal of the study */
    description!: string;
    /** Primary objective of the study */
    primaryObjectiveText!: string | null;
    /** Date when study must have been started.
It has influence on date consumption from PCloud system. */
    startDate!: Date;
    /** Length of study in days number. */
    duration!: number;
    /** Planned number of patients in the study. */
    plannedPatients!: number | null;
    /** Flag indicates that the study uses therapy data */
    hasTherapy!: boolean;
    /** Flag indicates that the study has enabled Monitoring(issues) feature. */
    hasMonitoring!: boolean;
    /** Configuration of Study Info Page */
    infoPageConfiguration!: StudyInfoPageConfigurationDto | null;
    /** External API token of PrismaCloud system. */
    token!: string | null;
    /** URL-address of of PrismaCloud system.
https://YOUR_SUBDOMAIN.prismacloud.com */
    prismaCloudUrl!: string | null;
    /** List of groups for new study. */
    groups!: CreateGroupDto[];
    /** Number of days for creating a patient in advance */
    patientStudyStartAdvanceDays!: number | null;
    /** Number of days for aggregation therapy data (usage, AHI, Leakage etc.) */
    therapyAggregationPeriod!: number;

    constructor(data?: ICreateStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyNumber = _data["studyNumber"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.primaryObjectiveText = _data["primaryObjectiveText"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.duration = _data["duration"];
            this.plannedPatients = _data["plannedPatients"];
            this.hasTherapy = _data["hasTherapy"];
            this.hasMonitoring = _data["hasMonitoring"];
            this.infoPageConfiguration = _data["infoPageConfiguration"] ? StudyInfoPageConfigurationDto.fromJS(_data["infoPageConfiguration"]) : <any>null;
            this.token = _data["token"];
            this.prismaCloudUrl = _data["prismaCloudUrl"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(CreateGroupDto.fromJS(item));
            }
            this.patientStudyStartAdvanceDays = _data["patientStudyStartAdvanceDays"];
            this.therapyAggregationPeriod = _data["therapyAggregationPeriod"];
        }
    }

    static fromJS(data: any): CreateStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyNumber"] = this.studyNumber;
        data["title"] = this.title;
        data["description"] = this.description;
        data["primaryObjectiveText"] = this.primaryObjectiveText;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["duration"] = this.duration;
        data["plannedPatients"] = this.plannedPatients;
        data["hasTherapy"] = this.hasTherapy;
        data["hasMonitoring"] = this.hasMonitoring;
        data["infoPageConfiguration"] = this.infoPageConfiguration ? this.infoPageConfiguration.toJSON() : <any>null;
        data["token"] = this.token;
        data["prismaCloudUrl"] = this.prismaCloudUrl;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["patientStudyStartAdvanceDays"] = this.patientStudyStartAdvanceDays;
        data["therapyAggregationPeriod"] = this.therapyAggregationPeriod;
        return data;
    }
}

export interface ICreateStudyDto {
    /** Number of the Study. */
    studyNumber: string;
    /** Short name of the study. */
    title: string;
    /** Description and proposal of the study */
    description: string;
    /** Primary objective of the study */
    primaryObjectiveText: string | null;
    /** Date when study must have been started.
It has influence on date consumption from PCloud system. */
    startDate: Date;
    /** Length of study in days number. */
    duration: number;
    /** Planned number of patients in the study. */
    plannedPatients: number | null;
    /** Flag indicates that the study uses therapy data */
    hasTherapy: boolean;
    /** Flag indicates that the study has enabled Monitoring(issues) feature. */
    hasMonitoring: boolean;
    /** Configuration of Study Info Page */
    infoPageConfiguration: StudyInfoPageConfigurationDto | null;
    /** External API token of PrismaCloud system. */
    token: string | null;
    /** URL-address of of PrismaCloud system.
https://YOUR_SUBDOMAIN.prismacloud.com */
    prismaCloudUrl: string | null;
    /** List of groups for new study. */
    groups: CreateGroupDto[];
    /** Number of days for creating a patient in advance */
    patientStudyStartAdvanceDays: number | null;
    /** Number of days for aggregation therapy data (usage, AHI, Leakage etc.) */
    therapyAggregationPeriod: number;
}

export class CreateGroupDto implements ICreateGroupDto {
    /** Title of the groups. Will be presented on the UI patient table. */
    title!: string;
    /** Set of the visible/disabled columns */
    tableColumns!: TableColumnsEnum;
    /** List of survey columns for a dashboard */
    surveyColumns?: string[] | null;
    /** List of surveys for a patient card section */
    surveysToPatientCard?: string[] | null;
    /** Describes which sections should be in patient card
e.g. [ columnOne: [GeneralInfo, Records, Stage], columnTwo: [Surveys, AppInformation], columnThree: [Notes, Analyzes] ] */
    patientCardSections!: CardSectionsEnum[][];
    formConfigIdForNotes?: number | null;
    noteDateDataKey?: string | null;
    mainNoteFieldDataKey?: string | null;

    constructor(data?: ICreateGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.patientCardSections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.tableColumns = _data["tableColumns"];
            if (Array.isArray(_data["surveyColumns"])) {
                this.surveyColumns = [] as any;
                for (let item of _data["surveyColumns"])
                    this.surveyColumns!.push(item);
            }
            if (Array.isArray(_data["surveysToPatientCard"])) {
                this.surveysToPatientCard = [] as any;
                for (let item of _data["surveysToPatientCard"])
                    this.surveysToPatientCard!.push(item);
            }
            if (Array.isArray(_data["patientCardSections"])) {
                this.patientCardSections = [] as any;
                for (let item of _data["patientCardSections"])
                    this.patientCardSections!.push(item);
            }
            this.formConfigIdForNotes = _data["formConfigIdForNotes"];
            this.noteDateDataKey = _data["noteDateDataKey"];
            this.mainNoteFieldDataKey = _data["mainNoteFieldDataKey"];
        }
    }

    static fromJS(data: any): CreateGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["tableColumns"] = this.tableColumns;
        if (Array.isArray(this.surveyColumns)) {
            data["surveyColumns"] = [];
            for (let item of this.surveyColumns)
                data["surveyColumns"].push(item);
        }
        if (Array.isArray(this.surveysToPatientCard)) {
            data["surveysToPatientCard"] = [];
            for (let item of this.surveysToPatientCard)
                data["surveysToPatientCard"].push(item);
        }
        if (Array.isArray(this.patientCardSections)) {
            data["patientCardSections"] = [];
            for (let item of this.patientCardSections)
                data["patientCardSections"].push(item);
        }
        data["formConfigIdForNotes"] = this.formConfigIdForNotes;
        data["noteDateDataKey"] = this.noteDateDataKey;
        data["mainNoteFieldDataKey"] = this.mainNoteFieldDataKey;
        return data;
    }
}

export interface ICreateGroupDto {
    /** Title of the groups. Will be presented on the UI patient table. */
    title: string;
    /** Set of the visible/disabled columns */
    tableColumns: TableColumnsEnum;
    /** List of survey columns for a dashboard */
    surveyColumns?: string[] | null;
    /** List of surveys for a patient card section */
    surveysToPatientCard?: string[] | null;
    /** Describes which sections should be in patient card
e.g. [ columnOne: [GeneralInfo, Records, Stage], columnTwo: [Surveys, AppInformation], columnThree: [Notes, Analyzes] ] */
    patientCardSections: CardSectionsEnum[][];
    formConfigIdForNotes?: number | null;
    noteDateDataKey?: string | null;
    mainNoteFieldDataKey?: string | null;
}

export class UpdateGroupDto implements IUpdateGroupDto {
    /** New set of displayed columns. */
    tableColumns?: TableColumnsEnum | null;
    /** New title of the group. */
    title?: string | null;
    /** List of survey columns for a dashboard */
    surveyColumns?: string[] | null;
    /** List of surveys for a patient card section */
    surveysToPatientCard?: string[] | null;
    /** Describes which sections should be in patient card
e.g. [ columnOne: [GeneralInfo, Records, Stage], columnTwo: [Surveys, AppInformation], columnThree: [Notes, Analyzes] ] */
    patientCardSections?: CardSectionsEnum[][] | null;
    formConfigIdForNotes?: number | null;
    noteDateDataKey?: string | null;
    mainNoteFieldDataKey?: string | null;

    constructor(data?: IUpdateGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableColumns = _data["tableColumns"];
            this.title = _data["title"];
            if (Array.isArray(_data["surveyColumns"])) {
                this.surveyColumns = [] as any;
                for (let item of _data["surveyColumns"])
                    this.surveyColumns!.push(item);
            }
            if (Array.isArray(_data["surveysToPatientCard"])) {
                this.surveysToPatientCard = [] as any;
                for (let item of _data["surveysToPatientCard"])
                    this.surveysToPatientCard!.push(item);
            }
            if (Array.isArray(_data["patientCardSections"])) {
                this.patientCardSections = [] as any;
                for (let item of _data["patientCardSections"])
                    this.patientCardSections!.push(item);
            }
            this.formConfigIdForNotes = _data["formConfigIdForNotes"];
            this.noteDateDataKey = _data["noteDateDataKey"];
            this.mainNoteFieldDataKey = _data["mainNoteFieldDataKey"];
        }
    }

    static fromJS(data: any): UpdateGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableColumns"] = this.tableColumns;
        data["title"] = this.title;
        if (Array.isArray(this.surveyColumns)) {
            data["surveyColumns"] = [];
            for (let item of this.surveyColumns)
                data["surveyColumns"].push(item);
        }
        if (Array.isArray(this.surveysToPatientCard)) {
            data["surveysToPatientCard"] = [];
            for (let item of this.surveysToPatientCard)
                data["surveysToPatientCard"].push(item);
        }
        if (Array.isArray(this.patientCardSections)) {
            data["patientCardSections"] = [];
            for (let item of this.patientCardSections)
                data["patientCardSections"].push(item);
        }
        data["formConfigIdForNotes"] = this.formConfigIdForNotes;
        data["noteDateDataKey"] = this.noteDateDataKey;
        data["mainNoteFieldDataKey"] = this.mainNoteFieldDataKey;
        return data;
    }
}

export interface IUpdateGroupDto {
    /** New set of displayed columns. */
    tableColumns?: TableColumnsEnum | null;
    /** New title of the group. */
    title?: string | null;
    /** List of survey columns for a dashboard */
    surveyColumns?: string[] | null;
    /** List of surveys for a patient card section */
    surveysToPatientCard?: string[] | null;
    /** Describes which sections should be in patient card
e.g. [ columnOne: [GeneralInfo, Records, Stage], columnTwo: [Surveys, AppInformation], columnThree: [Notes, Analyzes] ] */
    patientCardSections?: CardSectionsEnum[][] | null;
    formConfigIdForNotes?: number | null;
    noteDateDataKey?: string | null;
    mainNoteFieldDataKey?: string | null;
}

export class PatchStudyDto implements IPatchStudyDto {
    /** new title of teh study. */
    title?: string;
    /** New description of teh study */
    description?: string;
    /** Primary objective of the study */
    primaryObjectiveText?: string;
    /** New study number of the study. */
    studyNumber?: string;
    /** Planned number of patients in the study. */
    plannedPatients?: number | null;
    /** New aggregation period of the study */
    therapyAggregationPeriod?: number;
    /** Flag that turn ON or OFF sync with PrismaCloud */
    hasTherapy?: boolean;
    /** Flag that turn ON or OFF Monitoring (issue tracking) feature */
    hasMonitoring?: boolean;
    /** Flag indicates that the study uses pdf signing */
    hasPdfSigning?: boolean;
    /** Flag indicates that the study uses eCRF feature */
    hasEcrf?: boolean;
    /** Flag indicates that the study uses DB import */
    hasDbImport?: boolean;
    /** Flag indicates that mobile surveys are configured in study */
    hasSurveys?: boolean;
    /** Number of days for creating a patient in advance */
    patientStudyStartAdvanceDays?: number | null;
    /** Form Id of patient finish form. */
    patientFinishingFormId?: number | null;

    constructor(data?: IPatchStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.primaryObjectiveText = _data["primaryObjectiveText"];
            this.studyNumber = _data["studyNumber"];
            this.plannedPatients = _data["plannedPatients"];
            this.therapyAggregationPeriod = _data["therapyAggregationPeriod"];
            this.hasTherapy = _data["hasTherapy"];
            this.hasMonitoring = _data["hasMonitoring"];
            this.hasPdfSigning = _data["hasPdfSigning"];
            this.hasEcrf = _data["hasEcrf"];
            this.hasDbImport = _data["hasDbImport"];
            this.hasSurveys = _data["hasSurveys"];
            this.patientStudyStartAdvanceDays = _data["patientStudyStartAdvanceDays"];
            this.patientFinishingFormId = _data["patientFinishingFormId"];
        }
    }

    static fromJS(data: any): PatchStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["primaryObjectiveText"] = this.primaryObjectiveText;
        data["studyNumber"] = this.studyNumber;
        data["plannedPatients"] = this.plannedPatients;
        data["therapyAggregationPeriod"] = this.therapyAggregationPeriod;
        data["hasTherapy"] = this.hasTherapy;
        data["hasMonitoring"] = this.hasMonitoring;
        data["hasPdfSigning"] = this.hasPdfSigning;
        data["hasEcrf"] = this.hasEcrf;
        data["hasDbImport"] = this.hasDbImport;
        data["hasSurveys"] = this.hasSurveys;
        data["patientStudyStartAdvanceDays"] = this.patientStudyStartAdvanceDays;
        data["patientFinishingFormId"] = this.patientFinishingFormId;
        return data;
    }
}

export interface IPatchStudyDto {
    /** new title of teh study. */
    title?: string;
    /** New description of teh study */
    description?: string;
    /** Primary objective of the study */
    primaryObjectiveText?: string;
    /** New study number of the study. */
    studyNumber?: string;
    /** Planned number of patients in the study. */
    plannedPatients?: number | null;
    /** New aggregation period of the study */
    therapyAggregationPeriod?: number;
    /** Flag that turn ON or OFF sync with PrismaCloud */
    hasTherapy?: boolean;
    /** Flag that turn ON or OFF Monitoring (issue tracking) feature */
    hasMonitoring?: boolean;
    /** Flag indicates that the study uses pdf signing */
    hasPdfSigning?: boolean;
    /** Flag indicates that the study uses eCRF feature */
    hasEcrf?: boolean;
    /** Flag indicates that the study uses DB import */
    hasDbImport?: boolean;
    /** Flag indicates that mobile surveys are configured in study */
    hasSurveys?: boolean;
    /** Number of days for creating a patient in advance */
    patientStudyStartAdvanceDays?: number | null;
    /** Form Id of patient finish form. */
    patientFinishingFormId?: number | null;
}

export class UpdatePrismaClientDto implements IUpdatePrismaClientDto {
    /** External API token of PrismaCloud system. */
    prismaCloudToken?: string;
    /** URL-address of of PrismaCloud system.
https://YOUR_SUBDOMAIN.prismacloud.com */
    prismaCloudUrl?: string;

    constructor(data?: IUpdatePrismaClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prismaCloudToken = _data["prismaCloudToken"];
            this.prismaCloudUrl = _data["prismaCloudUrl"];
        }
    }

    static fromJS(data: any): UpdatePrismaClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrismaClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prismaCloudToken"] = this.prismaCloudToken;
        data["prismaCloudUrl"] = this.prismaCloudUrl;
        return data;
    }
}

export interface IUpdatePrismaClientDto {
    /** External API token of PrismaCloud system. */
    prismaCloudToken?: string;
    /** URL-address of of PrismaCloud system.
https://YOUR_SUBDOMAIN.prismacloud.com */
    prismaCloudUrl?: string;
}

export class StudyRecruitmentProgressDto implements IStudyRecruitmentProgressDto {
    /** Planned number of patients in the study.
This number is set by doctor and can be null if doctor doesn't want to set it. */
    planned!: number | null;
    /** Number of patients created */
    created!: number;
    /** Number of patients dropped out of the study. Currently not implemented, will be 0 until logic is implemented. */
    dropOuts!: number;
    /** Number of patients that are still needed to reach the planned number. Will be null if planned number is not set. */
    toDo!: number | null;
    /** Percent of recruitment progress. Calculated as (Created / Planned) * 100. Will be null if planned number is not set. */
    progressPercent!: number | null;

    constructor(data?: IStudyRecruitmentProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planned = _data["planned"];
            this.created = _data["created"];
            this.dropOuts = _data["dropOuts"];
            this.toDo = _data["toDo"];
            this.progressPercent = _data["progressPercent"];
        }
    }

    static fromJS(data: any): StudyRecruitmentProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyRecruitmentProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planned"] = this.planned;
        data["created"] = this.created;
        data["dropOuts"] = this.dropOuts;
        data["toDo"] = this.toDo;
        data["progressPercent"] = this.progressPercent;
        return data;
    }
}

export interface IStudyRecruitmentProgressDto {
    /** Planned number of patients in the study.
This number is set by doctor and can be null if doctor doesn't want to set it. */
    planned: number | null;
    /** Number of patients created */
    created: number;
    /** Number of patients dropped out of the study. Currently not implemented, will be 0 until logic is implemented. */
    dropOuts: number;
    /** Number of patients that are still needed to reach the planned number. Will be null if planned number is not set. */
    toDo: number | null;
    /** Percent of recruitment progress. Calculated as (Created / Planned) * 100. Will be null if planned number is not set. */
    progressPercent: number | null;
}

export class PatientGroupSummaryDto implements IPatientGroupSummaryDto {
    /** Id of the study group */
    groupId!: number;
    /** Title of the study group */
    groupTitle!: string;
    /** Counters of patients in the group per study state (not started, in progress, finished, archived, dropped out) */
    patientsPerStudyStateCounters!: PatientPerStudyStateCounters;
    /** Counters of patients in the group per progress step (for example, initial, control-1, control-2, final, etc.) */
    patientsPerProgressStepCounters!: PatientsPerProgressStepCounter[];

    constructor(data?: IPatientGroupSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.patientsPerStudyStateCounters = new PatientPerStudyStateCounters();
            this.patientsPerProgressStepCounters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupTitle = _data["groupTitle"];
            this.patientsPerStudyStateCounters = _data["patientsPerStudyStateCounters"] ? PatientPerStudyStateCounters.fromJS(_data["patientsPerStudyStateCounters"]) : new PatientPerStudyStateCounters();
            if (Array.isArray(_data["patientsPerProgressStepCounters"])) {
                this.patientsPerProgressStepCounters = [] as any;
                for (let item of _data["patientsPerProgressStepCounters"])
                    this.patientsPerProgressStepCounters!.push(PatientsPerProgressStepCounter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientGroupSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGroupSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupTitle"] = this.groupTitle;
        data["patientsPerStudyStateCounters"] = this.patientsPerStudyStateCounters ? this.patientsPerStudyStateCounters.toJSON() : <any>null;
        if (Array.isArray(this.patientsPerProgressStepCounters)) {
            data["patientsPerProgressStepCounters"] = [];
            for (let item of this.patientsPerProgressStepCounters)
                data["patientsPerProgressStepCounters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientGroupSummaryDto {
    /** Id of the study group */
    groupId: number;
    /** Title of the study group */
    groupTitle: string;
    /** Counters of patients in the group per study state (not started, in progress, finished, archived, dropped out) */
    patientsPerStudyStateCounters: PatientPerStudyStateCounters;
    /** Counters of patients in the group per progress step (for example, initial, control-1, control-2, final, etc.) */
    patientsPerProgressStepCounters: PatientsPerProgressStepCounter[];
}

export class PatientPerStudyStateCounters implements IPatientPerStudyStateCounters {
    /** General patient count in the group */
    patientCount!: number;
    /** Patient count in the group with not started study state */
    notStarted!: number;
    /** Patient count in the group with in progress study state */
    inProgress!: number;
    /** Patient count in the group with finished study state */
    finished!: number;
    /** Patient count in the group with archived study state
             */
    archived!: number;
    /** Patient count in the group with dropped out study state */
    droppedOut!: number;

    constructor(data?: IPatientPerStudyStateCounters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientCount = _data["patientCount"];
            this.notStarted = _data["notStarted"];
            this.inProgress = _data["inProgress"];
            this.finished = _data["finished"];
            this.archived = _data["archived"];
            this.droppedOut = _data["droppedOut"];
        }
    }

    static fromJS(data: any): PatientPerStudyStateCounters {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPerStudyStateCounters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientCount"] = this.patientCount;
        data["notStarted"] = this.notStarted;
        data["inProgress"] = this.inProgress;
        data["finished"] = this.finished;
        data["archived"] = this.archived;
        data["droppedOut"] = this.droppedOut;
        return data;
    }
}

export interface IPatientPerStudyStateCounters {
    /** General patient count in the group */
    patientCount: number;
    /** Patient count in the group with not started study state */
    notStarted: number;
    /** Patient count in the group with in progress study state */
    inProgress: number;
    /** Patient count in the group with finished study state */
    finished: number;
    /** Patient count in the group with archived study state
             */
    archived: number;
    /** Patient count in the group with dropped out study state */
    droppedOut: number;
}

export class PatientsPerProgressStepCounter implements IPatientsPerProgressStepCounter {
    /** Name of the progress step (for example, initial, control-1, control-2, final, etc.) */
    stepName!: string;
    /** Short name of the progress step (for example, init, C1, C2, Fin., etc.) */
    shortStepName!: string;
    /** Patient count in the group with specific progress step */
    patientCount!: number;

    constructor(data?: IPatientsPerProgressStepCounter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepName = _data["stepName"];
            this.shortStepName = _data["shortStepName"];
            this.patientCount = _data["patientCount"];
        }
    }

    static fromJS(data: any): PatientsPerProgressStepCounter {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsPerProgressStepCounter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepName"] = this.stepName;
        data["shortStepName"] = this.shortStepName;
        data["patientCount"] = this.patientCount;
        return data;
    }
}

export interface IPatientsPerProgressStepCounter {
    /** Name of the progress step (for example, initial, control-1, control-2, final, etc.) */
    stepName: string;
    /** Short name of the progress step (for example, init, C1, C2, Fin., etc.) */
    shortStepName: string;
    /** Patient count in the group with specific progress step */
    patientCount: number;
}

export class PagedResultOfStudyStaffDto implements IPagedResultOfStudyStaffDto {
    data!: StudyStaffDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfStudyStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudyStaffDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfStudyStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfStudyStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfStudyStaffDto {
    data: StudyStaffDto[];
    totalCount: number;
}

export class StudyStaffDto implements IStudyStaffDto {
    /** Doctor id. */
    id!: string;
    /** Doctor's full name. */
    fullName!: string;
    /** User's email [optional] from external logins or from hardcoded users. */
    email!: string | null;
    /** Date when user visit an application the last time. */
    lastVisitDate!: Date | null;
    /** User's roles */
    roles!: string[];
    /** User's tags */
    tags!: TagFiltersDto | null;

    constructor(data?: IStudyStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.lastVisitDate = _data["lastVisitDate"] ? new Date(_data["lastVisitDate"].toString()) : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.tags = _data["tags"] ? TagFiltersDto.fromJS(_data["tags"]) : <any>null;
        }
    }

    static fromJS(data: any): StudyStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["lastVisitDate"] = this.lastVisitDate && this.lastVisitDate.toISOString();
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["tags"] = this.tags ? this.tags.toJSON() : <any>null;
        return data;
    }
}

export interface IStudyStaffDto {
    /** Doctor id. */
    id: string;
    /** Doctor's full name. */
    fullName: string;
    /** User's email [optional] from external logins or from hardcoded users. */
    email: string | null;
    /** Date when user visit an application the last time. */
    lastVisitDate: Date | null;
    /** User's roles */
    roles: string[];
    /** User's tags */
    tags: TagFiltersDto | null;
}

/** 0 = Favorite 1 = FullName 2 = LastVisitDate */
export enum StaffSorting {
    Favorite = 0,
    FullName = 1,
    LastVisitDate = 2,
}

export class StudyStaffPerRoleDto implements IStudyStaffPerRoleDto {
    /** Role name */
    roleName!: string;
    /** Number of users with this role */
    staffCount!: number;

    constructor(data?: IStudyStaffPerRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
            this.staffCount = _data["staffCount"];
        }
    }

    static fromJS(data: any): StudyStaffPerRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyStaffPerRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        data["staffCount"] = this.staffCount;
        return data;
    }
}

export interface IStudyStaffPerRoleDto {
    /** Role name */
    roleName: string;
    /** Number of users with this role */
    staffCount: number;
}

export class StudyNoteConfigDto implements IStudyNoteConfigDto {
    /** Id of the form config */
    id!: number;
    /** Title of the form config */
    title!: string;
    /** Date when form was created and saved in the DB. */
    createdAt!: Date;
    /** Date when form was modified or filled. */
    updatedAt!: Date | null;
    /** Schema of form layout (markup) */
    layout!: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;

    constructor(data?: IStudyNoteConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layout = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
            if (Array.isArray(_data["scoreSections"])) {
                this.scoreSections = [] as any;
                for (let item of _data["scoreSections"])
                    this.scoreSections!.push(BaseScoreSection.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(BaseVariableSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyNoteConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyNoteConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        if (Array.isArray(this.scoreSections)) {
            data["scoreSections"] = [];
            for (let item of this.scoreSections)
                data["scoreSections"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyNoteConfigDto {
    /** Id of the form config */
    id: number;
    /** Title of the form config */
    title: string;
    /** Date when form was created and saved in the DB. */
    createdAt: Date;
    /** Date when form was modified or filled. */
    updatedAt: Date | null;
    /** Schema of form layout (markup) */
    layout: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;
}

export class StudyNoteConfigCreationDto implements IStudyNoteConfigCreationDto {
    /** Title of the form config */
    title!: string;
    /** Schema of form layout (markup) */
    layout!: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;

    constructor(data?: IStudyNoteConfigCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layout = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
            if (Array.isArray(_data["scoreSections"])) {
                this.scoreSections = [] as any;
                for (let item of _data["scoreSections"])
                    this.scoreSections!.push(BaseScoreSection.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(BaseVariableSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyNoteConfigCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyNoteConfigCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        if (Array.isArray(this.scoreSections)) {
            data["scoreSections"] = [];
            for (let item of this.scoreSections)
                data["scoreSections"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyNoteConfigCreationDto {
    /** Title of the form config */
    title: string;
    /** Schema of form layout (markup) */
    layout: { [key: string]: any; };
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    /** A set of auxiliary variables for calculating scores */
    variables?: BaseVariableSection[] | null;
}

export class StudyNoteConfigPatchingDto implements IStudyNoteConfigPatchingDto {
    /** Title of the form config */
    title?: string | null;
    /** Schema of form layout (markup) */
    layout?: { [key: string]: any; } | null;
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    variables?: BaseVariableSection[] | null;

    constructor(data?: IStudyNoteConfigPatchingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (_data["layout"]) {
                this.layout = {} as any;
                for (let key in _data["layout"]) {
                    if (_data["layout"].hasOwnProperty(key))
                        (<any>this.layout)![key] = _data["layout"][key];
                }
            }
            if (Array.isArray(_data["scoreSections"])) {
                this.scoreSections = [] as any;
                for (let item of _data["scoreSections"])
                    this.scoreSections!.push(BaseScoreSection.fromJS(item));
            }
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables!.push(BaseVariableSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyNoteConfigPatchingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyNoteConfigPatchingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (this.layout) {
            data["layout"] = {};
            for (let key in this.layout) {
                if (this.layout.hasOwnProperty(key))
                    (<any>data["layout"])[key] = (<any>this.layout)[key];
            }
        }
        if (Array.isArray(this.scoreSections)) {
            data["scoreSections"] = [];
            for (let item of this.scoreSections)
                data["scoreSections"].push(item.toJSON());
        }
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyNoteConfigPatchingDto {
    /** Title of the form config */
    title?: string | null;
    /** Schema of form layout (markup) */
    layout?: { [key: string]: any; } | null;
    /** A set describing the rules for calculating the score for a survey */
    scoreSections?: BaseScoreSection[] | null;
    variables?: BaseVariableSection[] | null;
}

export class StudyNoteResultDto implements IStudyNoteResultDto {
    /** The version number of form result */
    version!: ResultVersionNumber;
    /** Id of the form result which result version belongs to */
    formResultId!: number;
    /** Value of form result for the version */
    value!: { [key: string]: any; } | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; } | null;
    scoreResults!: ScoreResult[] | null;
    /** The reasons why field was changed. */
    fieldEditReasons!: { [key: string]: FieldEditReasonWithStaff; } | null;
    /** Filling progress */
    fillingProgress!: FillingProgress | null;
    /** Who create Value of this version */
    createdBy!: DoctorDto;
    /** When the version was created */
    createdAt!: Date;
    /** Who update Value of this version the last time */
    updatedBy!: DoctorDto;
    /** When the version was updated */
    updatedAt!: Date;

    constructor(data?: IStudyNoteResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new ResultVersionNumber();
            this.createdBy = new DoctorDto();
            this.updatedBy = new DoctorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? ResultVersionNumber.fromJS(_data["version"]) : new ResultVersionNumber();
            this.formResultId = _data["formResultId"];
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            if (Array.isArray(_data["scoreResults"])) {
                this.scoreResults = [] as any;
                for (let item of _data["scoreResults"])
                    this.scoreResults!.push(ScoreResult.fromJS(item));
            }
            if (_data["fieldEditReasons"]) {
                this.fieldEditReasons = {} as any;
                for (let key in _data["fieldEditReasons"]) {
                    if (_data["fieldEditReasons"].hasOwnProperty(key))
                        (<any>this.fieldEditReasons)![key] = _data["fieldEditReasons"][key] ? FieldEditReasonWithStaff.fromJS(_data["fieldEditReasons"][key]) : new FieldEditReasonWithStaff();
                }
            }
            this.fillingProgress = _data["fillingProgress"] ? FillingProgress.fromJS(_data["fillingProgress"]) : <any>null;
            this.createdBy = _data["createdBy"] ? DoctorDto.fromJS(_data["createdBy"]) : new DoctorDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedBy = _data["updatedBy"] ? DoctorDto.fromJS(_data["updatedBy"]) : new DoctorDto();
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): StudyNoteResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyNoteResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>null;
        data["formResultId"] = this.formResultId;
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        if (Array.isArray(this.scoreResults)) {
            data["scoreResults"] = [];
            for (let item of this.scoreResults)
                data["scoreResults"].push(item.toJSON());
        }
        if (this.fieldEditReasons) {
            data["fieldEditReasons"] = {};
            for (let key in this.fieldEditReasons) {
                if (this.fieldEditReasons.hasOwnProperty(key))
                    (<any>data["fieldEditReasons"])[key] = this.fieldEditReasons[key] ? this.fieldEditReasons[key].toJSON() : <any>null;
            }
        }
        data["fillingProgress"] = this.fillingProgress ? this.fillingProgress.toJSON() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        return data;
    }
}

export interface IStudyNoteResultDto {
    /** The version number of form result */
    version: ResultVersionNumber;
    /** Id of the form result which result version belongs to */
    formResultId: number;
    /** Value of form result for the version */
    value: { [key: string]: any; } | null;
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; } | null;
    scoreResults: ScoreResult[] | null;
    /** The reasons why field was changed. */
    fieldEditReasons: { [key: string]: FieldEditReasonWithStaff; } | null;
    /** Filling progress */
    fillingProgress: FillingProgress | null;
    /** Who create Value of this version */
    createdBy: DoctorDto;
    /** When the version was created */
    createdAt: Date;
    /** Who update Value of this version the last time */
    updatedBy: DoctorDto;
    /** When the version was updated */
    updatedAt: Date;
}

export class StudyNoteProcessingDto implements IStudyNoteProcessingDto {
    /** Value of form result for the version */
    value!: { [key: string]: any; };
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons!: { [key: string]: FieldSkipReason; } | null;
    scoreResults!: ScoreResult[] | null;
    /** Version type that you want to create. It can be major  e.g. v.1.0 or minor v.0.1
VersionType.Major by default */
    versionType!: VersionType | null;
    /** File Ids to commit */
    fileIdsToCommit!: string[];

    constructor(data?: IStudyNoteProcessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = {};
            this.fileIdsToCommit = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["value"]) {
                this.value = {} as any;
                for (let key in _data["value"]) {
                    if (_data["value"].hasOwnProperty(key))
                        (<any>this.value)![key] = _data["value"][key];
                }
            }
            if (_data["fieldSkipReasons"]) {
                this.fieldSkipReasons = {} as any;
                for (let key in _data["fieldSkipReasons"]) {
                    if (_data["fieldSkipReasons"].hasOwnProperty(key))
                        (<any>this.fieldSkipReasons)![key] = _data["fieldSkipReasons"][key];
                }
            }
            if (Array.isArray(_data["scoreResults"])) {
                this.scoreResults = [] as any;
                for (let item of _data["scoreResults"])
                    this.scoreResults!.push(ScoreResult.fromJS(item));
            }
            this.versionType = _data["versionType"];
            if (Array.isArray(_data["fileIdsToCommit"])) {
                this.fileIdsToCommit = [] as any;
                for (let item of _data["fileIdsToCommit"])
                    this.fileIdsToCommit!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyNoteProcessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyNoteProcessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.value) {
            data["value"] = {};
            for (let key in this.value) {
                if (this.value.hasOwnProperty(key))
                    (<any>data["value"])[key] = (<any>this.value)[key];
            }
        }
        if (this.fieldSkipReasons) {
            data["fieldSkipReasons"] = {};
            for (let key in this.fieldSkipReasons) {
                if (this.fieldSkipReasons.hasOwnProperty(key))
                    (<any>data["fieldSkipReasons"])[key] = (<any>this.fieldSkipReasons)[key];
            }
        }
        if (Array.isArray(this.scoreResults)) {
            data["scoreResults"] = [];
            for (let item of this.scoreResults)
                data["scoreResults"].push(item.toJSON());
        }
        data["versionType"] = this.versionType;
        if (Array.isArray(this.fileIdsToCommit)) {
            data["fileIdsToCommit"] = [];
            for (let item of this.fileIdsToCommit)
                data["fileIdsToCommit"].push(item);
        }
        return data;
    }
}

export interface IStudyNoteProcessingDto {
    /** Value of form result for the version */
    value: { [key: string]: any; };
    /** The reasons why a part of the required fields were not answered. */
    fieldSkipReasons: { [key: string]: FieldSkipReason; } | null;
    scoreResults: ScoreResult[] | null;
    /** Version type that you want to create. It can be major  e.g. v.1.0 or minor v.0.1
VersionType.Major by default */
    versionType: VersionType | null;
    /** File Ids to commit */
    fileIdsToCommit: string[];
}

export class StudyProgressStatisticDto implements IStudyProgressStatisticDto {
    groups!: StudyProgressStatisticGroup[];

    constructor(data?: IStudyProgressStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(StudyProgressStatisticGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgressStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgressStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgressStatisticDto {
    groups: StudyProgressStatisticGroup[];
}

export class StudyProgressStatisticGroup implements IStudyProgressStatisticGroup {
    groupId!: number;
    groupName!: string;
    targetPatientsCount!: number | null;
    recruitedPatientsCount!: number;
    remainingPatientsCount!: number | null;
    activePatientsCount!: number;
    notActivePatientsCount!: number;
    droppedOutPatientsCount!: number;
    routeSteps!: StudyProgressStatisticRouteStep[];

    constructor(data?: IStudyProgressStatisticGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.routeSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.targetPatientsCount = _data["targetPatientsCount"];
            this.recruitedPatientsCount = _data["recruitedPatientsCount"];
            this.remainingPatientsCount = _data["remainingPatientsCount"];
            this.activePatientsCount = _data["activePatientsCount"];
            this.notActivePatientsCount = _data["notActivePatientsCount"];
            this.droppedOutPatientsCount = _data["droppedOutPatientsCount"];
            if (Array.isArray(_data["routeSteps"])) {
                this.routeSteps = [] as any;
                for (let item of _data["routeSteps"])
                    this.routeSteps!.push(StudyProgressStatisticRouteStep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgressStatisticGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgressStatisticGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["targetPatientsCount"] = this.targetPatientsCount;
        data["recruitedPatientsCount"] = this.recruitedPatientsCount;
        data["remainingPatientsCount"] = this.remainingPatientsCount;
        data["activePatientsCount"] = this.activePatientsCount;
        data["notActivePatientsCount"] = this.notActivePatientsCount;
        data["droppedOutPatientsCount"] = this.droppedOutPatientsCount;
        if (Array.isArray(this.routeSteps)) {
            data["routeSteps"] = [];
            for (let item of this.routeSteps)
                data["routeSteps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgressStatisticGroup {
    groupId: number;
    groupName: string;
    targetPatientsCount: number | null;
    recruitedPatientsCount: number;
    remainingPatientsCount: number | null;
    activePatientsCount: number;
    notActivePatientsCount: number;
    droppedOutPatientsCount: number;
    routeSteps: StudyProgressStatisticRouteStep[];
}

export class StudyProgressStatisticRouteStep implements IStudyProgressStatisticRouteStep {
    name!: string;
    shortName!: string;
    patientsInProgress!: number;

    constructor(data?: IStudyProgressStatisticRouteStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.patientsInProgress = _data["patientsInProgress"];
        }
    }

    static fromJS(data: any): StudyProgressStatisticRouteStep {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgressStatisticRouteStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["patientsInProgress"] = this.patientsInProgress;
        return data;
    }
}

export interface IStudyProgressStatisticRouteStep {
    name: string;
    shortName: string;
    patientsInProgress: number;
}

export class UpdateTargetPatientsCountDto implements IUpdateTargetPatientsCountDto {
    groupId!: number;
    targetCount!: number | null;

    constructor(data?: IUpdateTargetPatientsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.targetCount = _data["targetCount"];
        }
    }

    static fromJS(data: any): UpdateTargetPatientsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTargetPatientsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["targetCount"] = this.targetCount;
        return data;
    }
}

export interface IUpdateTargetPatientsCountDto {
    groupId: number;
    targetCount: number | null;
}

export class CreateStudyRouteDto implements ICreateStudyRouteDto {
    /** Defined schema - how study must go on. */
    scheme!: CheckPoint[];
    /** Related group - where study route will be */
    groupId!: number;

    constructor(data?: ICreateStudyRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.scheme = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scheme"])) {
                this.scheme = [] as any;
                for (let item of _data["scheme"])
                    this.scheme!.push(CheckPoint.fromJS(item));
            }
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CreateStudyRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scheme)) {
            data["scheme"] = [];
            for (let item of this.scheme)
                data["scheme"].push(item.toJSON());
        }
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICreateStudyRouteDto {
    /** Defined schema - how study must go on. */
    scheme: CheckPoint[];
    /** Related group - where study route will be */
    groupId: number;
}

export class UpdatePatientRouteProgressDto implements IUpdatePatientRouteProgressDto {
    /** The keys are step names, the values are dates that the steps must be opened until */
    stepsToOpen!: { [key: string]: Date; };

    constructor(data?: IUpdatePatientRouteProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stepsToOpen = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["stepsToOpen"]) {
                this.stepsToOpen = {} as any;
                for (let key in _data["stepsToOpen"]) {
                    if (_data["stepsToOpen"].hasOwnProperty(key))
                        (<any>this.stepsToOpen)![key] = _data["stepsToOpen"][key] ? parseDateOnly(_data["stepsToOpen"][key].toString()) : <any>null;
                }
            }
        }
    }

    static fromJS(data: any): UpdatePatientRouteProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientRouteProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.stepsToOpen) {
            data["stepsToOpen"] = {};
            for (let key in this.stepsToOpen) {
                if (this.stepsToOpen.hasOwnProperty(key))
                    (<any>data["stepsToOpen"])[key] = this.stepsToOpen[key] && formatDate(this.stepsToOpen[key]);
            }
        }
        return data;
    }
}

export interface IUpdatePatientRouteProgressDto {
    /** The keys are step names, the values are dates that the steps must be opened until */
    stepsToOpen: { [key: string]: Date; };
}

export class AddCheckpointDto implements IAddCheckpointDto {
    /** Unique Name of the check point */
    name!: string;
    /** Short name of the check point */
    shortName!: string;
    /** Initial state of the check point */
    initState!: RouteProgressStateEnum;
    /** Collection of forms */
    forms!: CheckpointFormsDto[];
    /** Time limitation */
    limitation!: CheckpointTimeLimitationDto;
    /** An object to describe the position for adding a new checkpoint */
    addFunction!: AddFunctionDto;

    constructor(data?: IAddCheckpointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
            this.limitation = new CheckpointTimeLimitationDto();
            this.addFunction = new AddFunctionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.initState = _data["initState"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(CheckpointFormsDto.fromJS(item));
            }
            this.limitation = _data["limitation"] ? CheckpointTimeLimitationDto.fromJS(_data["limitation"]) : new CheckpointTimeLimitationDto();
            this.addFunction = _data["addFunction"] ? AddFunctionDto.fromJS(_data["addFunction"]) : new AddFunctionDto();
        }
    }

    static fromJS(data: any): AddCheckpointDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCheckpointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["initState"] = this.initState;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["limitation"] = this.limitation ? this.limitation.toJSON() : <any>null;
        data["addFunction"] = this.addFunction ? this.addFunction.toJSON() : <any>null;
        return data;
    }
}

export interface IAddCheckpointDto {
    /** Unique Name of the check point */
    name: string;
    /** Short name of the check point */
    shortName: string;
    /** Initial state of the check point */
    initState: RouteProgressStateEnum;
    /** Collection of forms */
    forms: CheckpointFormsDto[];
    /** Time limitation */
    limitation: CheckpointTimeLimitationDto;
    /** An object to describe the position for adding a new checkpoint */
    addFunction: AddFunctionDto;
}

export class CheckpointFormsDto implements ICheckpointFormsDto {
    /** Id of the form config */
    formConfigId!: number;
    /** Id of another form config that stores shared values (answers).
That answers must be transferred to this form too. */
    formConfigIdForInitialAnswers?: number | null;

    constructor(data?: ICheckpointFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formConfigId = _data["formConfigId"];
            this.formConfigIdForInitialAnswers = _data["formConfigIdForInitialAnswers"];
        }
    }

    static fromJS(data: any): CheckpointFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckpointFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formConfigId"] = this.formConfigId;
        data["formConfigIdForInitialAnswers"] = this.formConfigIdForInitialAnswers;
        return data;
    }
}

export interface ICheckpointFormsDto {
    /** Id of the form config */
    formConfigId: number;
    /** Id of another form config that stores shared values (answers).
That answers must be transferred to this form too. */
    formConfigIdForInitialAnswers?: number | null;
}

export class CheckpointTimeLimitationDto implements ICheckpointTimeLimitationDto {
    /** The period of shifting start step from the calculated date OR
from StartWhenStepWithNameDone is DONE
StepStartDate = ReferenceDate + NumberOfStartShiftPeriod */
    numberOfStartShiftPeriod!: number;
    /** The units of NumberOfStartShiftPeriod */
    startPeriodUnits!: string;
    /** The period of editing step from start */
    numberOfEditingPeriod!: number;
    /** The units of NumberOfEditingPeriod */
    editingPeriodUnits!: string;
    /** Field to calculate start date */
    startDateActionObject?: FormActionObject | null;
    /** The name of the step after which this step will start with shift NumberOfStartShiftPeriod */
    startWhenStepWithNameDone?: string | null;

    constructor(data?: ICheckpointTimeLimitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfStartShiftPeriod = _data["numberOfStartShiftPeriod"];
            this.startPeriodUnits = _data["startPeriodUnits"];
            this.numberOfEditingPeriod = _data["numberOfEditingPeriod"];
            this.editingPeriodUnits = _data["editingPeriodUnits"];
            this.startDateActionObject = _data["startDateActionObject"] ? FormActionObject.fromJS(_data["startDateActionObject"]) : <any>null;
            this.startWhenStepWithNameDone = _data["startWhenStepWithNameDone"];
        }
    }

    static fromJS(data: any): CheckpointTimeLimitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckpointTimeLimitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfStartShiftPeriod"] = this.numberOfStartShiftPeriod;
        data["startPeriodUnits"] = this.startPeriodUnits;
        data["numberOfEditingPeriod"] = this.numberOfEditingPeriod;
        data["editingPeriodUnits"] = this.editingPeriodUnits;
        data["startDateActionObject"] = this.startDateActionObject ? this.startDateActionObject.toJSON() : <any>null;
        data["startWhenStepWithNameDone"] = this.startWhenStepWithNameDone;
        return data;
    }
}

export interface ICheckpointTimeLimitationDto {
    /** The period of shifting start step from the calculated date OR
from StartWhenStepWithNameDone is DONE
StepStartDate = ReferenceDate + NumberOfStartShiftPeriod */
    numberOfStartShiftPeriod: number;
    /** The units of NumberOfStartShiftPeriod */
    startPeriodUnits: string;
    /** The period of editing step from start */
    numberOfEditingPeriod: number;
    /** The units of NumberOfEditingPeriod */
    editingPeriodUnits: string;
    /** Field to calculate start date */
    startDateActionObject?: FormActionObject | null;
    /** The name of the step after which this step will start with shift NumberOfStartShiftPeriod */
    startWhenStepWithNameDone?: string | null;
}

export class AddFunctionDto implements IAddFunctionDto {
    /** Function type to insert new checkpoint */
    functionType!: AddFunctionEnum;
    /** Reference to Checkpoint for AddFunction */
    checkpointName!: string;

    constructor(data?: IAddFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionType = _data["functionType"];
            this.checkpointName = _data["checkpointName"];
        }
    }

    static fromJS(data: any): AddFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionType"] = this.functionType;
        data["checkpointName"] = this.checkpointName;
        return data;
    }
}

export interface IAddFunctionDto {
    /** Function type to insert new checkpoint */
    functionType: AddFunctionEnum;
    /** Reference to Checkpoint for AddFunction */
    checkpointName: string;
}

/** 0 = AddBefore 1 = AddAfter */
export enum AddFunctionEnum {
    AddBefore = 0,
    AddAfter = 1,
}

export class AddFormConfigToCheckpointDto implements IAddFormConfigToCheckpointDto {
    formConfigId!: number;
    /** Id of another form config that stores shared values (answers).
That answers must be transferred to this form too. */
    formConfigIdForInitialAnswers?: number | null;

    constructor(data?: IAddFormConfigToCheckpointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formConfigId = _data["formConfigId"];
            this.formConfigIdForInitialAnswers = _data["formConfigIdForInitialAnswers"];
        }
    }

    static fromJS(data: any): AddFormConfigToCheckpointDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddFormConfigToCheckpointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formConfigId"] = this.formConfigId;
        data["formConfigIdForInitialAnswers"] = this.formConfigIdForInitialAnswers;
        return data;
    }
}

export interface IAddFormConfigToCheckpointDto {
    formConfigId: number;
    /** Id of another form config that stores shared values (answers).
That answers must be transferred to this form too. */
    formConfigIdForInitialAnswers?: number | null;
}

export class SurveyStatisticsDto implements ISurveyStatisticsDto {
    statistics!: StatisticsItemDto[];
    icon!: SurveyIcon;

    constructor(data?: ISurveyStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statistics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(StatisticsItemDto.fromJS(item));
            }
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): SurveyStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item.toJSON());
        }
        data["icon"] = this.icon;
        return data;
    }
}

export interface ISurveyStatisticsDto {
    statistics: StatisticsItemDto[];
    icon: SurveyIcon;
}

export class StatisticsItemDto implements IStatisticsItemDto {
    /** Answer Id */
    answerId?: number | null;
    /** Date of the beginning of the statistics period. */
    startDate!: Date | null;
    /** End date of the statistics period. */
    endDate!: Date | null;
    /** Score for the statistics period. */
    score!: number | null;
    /** Quality corresponding to the score value. */
    qualityMetric!: QualityMetric;
    /** Status of score calculation */
    scoreStatus!: ScoreCalculationStatusEnum;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation!: boolean;

    constructor(data?: IStatisticsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerId = _data["answerId"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.score = _data["score"];
            this.qualityMetric = _data["qualityMetric"];
            this.scoreStatus = _data["scoreStatus"];
            this.canRetryScoreCalculation = _data["canRetryScoreCalculation"];
        }
    }

    static fromJS(data: any): StatisticsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["score"] = this.score;
        data["qualityMetric"] = this.qualityMetric;
        data["scoreStatus"] = this.scoreStatus;
        data["canRetryScoreCalculation"] = this.canRetryScoreCalculation;
        return data;
    }
}

export interface IStatisticsItemDto {
    /** Answer Id */
    answerId?: number | null;
    /** Date of the beginning of the statistics period. */
    startDate: Date | null;
    /** End date of the statistics period. */
    endDate: Date | null;
    /** Score for the statistics period. */
    score: number | null;
    /** Quality corresponding to the score value. */
    qualityMetric: QualityMetric;
    /** Status of score calculation */
    scoreStatus: ScoreCalculationStatusEnum;
    /** This flag indicates the ability to retry scoring in case of failure. */
    canRetryScoreCalculation: boolean;
}

export class AnswersStatisticsDto implements IAnswersStatisticsDto {
    questionScheme!: QuestionScheme | null;
    typeOfSurvey!: SurveyType;
    minAnswerDate!: Date | null;
    maxAnswerDate!: Date | null;
    studyStartedAt!: Date;
    studyFinishedAt!: Date;
    answers!: AnswerStatisticsListItem[];

    constructor(data?: IAnswersStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionScheme = _data["questionScheme"] ? QuestionScheme.fromJS(_data["questionScheme"]) : <any>null;
            this.typeOfSurvey = _data["typeOfSurvey"];
            this.minAnswerDate = _data["minAnswerDate"] ? new Date(_data["minAnswerDate"].toString()) : <any>null;
            this.maxAnswerDate = _data["maxAnswerDate"] ? new Date(_data["maxAnswerDate"].toString()) : <any>null;
            this.studyStartedAt = _data["studyStartedAt"] ? parseDateOnly(_data["studyStartedAt"].toString()) : <any>null;
            this.studyFinishedAt = _data["studyFinishedAt"] ? parseDateOnly(_data["studyFinishedAt"].toString()) : <any>null;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswerStatisticsListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswersStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswersStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionScheme"] = this.questionScheme ? this.questionScheme.toJSON() : <any>null;
        data["typeOfSurvey"] = this.typeOfSurvey;
        data["minAnswerDate"] = this.minAnswerDate && this.minAnswerDate.toISOString();
        data["maxAnswerDate"] = this.maxAnswerDate && this.maxAnswerDate.toISOString();
        data["studyStartedAt"] = this.studyStartedAt && formatDate(this.studyStartedAt);
        data["studyFinishedAt"] = this.studyFinishedAt && formatDate(this.studyFinishedAt);
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnswersStatisticsDto {
    questionScheme: QuestionScheme | null;
    typeOfSurvey: SurveyType;
    minAnswerDate: Date | null;
    maxAnswerDate: Date | null;
    studyStartedAt: Date;
    studyFinishedAt: Date;
    answers: AnswerStatisticsListItem[];
}

export class AnswerStatisticsListItem implements IAnswerStatisticsListItem {
    answerId!: number | null;
    score!: number | null;
    quality!: QualityMetric;
    rawAnswer!: QuestionScheme | null;
    answerDate!: Date;
    answeredBy!: DoctorDto | null;
    scoreStatus!: ScoreCalculationStatusEnum | null;
    canRetryScoreCalculation!: boolean;

    constructor(data?: IAnswerStatisticsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerId = _data["answerId"];
            this.score = _data["score"];
            this.quality = _data["quality"];
            this.rawAnswer = _data["rawAnswer"] ? QuestionScheme.fromJS(_data["rawAnswer"]) : <any>null;
            this.answerDate = _data["answerDate"] ? new Date(_data["answerDate"].toString()) : <any>null;
            this.answeredBy = _data["answeredBy"] ? DoctorDto.fromJS(_data["answeredBy"]) : <any>null;
            this.scoreStatus = _data["scoreStatus"];
            this.canRetryScoreCalculation = _data["canRetryScoreCalculation"];
        }
    }

    static fromJS(data: any): AnswerStatisticsListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerStatisticsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["score"] = this.score;
        data["quality"] = this.quality;
        data["rawAnswer"] = this.rawAnswer ? this.rawAnswer.toJSON() : <any>null;
        data["answerDate"] = this.answerDate && this.answerDate.toISOString();
        data["answeredBy"] = this.answeredBy ? this.answeredBy.toJSON() : <any>null;
        data["scoreStatus"] = this.scoreStatus;
        data["canRetryScoreCalculation"] = this.canRetryScoreCalculation;
        return data;
    }
}

export interface IAnswerStatisticsListItem {
    answerId: number | null;
    score: number | null;
    quality: QualityMetric;
    rawAnswer: QuestionScheme | null;
    answerDate: Date;
    answeredBy: DoctorDto | null;
    scoreStatus: ScoreCalculationStatusEnum | null;
    canRetryScoreCalculation: boolean;
}

export class AnswerResultDto implements IAnswerResultDto {
    id!: number | null;
    questionnaireId!: number;
    answerScheme!: QuestionScheme | null;
    isSubmitted!: boolean;
    answer?: string | null;

    constructor(data?: IAnswerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionnaireId = _data["questionnaireId"];
            this.answerScheme = _data["answerScheme"] ? QuestionScheme.fromJS(_data["answerScheme"]) : <any>null;
            this.isSubmitted = _data["isSubmitted"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): AnswerResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionnaireId"] = this.questionnaireId;
        data["answerScheme"] = this.answerScheme ? this.answerScheme.toJSON() : <any>null;
        data["isSubmitted"] = this.isSubmitted;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IAnswerResultDto {
    id: number | null;
    questionnaireId: number;
    answerScheme: QuestionScheme | null;
    isSubmitted: boolean;
    answer?: string | null;
}

export class CreateSurveyDto implements ICreateSurveyDto {
    /** Id of assigned study. */
    studyId!: number;
    /** JSON-contract scheme of questionnaire. */
    schema!: QuestionScheme;
    /** Type of survey. */
    type!: string;
    /** Title of survey. */
    title!: string;
    /** Description of survey. */
    description?: string | null;
    /** Flag indicates that the doctor can fill this survey */
    canBeFilledByDoctor?: boolean;
    canBeTriggeredByPatient?: boolean;
    canBeTriggeredByDoctor?: boolean;
    /** Number of days during which survey will be shown with "expired" flag. */
    displayDurationInExpiredState?: number | null;
    /** Survey icon type */
    icon?: SurveyIcon;
    /** Settings for mobile app only */
    appSettings?: AppSettings | null;
    /** Url for azure function to calculate survey score. */
    calculationFuncUrl?: string | null;

    constructor(data?: ICreateSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.schema = new QuestionScheme();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.schema = _data["schema"] ? QuestionScheme.fromJS(_data["schema"]) : new QuestionScheme();
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.canBeFilledByDoctor = _data["canBeFilledByDoctor"];
            this.canBeTriggeredByPatient = _data["canBeTriggeredByPatient"];
            this.canBeTriggeredByDoctor = _data["canBeTriggeredByDoctor"];
            this.displayDurationInExpiredState = _data["displayDurationInExpiredState"];
            this.icon = _data["icon"];
            this.appSettings = _data["appSettings"] ? AppSettings.fromJS(_data["appSettings"]) : <any>null;
            this.calculationFuncUrl = _data["calculationFuncUrl"];
        }
    }

    static fromJS(data: any): CreateSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["schema"] = this.schema ? this.schema.toJSON() : <any>null;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["canBeFilledByDoctor"] = this.canBeFilledByDoctor;
        data["canBeTriggeredByPatient"] = this.canBeTriggeredByPatient;
        data["canBeTriggeredByDoctor"] = this.canBeTriggeredByDoctor;
        data["displayDurationInExpiredState"] = this.displayDurationInExpiredState;
        data["icon"] = this.icon;
        data["appSettings"] = this.appSettings ? this.appSettings.toJSON() : <any>null;
        data["calculationFuncUrl"] = this.calculationFuncUrl;
        return data;
    }
}

export interface ICreateSurveyDto {
    /** Id of assigned study. */
    studyId: number;
    /** JSON-contract scheme of questionnaire. */
    schema: QuestionScheme;
    /** Type of survey. */
    type: string;
    /** Title of survey. */
    title: string;
    /** Description of survey. */
    description?: string | null;
    /** Flag indicates that the doctor can fill this survey */
    canBeFilledByDoctor?: boolean;
    canBeTriggeredByPatient?: boolean;
    canBeTriggeredByDoctor?: boolean;
    /** Number of days during which survey will be shown with "expired" flag. */
    displayDurationInExpiredState?: number | null;
    /** Survey icon type */
    icon?: SurveyIcon;
    /** Settings for mobile app only */
    appSettings?: AppSettings | null;
    /** Url for azure function to calculate survey score. */
    calculationFuncUrl?: string | null;
}

export class SurveyRuleDto implements ISurveyRuleDto {
    /** Unique ID of surveyRule. */
    id!: number;
    /** Related entity. */
    survey!: SurveyDto;
    /** Period in days numbers between 2 starts of surveys. */
    repeatInDays!: number | null;
    /** Cron stroke representing display pattern for survey. */
    repeatPattern?: string | null;
    /** Number of days during which patient can see the survey. */
    displayDuration!: number;
    /** Number of days before start the survey */
    delayInDays!: number;

    constructor(data?: ISurveyRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.survey = new SurveyDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.survey = _data["survey"] ? SurveyDto.fromJS(_data["survey"]) : new SurveyDto();
            this.repeatInDays = _data["repeatInDays"];
            this.repeatPattern = _data["repeatPattern"];
            this.displayDuration = _data["displayDuration"];
            this.delayInDays = _data["delayInDays"];
        }
    }

    static fromJS(data: any): SurveyRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>null;
        data["repeatInDays"] = this.repeatInDays;
        data["repeatPattern"] = this.repeatPattern;
        data["displayDuration"] = this.displayDuration;
        data["delayInDays"] = this.delayInDays;
        return data;
    }
}

export interface ISurveyRuleDto {
    /** Unique ID of surveyRule. */
    id: number;
    /** Related entity. */
    survey: SurveyDto;
    /** Period in days numbers between 2 starts of surveys. */
    repeatInDays: number | null;
    /** Cron stroke representing display pattern for survey. */
    repeatPattern?: string | null;
    /** Number of days during which patient can see the survey. */
    displayDuration: number;
    /** Number of days before start the survey */
    delayInDays: number;
}

export class CreateSurveyRuleDto implements ICreateSurveyRuleDto {
    /** Survey id for this rule */
    surveyId!: number;
    /** List of group id that will contain this survey rule */
    groupId!: number;
    /** List of group Titles that will contain this survey rule
(Used only for DB seeding) */
    groupTitle?: string | null;
    /** Number of days in a which survey will be triggered to fill. */
    repeatPeriodInDays?: number;
    /** Number of days during which every iteration of survey lasts. */
    displayDuration!: number;
    /** Cron string representing repeat pattern of survey. */
    repeatPattern?: string | null;
    /** Number of days to postpone beginning of study. */
    delayInDays!: number;
    /** Flag indicating belong study for patient */
    isForAll!: boolean;

    constructor(data?: ICreateSurveyRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.groupId = _data["groupId"];
            this.groupTitle = _data["groupTitle"];
            this.repeatPeriodInDays = _data["repeatPeriodInDays"];
            this.displayDuration = _data["displayDuration"];
            this.repeatPattern = _data["repeatPattern"];
            this.delayInDays = _data["delayInDays"];
            this.isForAll = _data["isForAll"];
        }
    }

    static fromJS(data: any): CreateSurveyRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["groupId"] = this.groupId;
        data["groupTitle"] = this.groupTitle;
        data["repeatPeriodInDays"] = this.repeatPeriodInDays;
        data["displayDuration"] = this.displayDuration;
        data["repeatPattern"] = this.repeatPattern;
        data["delayInDays"] = this.delayInDays;
        data["isForAll"] = this.isForAll;
        return data;
    }
}

export interface ICreateSurveyRuleDto {
    /** Survey id for this rule */
    surveyId: number;
    /** List of group id that will contain this survey rule */
    groupId: number;
    /** List of group Titles that will contain this survey rule
(Used only for DB seeding) */
    groupTitle?: string | null;
    /** Number of days in a which survey will be triggered to fill. */
    repeatPeriodInDays?: number;
    /** Number of days during which every iteration of survey lasts. */
    displayDuration: number;
    /** Cron string representing repeat pattern of survey. */
    repeatPattern?: string | null;
    /** Number of days to postpone beginning of study. */
    delayInDays: number;
    /** Flag indicating belong study for patient */
    isForAll: boolean;
}

/** Questionnaire that will be created in the future */
export class PredictedQuestionnaireDto implements IPredictedQuestionnaireDto {
    surveyId!: number;
    surveyType!: string;
    /** An id of a SurveyRule that this questionnaire will be created by */
    surveyRuleId!: number;
    patientId!: string;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IPredictedQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyType = _data["surveyType"];
            this.surveyRuleId = _data["surveyRuleId"];
            this.patientId = _data["patientId"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PredictedQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictedQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyType"] = this.surveyType;
        data["surveyRuleId"] = this.surveyRuleId;
        data["patientId"] = this.patientId;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["endDate"] = this.endDate && formatDate(this.endDate);
        return data;
    }
}

/** Questionnaire that will be created in the future */
export interface IPredictedQuestionnaireDto {
    surveyId: number;
    surveyType: string;
    /** An id of a SurveyRule that this questionnaire will be created by */
    surveyRuleId: number;
    patientId: string;
    startDate: Date;
    endDate: Date;
}

export class TestStudyDto implements ITestStudyDto {
    /** Study id. */
    id!: number;
    /** Number of the Study. */
    studyNumber!: string;
    /** Short description of the study. */
    title!: string;
    /** Description and proposal of study. */
    description!: string;
    /** Date when study has been started. */
    startDate!: Date;
    /** Date when study must finish. */
    duration!: number;
    /** Date of study creation. */
    createdAt!: Date;
    /** Flag indicates that the study uses therapy data. */
    hasTherapy!: boolean;
    /** Flag indicates that the study could be under "Monitoring" (issue tracker). */
    hasMonitoring!: boolean;
    /** Flag indicates that mobile surveys are configured in study. */
    hasSurveys!: boolean;
    /** Flag indicates that the study uses pdf signing */
    hasPdfSigning!: boolean;
    /** Flag indicates that the study uses DB import */
    hasDbImport!: boolean;
    /** List of available groups in study. */
    groups!: GroupDto[];
    /** List of available surveys in study. */
    surveys!: SurveyDto[];
    /** Form type and id for patient creation */
    patientCreationFormBinding!: FormBinding | null;
    /** FAQ id for study */
    faqId!: number | null;
    /** Amount of days for therapy data indicators aggregation */
    therapyAggregationPeriod!: number;
    doctors!: TestDoctorDto[];

    constructor(data?: ITestStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
            this.surveys = [];
            this.doctors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyNumber = _data["studyNumber"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.duration = _data["duration"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.hasTherapy = _data["hasTherapy"];
            this.hasMonitoring = _data["hasMonitoring"];
            this.hasSurveys = _data["hasSurveys"];
            this.hasPdfSigning = _data["hasPdfSigning"];
            this.hasDbImport = _data["hasDbImport"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDto.fromJS(item));
            }
            if (Array.isArray(_data["surveys"])) {
                this.surveys = [] as any;
                for (let item of _data["surveys"])
                    this.surveys!.push(SurveyDto.fromJS(item));
            }
            this.patientCreationFormBinding = _data["patientCreationFormBinding"] ? FormBinding.fromJS(_data["patientCreationFormBinding"]) : <any>null;
            this.faqId = _data["faqId"];
            this.therapyAggregationPeriod = _data["therapyAggregationPeriod"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors!.push(TestDoctorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyNumber"] = this.studyNumber;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["duration"] = this.duration;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["hasTherapy"] = this.hasTherapy;
        data["hasMonitoring"] = this.hasMonitoring;
        data["hasSurveys"] = this.hasSurveys;
        data["hasPdfSigning"] = this.hasPdfSigning;
        data["hasDbImport"] = this.hasDbImport;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.surveys)) {
            data["surveys"] = [];
            for (let item of this.surveys)
                data["surveys"].push(item.toJSON());
        }
        data["patientCreationFormBinding"] = this.patientCreationFormBinding ? this.patientCreationFormBinding.toJSON() : <any>null;
        data["faqId"] = this.faqId;
        data["therapyAggregationPeriod"] = this.therapyAggregationPeriod;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITestStudyDto {
    /** Study id. */
    id: number;
    /** Number of the Study. */
    studyNumber: string;
    /** Short description of the study. */
    title: string;
    /** Description and proposal of study. */
    description: string;
    /** Date when study has been started. */
    startDate: Date;
    /** Date when study must finish. */
    duration: number;
    /** Date of study creation. */
    createdAt: Date;
    /** Flag indicates that the study uses therapy data. */
    hasTherapy: boolean;
    /** Flag indicates that the study could be under "Monitoring" (issue tracker). */
    hasMonitoring: boolean;
    /** Flag indicates that mobile surveys are configured in study. */
    hasSurveys: boolean;
    /** Flag indicates that the study uses pdf signing */
    hasPdfSigning: boolean;
    /** Flag indicates that the study uses DB import */
    hasDbImport: boolean;
    /** List of available groups in study. */
    groups: GroupDto[];
    /** List of available surveys in study. */
    surveys: SurveyDto[];
    /** Form type and id for patient creation */
    patientCreationFormBinding: FormBinding | null;
    /** FAQ id for study */
    faqId: number | null;
    /** Amount of days for therapy data indicators aggregation */
    therapyAggregationPeriod: number;
    doctors: TestDoctorDto[];
}

export class TestDoctorDto implements ITestDoctorDto {
    /** Doctor id. */
    id!: string;
    /** Doctor's full name. */
    fullName!: string;
    /** Doctor's email. */
    email!: string;
    /** Filters that are always applied to patient tags
to restrict access of doctor to patients */
    tagFilters!: TagFiltersDto | null;
    studyIds!: number[];

    constructor(data?: ITestDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.tagFilters = _data["tagFilters"] ? TagFiltersDto.fromJS(_data["tagFilters"]) : <any>null;
            if (Array.isArray(_data["studyIds"])) {
                this.studyIds = [] as any;
                for (let item of _data["studyIds"])
                    this.studyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TestDoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["tagFilters"] = this.tagFilters ? this.tagFilters.toJSON() : <any>null;
        if (Array.isArray(this.studyIds)) {
            data["studyIds"] = [];
            for (let item of this.studyIds)
                data["studyIds"].push(item);
        }
        return data;
    }
}

export interface ITestDoctorDto {
    /** Doctor id. */
    id: string;
    /** Doctor's full name. */
    fullName: string;
    /** Doctor's email. */
    email: string;
    /** Filters that are always applied to patient tags
to restrict access of doctor to patients */
    tagFilters: TagFiltersDto | null;
    studyIds: number[];
}

export class CreateTestStudyDto implements ICreateTestStudyDto {
    /** List of possible survey types if needed. */
    surveyTypes?: string[];
    /** Type of random generated study for UI tests.
e.g. Intervention, CPAP, SoftStop etc. */
    seedingType?: string | null;
    /** This flag indicates that the study has monitoring feature */
    hasMonitoring?: boolean;
    /** This flag indicates that the study has mobile survey feature */
    hasSurveys?: boolean;
    /** This flag indicates that the study has DB Import (analysis) feature */
    hasDbImport?: boolean;
    doctors?: CreateTestDoctorDto[];

    constructor(data?: ICreateTestStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyTypes"])) {
                this.surveyTypes = [] as any;
                for (let item of _data["surveyTypes"])
                    this.surveyTypes!.push(item);
            }
            this.seedingType = _data["seedingType"];
            this.hasMonitoring = _data["hasMonitoring"];
            this.hasSurveys = _data["hasSurveys"];
            this.hasDbImport = _data["hasDbImport"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors!.push(CreateTestDoctorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTestStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyTypes)) {
            data["surveyTypes"] = [];
            for (let item of this.surveyTypes)
                data["surveyTypes"].push(item);
        }
        data["seedingType"] = this.seedingType;
        data["hasMonitoring"] = this.hasMonitoring;
        data["hasSurveys"] = this.hasSurveys;
        data["hasDbImport"] = this.hasDbImport;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTestStudyDto {
    /** List of possible survey types if needed. */
    surveyTypes?: string[];
    /** Type of random generated study for UI tests.
e.g. Intervention, CPAP, SoftStop etc. */
    seedingType?: string | null;
    /** This flag indicates that the study has monitoring feature */
    hasMonitoring?: boolean;
    /** This flag indicates that the study has mobile survey feature */
    hasSurveys?: boolean;
    /** This flag indicates that the study has DB Import (analysis) feature */
    hasDbImport?: boolean;
    doctors?: CreateTestDoctorDto[];
}

export class CreateTestDoctorDto implements ICreateTestDoctorDto {
    /** First name of the test doctor. */
    firstName!: string;
    /** Last name of the test doctor. */
    lastName!: string;
    /** Login of the doctor. */
    email!: string;
    /** Related studies. */
    studyIds?: number[];
    /** This flag indicates that the doctor has monitoring role */
    isMonitor?: boolean;
    /** Staff roles */
    studyRoles?: string[];
    /** Tag filters to be applied for the doctor in all assigned studies.
If not specified, no filters will be applied. */
    tagFilters?: TagFiltersDto | null;

    constructor(data?: ICreateTestDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["studyIds"])) {
                this.studyIds = [] as any;
                for (let item of _data["studyIds"])
                    this.studyIds!.push(item);
            }
            this.isMonitor = _data["isMonitor"];
            if (Array.isArray(_data["studyRoles"])) {
                this.studyRoles = [] as any;
                for (let item of _data["studyRoles"])
                    this.studyRoles!.push(item);
            }
            this.tagFilters = _data["tagFilters"] ? TagFiltersDto.fromJS(_data["tagFilters"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateTestDoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestDoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.studyIds)) {
            data["studyIds"] = [];
            for (let item of this.studyIds)
                data["studyIds"].push(item);
        }
        data["isMonitor"] = this.isMonitor;
        if (Array.isArray(this.studyRoles)) {
            data["studyRoles"] = [];
            for (let item of this.studyRoles)
                data["studyRoles"].push(item);
        }
        data["tagFilters"] = this.tagFilters ? this.tagFilters.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateTestDoctorDto {
    /** First name of the test doctor. */
    firstName: string;
    /** Last name of the test doctor. */
    lastName: string;
    /** Login of the doctor. */
    email: string;
    /** Related studies. */
    studyIds?: number[];
    /** This flag indicates that the doctor has monitoring role */
    isMonitor?: boolean;
    /** Staff roles */
    studyRoles?: string[];
    /** Tag filters to be applied for the doctor in all assigned studies.
If not specified, no filters will be applied. */
    tagFilters?: TagFiltersDto | null;
}

export class CreateTestTherapyDataDto implements ICreateTestTherapyDataDto {
    /** How long device has been used during the day. [Minutes] */
    usageMin!: number;
    /** Leakage value. [Liters per minutes] */
    leakage!: number | null;
    /** AHI index. */
    ahi!: number | null;
    /** Date when therapy was performed (on teh device or in pCloud system). */
    therapyDay!: Date;
    /** Date when therapy data was consumed (synced into our system) */
    syncDate!: Date;
    /** Device which has got statistics */
    deviceSerialNumber!: string;

    constructor(data?: ICreateTestTherapyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usageMin = _data["usageMin"];
            this.leakage = _data["leakage"];
            this.ahi = _data["ahi"];
            this.therapyDay = _data["therapyDay"] ? parseDateOnly(_data["therapyDay"].toString()) : <any>null;
            this.syncDate = _data["syncDate"] ? new Date(_data["syncDate"].toString()) : <any>null;
            this.deviceSerialNumber = _data["deviceSerialNumber"];
        }
    }

    static fromJS(data: any): CreateTestTherapyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestTherapyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usageMin"] = this.usageMin;
        data["leakage"] = this.leakage;
        data["ahi"] = this.ahi;
        data["therapyDay"] = this.therapyDay && formatDate(this.therapyDay);
        data["syncDate"] = this.syncDate && this.syncDate.toISOString();
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        return data;
    }
}

export interface ICreateTestTherapyDataDto {
    /** How long device has been used during the day. [Minutes] */
    usageMin: number;
    /** Leakage value. [Liters per minutes] */
    leakage: number | null;
    /** AHI index. */
    ahi: number | null;
    /** Date when therapy was performed (on teh device or in pCloud system). */
    therapyDay: Date;
    /** Date when therapy data was consumed (synced into our system) */
    syncDate: Date;
    /** Device which has got statistics */
    deviceSerialNumber: string;
}

export class CreateTestPatientDto implements ICreateTestPatientDto {
    /** Patient studyId, where new patient has to be included. */
    studyId!: number;
    /** Unique identifier of the Patient for the current Study. */
    uniqueId!: string;
    /** Date when study must start for the patient. */
    studyStartedAt!: Date | null;
    /** Date when patient was created in the system. */
    createdAt!: Date;
    /** Date when device was assigned to patient. */
    deviceAssignedAt!: Date | null;
    /** Date of discharge. */
    dischargeDate?: Date | null;
    /** Device serial number, assigned to patient.
Data (from PrismaCLoud system) will be assigned for statistics with given device serial number. */
    deviceSerialNumber!: string | null;
    /** Patient's group. */
    groupId!: number;
    /** Additional data that is attached to patients
to filter them and restrict access of doctor to patient
according to tag filters of the doctor */
    tags?: { [key: string]: string; } | null;

    constructor(data?: ICreateTestPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.uniqueId = _data["uniqueId"];
            this.studyStartedAt = _data["studyStartedAt"] ? parseDateOnly(_data["studyStartedAt"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.deviceAssignedAt = _data["deviceAssignedAt"] ? new Date(_data["deviceAssignedAt"].toString()) : <any>null;
            this.dischargeDate = _data["dischargeDate"] ? parseDateOnly(_data["dischargeDate"].toString()) : <any>null;
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.groupId = _data["groupId"];
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateTestPatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestPatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["uniqueId"] = this.uniqueId;
        data["studyStartedAt"] = this.studyStartedAt && formatDate(this.studyStartedAt);
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["deviceAssignedAt"] = this.deviceAssignedAt && this.deviceAssignedAt.toISOString();
        data["dischargeDate"] = this.dischargeDate && formatDate(this.dischargeDate);
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["groupId"] = this.groupId;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = (<any>this.tags)[key];
            }
        }
        return data;
    }
}

export interface ICreateTestPatientDto {
    /** Patient studyId, where new patient has to be included. */
    studyId: number;
    /** Unique identifier of the Patient for the current Study. */
    uniqueId: string;
    /** Date when study must start for the patient. */
    studyStartedAt: Date | null;
    /** Date when patient was created in the system. */
    createdAt: Date;
    /** Date when device was assigned to patient. */
    deviceAssignedAt: Date | null;
    /** Date of discharge. */
    dischargeDate?: Date | null;
    /** Device serial number, assigned to patient.
Data (from PrismaCLoud system) will be assigned for statistics with given device serial number. */
    deviceSerialNumber: string | null;
    /** Patient's group. */
    groupId: number;
    /** Additional data that is attached to patients
to filter them and restrict access of doctor to patient
according to tag filters of the doctor */
    tags?: { [key: string]: string; } | null;
}

export class TriggerScheduledTaskDto implements ITriggerScheduledTaskDto {
    /** ID of the test study for which task will be triggered.
ONLY for that study - not for whole system. */
    studyId!: number;
    /** Set of the task which should be triggered. */
    tasks!: ScheduledTaskEnum;

    constructor(data?: ITriggerScheduledTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.tasks = _data["tasks"];
        }
    }

    static fromJS(data: any): TriggerScheduledTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerScheduledTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["tasks"] = this.tasks;
        return data;
    }
}

export interface ITriggerScheduledTaskDto {
    /** ID of the test study for which task will be triggered.
ONLY for that study - not for whole system. */
    studyId: number;
    /** Set of the task which should be triggered. */
    tasks: ScheduledTaskEnum;
}

/** 1 = All 2 = CreatingPrismaCheckNotificationJob 4 = CreatingPrismaReportNotificationJob 8 = QuestionnaireManagerJob 16 = CategorizationJob 32 = TherapyDataSyncJob 64 = UpdateRouteProgressJob */
export enum ScheduledTaskEnum {
    All = 1,
    CreatingPrismaCheckNotificationJob = 2,
    CreatingPrismaReportNotificationJob = 4,
    QuestionnaireManagerJob = 8,
    CategorizationJob = 16,
    TherapyDataSyncJob = 32,
    UpdateRouteProgressJob = 64,
}

export class RoleDto implements IRoleDto {
    id!: string;
    name!: string;
    permissions!: Permissions[];

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IRoleDto {
    id: string;
    name: string;
    permissions: Permissions[];
}

/** 1 = StudyManage 3 = RoleAssign 30 = UserManage */
export enum Permissions {
    StudyManage = 1,
    RoleAssign = 3,
    UserManage = 30,
}

export class StudyRoleCreationDto implements IStudyRoleCreationDto {
    name!: string;
    claims!: StudyRoleClaimValue[];

    constructor(data?: IStudyRoleCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claims = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyRoleCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyRoleCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item);
        }
        return data;
    }
}

export interface IStudyRoleCreationDto {
    name: string;
    claims: StudyRoleClaimValue[];
}

export class RoleCreationDto implements IRoleCreationDto {
    name!: string;
    permissions?: Permissions[] | null;

    constructor(data?: IRoleCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IRoleCreationDto {
    name: string;
    permissions?: Permissions[] | null;
}

export class PagedResultOfStaffDto implements IPagedResultOfStaffDto {
    data!: StaffDto[];
    totalCount!: number;

    constructor(data?: IPagedResultOfStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaffDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultOfStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultOfStaffDto {
    data: StaffDto[];
    totalCount: number;
}

export class StaffDto implements IStaffDto {
    /** Doctor id. */
    id!: string;
    /** Doctor's full name. */
    fullName!: string;
    /** Studies of doctor. */
    studies!: StaffStudyDto[];
    /** User roles */
    roles!: string[];
    /** UserName for login. */
    userName!: string;
    /** Date when user visit an application the last time. */
    lastVisitDate!: Date | null;
    /** User's email [optional] from external logins or from hardcoded users. */
    email!: string | null;
    /** User's timezone in standard string. */
    timeZone!: string;
    /** Describes manually created users, who has not logged in yet. */
    predefinedUser!: boolean;

    constructor(data?: IStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studies = [];
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(StaffStudyDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.userName = _data["userName"];
            this.lastVisitDate = _data["lastVisitDate"] ? new Date(_data["lastVisitDate"].toString()) : <any>null;
            this.email = _data["email"];
            this.timeZone = _data["timeZone"];
            this.predefinedUser = _data["predefinedUser"];
        }
    }

    static fromJS(data: any): StaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["userName"] = this.userName;
        data["lastVisitDate"] = this.lastVisitDate && this.lastVisitDate.toISOString();
        data["email"] = this.email;
        data["timeZone"] = this.timeZone;
        data["predefinedUser"] = this.predefinedUser;
        return data;
    }
}

export interface IStaffDto {
    /** Doctor id. */
    id: string;
    /** Doctor's full name. */
    fullName: string;
    /** Studies of doctor. */
    studies: StaffStudyDto[];
    /** User roles */
    roles: string[];
    /** UserName for login. */
    userName: string;
    /** Date when user visit an application the last time. */
    lastVisitDate: Date | null;
    /** User's email [optional] from external logins or from hardcoded users. */
    email: string | null;
    /** User's timezone in standard string. */
    timeZone: string;
    /** Describes manually created users, who has not logged in yet. */
    predefinedUser: boolean;
}

export class StaffStudyDto implements IStaffStudyDto {
    /** Id of the study */
    id!: number;
    /** Number of the Study. */
    studyNumber!: string;
    /** Short name of the Study. */
    studyTitle!: string;
    /** Set of user roles in the study */
    roles!: StudyRoleDto[];
    /** Tag filters that restrict access to patients in this study */
    tagFilters!: TagFiltersDto | null;

    constructor(data?: IStaffStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyNumber = _data["studyNumber"];
            this.studyTitle = _data["studyTitle"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(StudyRoleDto.fromJS(item));
            }
            this.tagFilters = _data["tagFilters"] ? TagFiltersDto.fromJS(_data["tagFilters"]) : <any>null;
        }
    }

    static fromJS(data: any): StaffStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyNumber"] = this.studyNumber;
        data["studyTitle"] = this.studyTitle;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["tagFilters"] = this.tagFilters ? this.tagFilters.toJSON() : <any>null;
        return data;
    }
}

export interface IStaffStudyDto {
    /** Id of the study */
    id: number;
    /** Number of the Study. */
    studyNumber: string;
    /** Short name of the Study. */
    studyTitle: string;
    /** Set of user roles in the study */
    roles: StudyRoleDto[];
    /** Tag filters that restrict access to patients in this study */
    tagFilters: TagFiltersDto | null;
}

export class CreatePredefinedUserDto implements ICreatePredefinedUserDto {
    /** Email by which we associate login user and create real user assignment. */
    email!: string;
    /** Study where user will be created with study roles. */
    studyWithRoles!: StaffStudyCreationDto[];

    constructor(data?: ICreatePredefinedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyWithRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["studyWithRoles"])) {
                this.studyWithRoles = [] as any;
                for (let item of _data["studyWithRoles"])
                    this.studyWithRoles!.push(StaffStudyCreationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePredefinedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.studyWithRoles)) {
            data["studyWithRoles"] = [];
            for (let item of this.studyWithRoles)
                data["studyWithRoles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePredefinedUserDto {
    /** Email by which we associate login user and create real user assignment. */
    email: string;
    /** Study where user will be created with study roles. */
    studyWithRoles: StaffStudyCreationDto[];
}

export class StaffStudyCreationDto implements IStaffStudyCreationDto {
    /** Id of the study */
    studyId!: number;
    /** Set of user study roles */
    roles!: string[];
    /** Tags for deciding access during one study. */
    tagFilters!: TagFiltersDto | null;

    constructor(data?: IStaffStudyCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.tagFilters = _data["tagFilters"] ? TagFiltersDto.fromJS(_data["tagFilters"]) : <any>null;
        }
    }

    static fromJS(data: any): StaffStudyCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffStudyCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["tagFilters"] = this.tagFilters ? this.tagFilters.toJSON() : <any>null;
        return data;
    }
}

export interface IStaffStudyCreationDto {
    /** Id of the study */
    studyId: number;
    /** Set of user study roles */
    roles: string[];
    /** Tags for deciding access during one study. */
    tagFilters: TagFiltersDto | null;
}

export class PatchUserDto implements IPatchUserDto {
    /** Updates email for not authorized users only. */
    email?: string | null;
    /** Adjust a set of user roles. */
    roles?: string[] | null;
    /** Adjust a set of assigned studies. */
    studyIds?: number[] | null;

    constructor(data?: IPatchUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["studyIds"])) {
                this.studyIds = [] as any;
                for (let item of _data["studyIds"])
                    this.studyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PatchUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.studyIds)) {
            data["studyIds"] = [];
            for (let item of this.studyIds)
                data["studyIds"].push(item);
        }
        return data;
    }
}

export interface IPatchUserDto {
    /** Updates email for not authorized users only. */
    email?: string | null;
    /** Adjust a set of user roles. */
    roles?: string[] | null;
    /** Adjust a set of assigned studies. */
    studyIds?: number[] | null;
}

/** Describe config for maintenance state. At this service is always disabled. This class needs only for type-safe generated models on client-side and have endpoint */
export class MaintenanceDto implements IMaintenanceDto {
    /** Is Maintenance turned on flag. */
    isEnabled!: boolean;
    /** Possible date when maintenance could finish. Date in UTC time zone. */
    plannedFinishDate!: Date | null;

    constructor(data?: IMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.plannedFinishDate = _data["plannedFinishDate"] ? new Date(_data["plannedFinishDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): MaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["plannedFinishDate"] = this.plannedFinishDate && this.plannedFinishDate.toISOString();
        return data;
    }
}

/** Describe config for maintenance state. At this service is always disabled. This class needs only for type-safe generated models on client-side and have endpoint */
export interface IMaintenanceDto {
    /** Is Maintenance turned on flag. */
    isEnabled: boolean;
    /** Possible date when maintenance could finish. Date in UTC time zone. */
    plannedFinishDate: Date | null;
}

/** Describes an object with available and supported mobile application version */
export class SupportedAppVersions implements ISupportedAppVersions {
    /** Minimal supported mobile App version and higher.
All prior versions will be restricted by API (there are some incapability or breaking changes).
User gets blocked app until he/she update the app. */
    minimalSupported!: string;
    /** Currently released version in stores. */
    current!: string;

    constructor(data?: ISupportedAppVersions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimalSupported = _data["minimalSupported"];
            this.current = _data["current"];
        }
    }

    static fromJS(data: any): SupportedAppVersions {
        data = typeof data === 'object' ? data : {};
        let result = new SupportedAppVersions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimalSupported"] = this.minimalSupported;
        data["current"] = this.current;
        return data;
    }
}

/** Describes an object with available and supported mobile application version */
export interface ISupportedAppVersions {
    /** Minimal supported mobile App version and higher.
All prior versions will be restricted by API (there are some incapability or breaking changes).
User gets blocked app until he/she update the app. */
    minimalSupported: string;
    /** Currently released version in stores. */
    current: string;
}

export function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

function parseDateOnly(s: string) {
    const date = new Date(s);
    return new Date(date.getTime() + 
        date.getTimezoneOffset() * 60000);
}
//-----/CustomTypes.File-----

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//-----/Types.File-----

import { addResultTypeFactory } from './api-client/helpers';
export { setBaseUrl, getBaseUrl } from './api-client/helpers';
export { setAxiosFactory, getAxios } from './api-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './api-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('AnalyzesClient___getAllAnalysisPresetsForStudy', (data: any) => { const result = new AnalysisPresetDto(); result.init(data); return result; });
  addResultTypeFactory('AnalyzesClient___getAnalysisPresetById', (data: any) => { const result = new AnalysisPresetDto(); result.init(data); return result; });
  addResultTypeFactory('AnalyzesClient___getAllPatientAnalyzes', (data: any) => { const result = new AnalysisDto(); result.init(data); return result; });
  addResultTypeFactory('AnalyzesClient___getAnalysisById', (data: any) => { const result = new AnalysisDto(); result.init(data); return result; });


  addResultTypeFactory('ConfigurableMonitoringFormsClient___getMonitoringFormConfigs', (data: any) => { const result = new MonitoringFormConfigDto(); result.init(data); return result; });
  addResultTypeFactory('ConfigurableMonitoringFormsClient___getMonitoringFormConfig', (data: any) => { const result = new MonitoringFormConfigDto(); result.init(data); return result; });
  addResultTypeFactory('ConfigurableMonitoringFormsClient___getMonitoringFormResults', (data: any) => { const result = new MonitoringFormResultDto(); result.init(data); return result; });
  addResultTypeFactory('ConfigurableMonitoringFormsClient___getMonitoringFormResultsForList', (data: any) => { const result = new ShortMonitoringFormResultDto(); result.init(data); return result; });
  addResultTypeFactory('ConfigurableMonitoringFormsClient___getMonitoringFormResult', (data: any) => { const result = new MonitoringFormResultDto(); result.init(data); return result; });


  addResultTypeFactory('DeviceDataSummaryClient___getDeviceDataSummary', (data: any) => { const result = new SummaryDto(); result.init(data); return result; });


  addResultTypeFactory('ExportLogClient___getStatisticTypesToExport', (data: any) => { const result = new StatisticTypesDto(); result.init(data); return result; });


  addResultTypeFactory('FaqClient___getById', (data: any) => { const result = new FaqDto(); result.init(data); return result; });




  addResultTypeFactory('FormsClient___getFormById', (data: any) => { const result = new FormDto(); result.init(data); return result; });
  addResultTypeFactory('FormsClient___getFormHistoryById', (data: any) => { const result = new FormHistoryDto(); result.init(data); return result; });
  addResultTypeFactory('FormsClient___getForms', (data: any) => { const result = new FormDto(); result.init(data); return result; });
  addResultTypeFactory('FormsClient___getFormResults', (data: any) => { const result = new PagedResultOfFormResultDto(); result.init(data); return result; });
  addResultTypeFactory('FormsClient___getFormResultDates', (data: any) => { const result = new FormResultDatesDto(); result.init(data); return result; });
  addResultTypeFactory('FormsClient___getFormResultById', (data: any) => { const result = new FormResultDto(); result.init(data); return result; });


  addResultTypeFactory('IssueClient___getIssue', (data: any) => { const result = new IssueDto(); result.init(data); return result; });
  addResultTypeFactory('IssueClient___getIssuesForStudy', (data: any) => { const result = new PagedResultOfIssueDto(); result.init(data); return result; });
  addResultTypeFactory('IssueClient___getIssuesGroupedByPatients', (data: any) => { const result = new PagedResultOfGroupedIssueDto(); result.init(data); return result; });
  addResultTypeFactory('IssueClient___getIssueHistory', (data: any) => { const result = new IssueHistoryDto(); result.init(data); return result; });
  addResultTypeFactory('IssueClient___getIssueComments', (data: any) => { const result = new IssueCommentDto(); result.init(data); return result; });


  addResultTypeFactory('MonitoringFormsClient___getMonitoringForms', (data: any) => { const result = new MonitoringFormDto(); result.init(data); return result; });


  addResultTypeFactory('NotificationClient___getNotifications', (data: any) => { const result = new PagedResultOfNotificationDto(); result.init(data); return result; });
  addResultTypeFactory('NotificationClient___getNotificationBatches', (data: any) => { const result = new NotificationBatchDto(); result.init(data); return result; });
  addResultTypeFactory('NotificationClient___getNotificationCounts', (data: any) => { const result = new NotificationCountsByTypeDto(); result.init(data); return result; });
  addResultTypeFactory('NotificationClient___getPushTokens', (data: any) => { const result = new UserPushTokenDto(); result.init(data); return result; });


  addResultTypeFactory('ParticipantsClient___getParticipants', (data: any) => { const result = new PagedResultOfParticipantDto(); result.init(data); return result; });


  addResultTypeFactory('PatientClient___getPatient', (data: any) => { const result = new PatientListDto(); result.init(data); return result; });
  addResultTypeFactory('PatientClient___getPatientByStudyAndUniqId', (data: any) => { const result = new PatientListDto(); result.init(data); return result; });
  addResultTypeFactory('PatientClient___getPatients', (data: any) => { const result = new PagedResultOfPatientListDto(); result.init(data); return result; });
  addResultTypeFactory('PatientClient___getPatientStudyCounters', (data: any) => { const result = new PatientGroupCountersDto(); result.init(data); return result; });
  addResultTypeFactory('PatientClient___getPatientChangesInfo', (data: any) => { const result = new PatientChangesDetails(); result.init(data); return result; });
  addResultTypeFactory('PatientClient___getPatientDeviceBindings', (data: any) => { const result = new DeviceBindingDto(); result.init(data); return result; });




  addResultTypeFactory('ProfileClient___getDoctorProfileInfo', (data: any) => { const result = new DoctorProfileDto(); result.init(data); return result; });
  addResultTypeFactory('ProfileClient___getPatientProfileInfo', (data: any) => { const result = new PatientDto(); result.init(data); return result; });






  addResultTypeFactory('StudyClient___getAdminStudies', (data: any) => { const result = new PagedResultOfAdminStudyDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getDoctorStudies', (data: any) => { const result = new DoctorStudyListDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getDoctorStudyById', (data: any) => { const result = new DoctorStudyDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getStudyAttachments', (data: any) => { const result = new StudyAttachmentDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getMyStudy', (data: any) => { const result = new PatientStudyDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getMyStudy2', (data: any) => { const result = new PatientStudyDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getRecruitmentProgress', (data: any) => { const result = new StudyRecruitmentProgressDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getPatientsSummary', (data: any) => { const result = new PatientGroupSummaryDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getStudyUserList', (data: any) => { const result = new PagedResultOfStudyStaffDto(); result.init(data); return result; });
  addResultTypeFactory('StudyClient___getStudyStaffPerRole', (data: any) => { const result = new StudyStaffPerRoleDto(); result.init(data); return result; });


  addResultTypeFactory('StudyNotesClient___getStudyNotesConfig', (data: any) => { const result = new StudyNoteConfigDto(); result.init(data); return result; });
  addResultTypeFactory('StudyNotesClient___getStudyNotes', (data: any) => { const result = new StudyNoteResultDto(); result.init(data); return result; });


  addResultTypeFactory('StudyProgressStatisticClient___getStudyProgressStatistic', (data: any) => { const result = new StudyProgressStatisticDto(); result.init(data); return result; });


  addResultTypeFactory('StudyRoutesClient___getAll', (data: any) => { const result = new StudyRouteDto(); result.init(data); return result; });
  addResultTypeFactory('StudyRoutesClient___getStudyRouteById', (data: any) => { const result = new StudyRouteDto(); result.init(data); return result; });
  addResultTypeFactory('StudyRoutesClient___getPatientRouteProgress', (data: any) => { const result = new RouteProgressDto(); result.init(data); return result; });


  addResultTypeFactory('SurveyClient___getSurveys', (data: any) => { const result = new SurveyDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getAnswersStatistic', (data: any) => { const result = new AnswersStatisticsDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getAnswerStatistic', (data: any) => { const result = new AnswersStatisticsDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getAnswers', (data: any) => { const result = new AnswerDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getQuestionnaires', (data: any) => { const result = new QuestionnaireDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getPredictedQuestionnaires', (data: any) => { const result = new PredictedQuestionnaireDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getSurveyRecordsForPatient', (data: any) => { const result = new AnswerDto(); result.init(data); return result; });
  addResultTypeFactory('SurveyClient___getSurveyRulesByStudy', (data: any) => { const result = new SurveyRuleDto(); result.init(data); return result; });


  addResultTypeFactory('TestClient___getQuestionnaire', (data: any) => { const result = new QuestionnaireDto(); result.init(data); return result; });
  addResultTypeFactory('TestClient___getSurveysForDoctor', (data: any) => { const result = new SurveyDto(); result.init(data); return result; });
  addResultTypeFactory('TestClient___getSurveyRulesForDoctor', (data: any) => { const result = new SurveyRuleDto(); result.init(data); return result; });
  addResultTypeFactory('TestClient___getPatientInfoByUniqueId', (data: any) => { const result = new PatientDto(); result.init(data); return result; });


  addResultTypeFactory('UserRolesClient___getGeneralRoles', (data: any) => { const result = new RoleDto(); result.init(data); return result; });
  addResultTypeFactory('UserRolesClient___getStudyRoles', (data: any) => { const result = new StudyRoleDto(); result.init(data); return result; });


  addResultTypeFactory('UsersClient___getAllUsers', (data: any) => { const result = new PagedResultOfStaffDto(); result.init(data); return result; });


  addResultTypeFactory('VersionClient___maintenance', (data: any) => { const result = new MaintenanceDto(); result.init(data); return result; });
  addResultTypeFactory('VersionClient___appVersion', (data: any) => { const result = new SupportedAppVersions(); result.init(data); return result; });


}
//-----/PersistorHydrator.File----